function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInmersial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2049,
    height: 2049,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "none"
    },
    d: "M0 0L0 2049L2049 2049L2049 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M634 694C639.951 696.497 648.58 695 655 695L701 695L861 695L1416 695C1410.05 692.503 1401.42 694 1395 694L1349 694L1189 694L634 694M615 695C616.506 695.683 617.315 695.826 619 696C617.494 695.317 616.685 695.174 615 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M619 695C620.506 695.683 621.315 695.826 623 696C621.494 695.317 620.685 695.174 619 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M623 695C624.506 695.683 625.315 695.826 627 696C625.494 695.317 624.685 695.174 623 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#092c74",
      stroke: "none"
    },
    d: "M729 1457C688.274 1457 646.443 1459.75 606 1454.72C548.084 1447.51 493.097 1423.61 447 1388.11C418.442 1366.12 393.35 1338.99 373.355 1309C308.055 1211.05 300.028 1079.05 356.309 975C381.232 928.923 416.353 888.905 459 858.427C501.159 828.299 551.621 808.204 603 801.282C628.639 797.828 654.166 798 680 798L765 798L1274 798L1369 798C1399.92 798 1430.46 797.906 1461 803.424C1507.12 811.758 1551.69 830.829 1590 857.721C1621.79 880.036 1649.96 908.211 1672.28 940C1740.59 1037.3 1750.36 1167.67 1697.19 1274C1674.06 1320.27 1639.32 1361.11 1598 1392.1C1553.36 1425.59 1499.43 1447.82 1444 1454.72C1401.62 1459.99 1357.68 1457 1315 1457C1322.56 1467.74 1333.72 1476.72 1343 1486C1358.18 1501.18 1372.84 1516.84 1388 1532L1407 1551C1409.94 1553.93 1412.99 1557.92 1417 1559.4C1422.55 1561.44 1429.33 1559.3 1435 1559.04C1453.48 1558.2 1471.87 1555.23 1490 1551.6C1566.93 1536.19 1642.67 1497.93 1699 1442.99C1735.6 1407.28 1766.83 1366.85 1789.75 1321C1844.08 1212.35 1849.66 1080.77 1804.55 968C1750.38 832.56 1627.28 728.447 1483 702.424C1441.07 694.863 1399.45 695 1357 695L1228 695L877 695L713 695C676.362 695 639.461 693.639 603 697.17C556.133 701.708 509.754 714.677 467 734.309C340.61 792.343 248.049 911.429 222.46 1048C193.297 1203.64 253.969 1367.37 378 1466.2C432.388 1509.54 499.856 1542.6 569 1553.27C583.576 1555.53 598.231 1558.47 613 1559.01C617.443 1559.17 622.679 1560.98 627 1559.4C631.384 1557.79 634.791 1553.21 638 1550L657 1531C674.855 1513.15 692.886 1495.47 710.089 1477C716.308 1470.32 723.735 1464.47 729 1457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1423 695C1424.51 695.683 1425.31 695.826 1427 696C1425.49 695.317 1424.69 695.174 1423 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1427 695C1428.51 695.683 1429.31 695.826 1431 696C1429.49 695.317 1428.69 695.174 1427 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1431 695C1432.51 695.683 1433.31 695.826 1435 696C1433.49 695.317 1432.69 695.174 1431 695M604 696C605.248 696.685 605.548 696.749 607 697C605.752 696.315 605.452 696.251 604 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M607.667 696.333C607.222 696.778 608.278 696.722 608.333 696.667C608.778 696.222 607.722 696.278 607.667 696.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M609 696C610.248 696.685 610.548 696.749 612 697C610.752 696.315 610.452 696.251 609 696M1438 696C1439.25 696.685 1439.55 696.749 1441 697C1439.75 696.315 1439.45 696.251 1438 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1441 696C1442.25 696.685 1442.55 696.749 1444 697C1442.75 696.315 1442.45 696.251 1441 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1444.67 696.333C1444.22 696.778 1445.28 696.722 1445.33 696.667C1445.78 696.223 1444.72 696.278 1444.67 696.333M595.667 697.333C595.222 697.778 596.278 697.722 596.333 697.667C596.777 697.223 595.722 697.278 595.667 697.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M597.667 697.333C597.222 697.778 598.278 697.722 598.333 697.667C598.778 697.222 597.722 697.278 597.667 697.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M599.667 697.333C599.222 697.778 600.278 697.722 600.333 697.667C600.778 697.223 599.722 697.278 599.667 697.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1449.67 697.333C1449.22 697.777 1450.28 697.722 1450.33 697.667C1450.78 697.222 1449.72 697.278 1449.67 697.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1451.67 697.333C1451.22 697.777 1452.28 697.722 1452.33 697.667C1452.78 697.223 1451.72 697.277 1451.67 697.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1453.67 697.333C1453.22 697.778 1454.28 697.722 1454.33 697.667C1454.78 697.223 1453.72 697.278 1453.67 697.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M588 698C589.248 698.685 589.549 698.749 591 699C589.752 698.315 589.452 698.251 588 698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M591.667 698.333C591.222 698.778 592.278 698.722 592.333 698.667C592.777 698.223 591.722 698.278 591.667 698.333M1457.67 698.333C1457.22 698.778 1458.28 698.722 1458.33 698.667C1458.78 698.222 1457.72 698.278 1457.67 698.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1459.67 698.333C1459.22 698.778 1460.28 698.722 1460.33 698.667C1460.78 698.222 1459.72 698.278 1459.67 698.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d7e5",
      stroke: "none"
    },
    d: "M1461.67 698.333C1461.22 698.778 1462.28 698.722 1462.33 698.667C1462.78 698.222 1461.72 698.278 1461.67 698.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M581 699C582.248 699.685 582.548 699.749 584 700C582.751 699.315 582.452 699.251 581 699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37548e",
      stroke: "none"
    },
    d: "M584.667 699.333C584.222 699.778 585.278 699.722 585.333 699.667C585.777 699.223 584.722 699.278 584.667 699.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1465 699C1466.25 699.685 1466.55 699.749 1468 700C1466.75 699.315 1466.45 699.251 1465 699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e5ee",
      stroke: "none"
    },
    d: "M1468.67 699.333C1468.22 699.778 1469.28 699.722 1469.33 699.667C1469.78 699.222 1468.72 699.278 1468.67 699.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M575 700L576 701L575 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M576 700C577.248 700.685 577.548 700.749 579 701C577.752 700.315 577.452 700.251 576 700M1471 700C1472.25 700.685 1472.55 700.749 1474 701C1472.75 700.315 1472.45 700.251 1471 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e5ee",
      stroke: "none"
    },
    d: "M1474.67 700.333C1474.22 700.778 1475.28 700.722 1475.33 700.667C1475.78 700.223 1474.72 700.278 1474.67 700.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M569 701C570.248 701.685 570.548 701.749 572 702C570.752 701.315 570.452 701.251 569 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1477 701C1478.25 701.685 1478.55 701.749 1480 702C1478.75 701.315 1478.45 701.251 1477 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M564 702L565 703L564 702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M565 702C566.248 702.685 566.548 702.749 568 703C566.751 702.315 566.452 702.251 565 702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1483.67 702.333C1483.22 702.778 1484.28 702.722 1484.33 702.667C1484.78 702.222 1483.72 702.278 1483.67 702.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M559 703L560 704L559 703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M560.667 703.333C560.222 703.778 561.278 703.722 561.333 703.667C561.778 703.222 560.722 703.278 560.667 703.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1488.67 703.333C1488.22 703.778 1489.28 703.722 1489.33 703.667C1489.78 703.222 1488.72 703.278 1488.67 703.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M555 704C556.248 704.685 556.548 704.749 558 705C556.752 704.315 556.451 704.251 555 704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1493 704C1494.25 704.685 1494.55 704.749 1496 705C1494.75 704.315 1494.45 704.251 1493 704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M550 705L551 706L550 705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M551 705L552 706L551 705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M552 705L553 706L552 705M1497 705L1498 706L1497 705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1498.67 705.333C1498.22 705.778 1499.28 705.722 1499.33 705.667C1499.78 705.222 1498.72 705.278 1498.67 705.333M546 706L547 707L546 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M547 706L548 707L547 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1501.67 706.333C1501.22 706.778 1502.28 706.722 1502.33 706.667C1502.78 706.223 1501.72 706.278 1501.67 706.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1503 706L1504 707L1503 706M542 707L543 708L542 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M543 707L544 708L543 707M1506 707L1507 708L1506 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1507 707L1508 708L1507 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M538 708L539 709L538 708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M539 708L540 709L539 708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1510 708L1511 709L1510 708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1511 708L1512 709L1511 708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M534 709L535 710L534 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M535 709L536 710L535 709M1514 709L1515 710L1514 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1515 709L1516 710L1515 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M531 710L532 711L531 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M532 710L533 711L532 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1517 710L1518 711L1517 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1518 710L1519 711L1518 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M527 711L528 712L527 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M528 711L529 712L528 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1521 711L1522 712L1521 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1522 711L1523 712L1522 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M524 712L525 713L524 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M525 712L526 713L525 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1524 712L1525 713L1524 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1525 712L1526 713L1525 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M521 713L522 714L521 713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1528 713L1529 714L1528 713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M517 714L518 715L517 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M518 714L519 715L518 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1531 714L1532 715L1531 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1532 714L1533 715L1532 714M514 715L515 716L514 715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M515 715L516 716L515 715M1534 715L1535 716L1534 715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1535 715L1536 716L1535 715M511 716L512 717L511 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M512 716L513 717L512 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1537 716L1538 717L1537 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1538 716L1539 717L1538 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M508 717L509 718L508 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M509 717L510 718L509 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1540 717L1541 718L1540 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1541 717L1542 718L1541 717M505 718L506 719L505 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M506 718L507 719L506 718M1543 718L1544 719L1543 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1544 718L1545 719L1544 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M503 719L504 720L503 719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1546 719L1547 720L1546 719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M500 720L501 721L500 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1549 720L1550 721L1549 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M497 721L498 722L497 721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M498 721L499 722L498 721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1552 721L1553 722L1552 721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M494 722L495 723L494 722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M495 722L496 723L495 722M1554 722L1555 723L1554 722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1555 722L1556 723L1555 722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M492 723L493 724L492 723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1557 723L1558 724L1557 723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M489 724L490 725L489 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M490 724L491 725L490 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1559 724L1560 725L1559 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1560 724L1561 725L1560 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M487 725L488 726L487 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1562 725L1563 726L1562 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M484 726L485 727L484 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M485 726L486 727L485 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1564 726L1565 727L1564 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1565 726L1566 727L1565 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M482 727L483 728L482 727M1567 727L1568 728L1567 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M480 728L481 729L480 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1569 728L1570 729L1569 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1570 728L1571 729L1570 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M477 729L478 730L477 729M1572 729L1573 730L1572 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M475 730L476 731L475 730M1574 730L1575 731L1574 730z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M473 731L474 732L473 731M1576 731L1577 732L1576 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1577 731L1578 732L1577 731M470 732L471 733L470 732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M471 732L472 733L471 732M1578 732L1579 733L1578 732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1579 732L1580 733L1579 732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M468 733L469 734L468 733M1581 733L1582 734L1581 733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M466 734L467 735L466 734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1583 734L1584 735L1583 734M464 735L465 736L464 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1585 735L1586 736L1585 735M462 736L463 737L462 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1587 736L1588 737L1587 736M460 737L461 738L460 737M1589 737L1590 738L1589 737M458 738L459 739L458 738M1591 738L1592 739L1591 738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1592 738L1593 739L1592 738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M456 739L457 740L456 739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1593 739L1594 740L1593 739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1594 739L1595 740L1594 739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M454 740L455 741L454 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1595 740L1596 741L1595 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1596 740L1597 741L1596 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M452 741L453 742L452 741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1597 741L1598 742L1597 741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M450 742L451 743L450 742M1599 742L1600 743L1599 742M448 743L449 744L448 743M1601 743L1602 744L1601 743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M446 744L447 745L446 744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1603 744L1604 745L1603 744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M444 745L445 746L444 745M1605 745L1606 746L1605 745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M442 746L443 747L442 746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1607 746L1608 747L1607 746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M440 747L441 748L440 747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1609 747L1610 748L1609 747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M439 748L440 749L439 748M1610 748L1611 749L1610 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1611 748L1612 749L1611 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M437 749L438 750L437 749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1612 749L1613 750L1612 749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M435 750L436 751L435 750z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1614 750L1615 751L1614 750z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M433 751L434 752L433 751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1616 751L1617 752L1616 751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M431 752L432 753L431 752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M432 752L433 753L432 752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1618 752L1619 753L1618 752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M430 753L431 754L430 753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1619 753L1620 754L1619 753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M428 754L429 755L428 754M1621 754L1622 755L1621 754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M426 755L427 756L426 755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1623 755L1624 756L1623 755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M425 756L426 757L425 756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1624 756L1625 757L1624 756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M423 757L424 758L423 757M1626 757L1627 758L1626 757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M421 758L422 759L421 758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1628 758L1629 759L1628 758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M420 759L421 760L420 759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1629 759L1630 760L1629 759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M418 760L419 761L418 760z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1631 760L1632 761L1631 760z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M417 761L418 762L417 761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M415 762L416 763L415 762M1634 762L1635 763L1634 762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1636 763L1637 764L1636 763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M412 764L413 765L412 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1637 764L1638 765L1637 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M410 765L411 766L410 765M1639 765L1640 766L1639 765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M409 766L410 767L409 766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1640 766L1641 767L1640 766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M407 767L408 768L407 767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1642 767L1643 768L1642 767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M406 768L407 769L406 768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1643 768L1644 769L1643 768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1645 769L1646 770L1645 769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M403 770L404 771L403 770z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1646 770L1647 771L1646 770z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M400 772L401 773L400 772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1649 772L1650 773L1649 772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M399 773L400 774L399 773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M397 774L398 775L397 774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1652 774L1653 775L1652 774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M396 775L397 776L396 775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1653 775L1654 776L1653 775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1655 776L1656 777L1655 776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M393 777L394 778L393 777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1656 777L1657 778L1656 777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M392 778L393 779L392 778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1657 778L1658 779L1657 778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M390 779L391 780L390 779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1659 779L1660 780L1659 779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M389 780L390 781L389 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1660 780L1661 781L1660 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M388 781L389 782L388 781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M386 782L387 783L386 782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1663 782L1664 783L1663 782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M385 783L386 784L385 783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1664 783L1665 784L1664 783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M384 784L385 785L384 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1665 784L1666 785L1665 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1667 785L1668 786L1667 785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M381 786L382 787L381 786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1668 786L1669 787L1668 786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M380 787L381 788L380 787M1669 787L1670 788L1669 787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1672 789L1673 790L1672 789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M376 790L377 791L376 790z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1673 790L1674 791L1673 790z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M375 791L376 792L375 791M1674 791L1675 792L1674 791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M374 792L375 793L374 792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M371 794L372 795L371 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1678 794L1679 795L1678 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M370 795L371 796L370 795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1679 795L1680 796L1679 795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M369 796L370 797L369 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1680 796L1681 797L1680 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M632 798C634.332 798.984 636.457 798.981 639 799C636.668 798.016 634.543 798.019 632 798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M639 798C644.951 800.497 653.58 799 660 799L706 799L864 799L1412 799C1406.05 796.503 1397.42 798 1391 798L1345 798L1187 798L639 798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1412 798C1414.05 798.874 1415.75 798.953 1418 799C1415.95 798.126 1414.25 798.047 1412 798M618 799C619.249 799.685 619.548 799.749 621 800C619.752 799.315 619.452 799.251 618 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M621 799C622.248 799.685 622.548 799.749 624 800C622.752 799.315 622.451 799.251 621 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M624 799C625.248 799.685 625.548 799.749 627 800C625.752 799.315 625.452 799.251 624 799M1423 799C1424.25 799.685 1424.55 799.749 1426 800C1424.75 799.315 1424.45 799.251 1423 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1426 799C1427.25 799.685 1427.55 799.749 1429 800C1427.75 799.315 1427.45 799.251 1426 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1429 799C1430.25 799.685 1430.55 799.749 1432 800C1430.75 799.315 1430.45 799.251 1429 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1684 799L1685 800L1684 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M364 800L365 801L364 800z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M609.667 800.333C609.222 800.778 610.278 800.722 610.333 800.667C610.777 800.223 609.722 800.278 609.667 800.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M611.667 800.333C611.222 800.778 612.278 800.722 612.333 800.667C612.777 800.223 611.722 800.278 611.667 800.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M613.667 800.333C613.222 800.778 614.278 800.722 614.333 800.667C614.778 800.223 613.722 800.278 613.667 800.333M1435.67 800.333C1435.22 800.778 1436.28 800.722 1436.33 800.667C1436.78 800.222 1435.72 800.278 1435.67 800.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1437.67 800.333C1437.22 800.778 1438.28 800.722 1438.33 800.667C1438.78 800.222 1437.72 800.278 1437.67 800.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1439 800C1440.25 800.685 1440.55 800.749 1442 801C1440.75 800.315 1440.45 800.251 1439 800z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1685 800L1686 801L1685 800z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M363 801L364 802L363 801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M601.667 801.333C601.222 801.778 602.278 801.722 602.333 801.667C602.778 801.222 601.722 801.278 601.667 801.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M603 801C604.248 801.685 604.549 801.749 606 802C604.751 801.315 604.452 801.251 603 801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1444.67 801.333C1444.22 801.778 1445.28 801.722 1445.33 801.667C1445.78 801.222 1444.72 801.278 1444.67 801.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1446 801C1447.25 801.685 1447.55 801.749 1449 802C1447.75 801.315 1447.45 801.251 1446 801M1686 801L1687 802L1686 801M362 802L363 803L362 802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M595 802L596 803L595 802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M596 802C597.248 802.685 597.548 802.749 599 803C597.752 802.315 597.452 802.251 596 802M1451 802C1452.25 802.685 1452.55 802.749 1454 803C1452.75 802.315 1452.45 802.251 1451 802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37548e",
      stroke: "none"
    },
    d: "M1454.67 802.333C1454.22 802.777 1455.28 802.722 1455.33 802.667C1455.78 802.222 1454.72 802.278 1454.67 802.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1687 802L1688 803L1687 802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M361 803L362 804L361 803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M589 803L590 804L589 803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M590 803C591.248 803.685 591.548 803.749 593 804C591.752 803.315 591.452 803.251 590 803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1457 803C1458.25 803.685 1458.55 803.749 1460 804C1458.75 803.315 1458.45 803.251 1457 803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284685",
      stroke: "none"
    },
    d: "M1460.67 803.333C1460.22 803.778 1461.28 803.722 1461.33 803.667C1461.78 803.222 1460.72 803.278 1460.67 803.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M584.667 804.333C584.222 804.778 585.278 804.722 585.333 804.667C585.778 804.223 584.722 804.278 584.667 804.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1463 804L1464 805L1463 804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1464 804C1465.25 804.685 1465.55 804.749 1467 805C1465.75 804.315 1465.45 804.251 1464 804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M579.667 805.333C579.222 805.778 580.278 805.722 580.333 805.667C580.777 805.223 579.722 805.278 579.667 805.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1468 805L1469 806L1468 805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1469.67 805.333C1469.22 805.777 1470.28 805.722 1470.33 805.667C1470.78 805.222 1469.72 805.278 1469.67 805.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M575.667 806.333C575.222 806.778 576.278 806.722 576.333 806.667C576.778 806.222 575.722 806.278 575.667 806.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1473 806L1474 807L1473 806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1474.67 806.333C1474.22 806.778 1475.28 806.722 1475.33 806.667C1475.78 806.222 1474.72 806.278 1474.67 806.333M570 807L571 808L570 807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M571 807L572 808L571 807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M572 807L573 808L572 807M1477 807L1478 808L1477 807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1478 807L1479 808L1478 807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1693 807L1694 808L1693 807M355 808L356 809L355 808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M566 808L567 809L566 808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M567 808L568 809L567 808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M568 808L569 809L568 808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1482 808L1483 809L1482 808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1483 808L1484 809L1483 808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1694 808L1695 809L1694 808M354 809L355 810L354 809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M563 809L564 810L563 809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M564 809L565 810L564 809M1485 809L1486 810L1485 809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1486 809L1487 810L1486 809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1487 809L1488 810L1487 809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1695 809L1696 810L1695 809M353 810L354 811L353 810z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M559 810L560 811L559 810z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M560 810L561 811L560 810M1489 810L1490 811L1489 810z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1490 810L1491 811L1490 810z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1696 810L1697 811L1696 810M352 811L353 812L352 811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M555 811L556 812L555 811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M556 811L557 812L556 811M1493 811L1494 812L1493 811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1494 811L1495 812L1494 811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1697 811L1698 812L1697 811M351 812L352 813L351 812M552 812L553 813L552 812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M553 812L554 813L553 812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1496 812L1497 813L1496 812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1497 812L1498 813L1497 812M1698 812L1699 813L1698 812M350 813L351 814L350 813M549 813L550 814L549 813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M550 813L551 814L550 813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1500 813L1501 814L1500 813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1699 813L1700 814L1699 813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M349 814L350 815L349 814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M546 814L547 815L546 814M1503 814L1504 815L1503 814M543 815L544 816L543 815M1506 815L1507 816L1506 815M540 816L541 817L540 816M1509 816L1510 817L1509 816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M537 817L538 818L537 817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M538 817L539 818L538 817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1512 817L1513 818L1512 817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M534 818L535 819L534 818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M535 818L536 819L535 818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1514 818L1515 819L1514 818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1515 818L1516 819L1515 818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M532 819L533 820L532 819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1517 819L1518 820L1517 819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M529 820L530 821L529 820z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1520 820L1521 821L1520 820z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M527 821L528 822L527 821M1522 821L1523 822L1522 821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1523 821L1524 822L1523 821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M524 822L525 823L524 822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1525 822L1526 823L1525 822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M522 823L523 824L522 823M1527 823L1528 824L1527 823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1528 823L1529 824L1528 823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M519 824L520 825L519 824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M520 824L521 825L520 824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1530 824L1531 825L1530 824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M517 825L518 826L517 825M1532 825L1533 826L1532 825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M515 826L516 827L515 826M1534 826L1535 827L1534 826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M512 827L513 828L512 827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M513 827L514 828L513 827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1536 827L1537 828L1536 827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1537 827L1538 828L1537 827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M510 828L511 829L510 828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M511 828L512 829L511 828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1539 828L1540 829L1539 828M334 829L335 830L334 829M508 829L509 830L508 829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1541 829L1542 830L1541 829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M333 830L334 831L333 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M506 830L507 831L506 830M1543 830L1544 831L1543 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1716 830L1717 831L1716 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M332 831L333 832L332 831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M504 831L505 832L504 831M1545 831L1546 832L1545 831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1717 831L1718 832L1717 831M331 832L332 833L331 832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M502 832L503 833L502 832M1547 832L1548 833L1547 832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1718 832L1719 833L1718 832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M330 833L331 834L330 833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M500 833L501 834L500 833M1549 833L1550 834L1549 833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1719 833L1720 834L1719 833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M329 834L330 835L329 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M498 834L499 835L498 834M1551 834L1552 835L1551 834M1720 834L1721 835L1720 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M328 835L329 836L328 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M496 835L497 836L496 835M1553 835L1554 836L1553 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1721 835L1722 836L1721 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M327 836L328 837L327 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M494 836L495 837L494 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1555 836L1556 837L1555 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1722 836L1723 837L1722 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M492 837L493 838L492 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1557 837L1558 838L1557 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M490 838L491 839L490 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M491 838L492 839L491 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1559 838L1560 839L1559 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M489 839L490 840L489 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1560 839L1561 840L1560 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1561 839L1562 840L1561 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M487 840L488 841L487 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1562 840L1563 841L1562 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M323 841L324 842L323 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M485 841L486 842L485 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1564 841L1565 842L1564 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M322 842L323 843L322 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M483 842L484 843L483 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1566 842L1567 843L1566 842M1727 842L1728 843L1727 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M321 843L322 844L321 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M482 843L483 844L482 843M1567 843L1568 844L1567 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1728 843L1729 844L1728 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M320 844L321 845L320 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M480 844L481 845L480 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1569 844L1570 845L1569 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1729 844L1730 845L1729 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M478 845L479 846L478 845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1571 845L1572 846L1571 845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1730 845L1731 846L1730 845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M477 846L478 847L477 846M1572 846L1573 847L1572 846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M475 847L476 848L475 847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1574 847L1575 848L1574 847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M317 848L318 849L317 848M473 848L474 849L473 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1576 848L1577 849L1576 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M316 849L317 850L316 849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M472 849L473 850L472 849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1577 849L1578 850L1577 849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1733 849L1734 850L1733 849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M315 850L316 851L315 850z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M470 850L471 851L470 850z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1579 850L1580 851L1579 850M1734 850L1735 851L1734 850z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M314 851L315 852L314 851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M469 851L470 852L469 851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1580 851L1581 852L1580 851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1735 851L1736 852L1735 851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M467 852L468 853L467 852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1582 852L1583 853L1582 852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M466 853L467 854L466 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M312 854L313 855L312 854M464 854L465 855L464 854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1585 854L1586 855L1585 854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M311 855L312 856L311 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M463 855L464 856L463 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1586 855L1587 856L1586 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1738 855L1739 856L1738 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M310 856L311 857L310 856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M461 856L462 857L461 856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1588 856L1589 857L1588 856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1739 856L1740 857L1739 856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M460 857L461 858L460 857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1589 857L1590 858L1589 857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1740 857L1741 858L1740 857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M458 858L459 859L458 858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1591 858L1592 859L1591 858M308 859L309 860L308 859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M457 859L458 860L457 859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1592 859L1593 860L1592 859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M307 860L308 861L307 860z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1742 860L1743 861L1742 860z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M306 861L307 862L306 861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M454 861L455 862L454 861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1595 861L1596 862L1595 861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1743 861L1744 862L1743 861M453 862L454 863L453 862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1596 862L1597 863L1596 862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M304 864L305 865L304 864M450 864L451 865L450 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1599 864L1600 865L1599 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1745 864L1746 865L1745 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M303 865L304 866L303 865M449 865L450 866L449 865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1600 865L1601 866L1600 865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1746 865L1747 866L1746 865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1747 866L1748 867L1747 866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M446 867L447 868L446 867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1603 867L1604 868L1603 867M301 868L302 869L301 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M445 868L446 869L445 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1604 868L1605 869L1604 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1748 868L1749 869L1748 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M300 869L301 870L300 869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M444 869L445 870L444 869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1749 869L1750 870L1749 869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1607 870L1608 871L1607 870z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1750 870L1751 871L1750 870z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M441 871L442 872L441 871M1608 871L1609 872L1608 871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M298 872L299 873L298 872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M440 872L441 873L440 872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1609 872L1610 873L1609 872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1751 872L1752 873L1751 872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M297 873L298 874L297 873M439 873L440 874L439 873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1752 873L1753 874L1752 873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M296 875L297 876L296 875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1613 875L1614 876L1613 875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M295 876L296 877L295 876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M435 876L436 877L435 876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1614 876L1615 877L1614 876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1754 876L1755 877L1754 876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M434 877L435 878L434 877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1615 877L1616 878L1615 877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1755 877L1756 878L1755 877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M433 878L434 879L433 878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1616 878L1617 879L1616 878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M293 879L294 880L293 879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1756 879L1757 880L1756 879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M292 880L293 881L292 880z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1757 880L1758 881L1757 880z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M291 882L292 883L291 882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M428 882L429 883L428 882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1621 882L1622 883L1621 882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M290 883L291 884L290 883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M427 883L428 884L427 883M1622 883L1623 884L1622 883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1759 883L1760 884L1759 883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M426 884L427 885L426 884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1623 884L1624 885L1623 884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1760 884L1761 885L1760 884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M289 885L290 886L289 885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M425 885L426 886L425 885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1624 885L1625 886L1624 885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M288 886L289 887L288 886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M424 886L425 887L424 886M1625 886L1626 887L1625 886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1761 886L1762 887L1761 886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M423 887L424 888L423 887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1626 887L1627 888L1626 887M1762 887L1763 888L1762 887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M287 888L288 889L287 888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M422 888L423 889L422 888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M286 889L287 890L286 889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1763 889L1764 890L1763 889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1764 890L1765 891L1764 890z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M285 891L286 892L285 891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M284 892L285 893L284 892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1765 892L1766 893L1765 892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M283 894L284 895L283 894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M282 895L283 896L282 895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1767 895L1768 896L1767 895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M281 897L282 898L281 897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1768 897L1769 898L1768 897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M280 898L281 899L280 898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1769 898L1770 899L1769 898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M279 900L280 901L279 900z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1770 900L1771 901L1770 900z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1771 901L1772 902L1771 901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M278 902L279 903L278 902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M408 902L409 903L408 902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M277 903L278 904L277 903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M407 903L408 904L407 903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1772 903L1773 904L1772 903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M406 904L407 905L406 904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1643 904L1644 905L1643 904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M276 905L277 906L276 905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M405 905L406 906L405 905M1644 905L1645 906L1644 905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1773 905L1774 906L1773 905M404 906L405 907L404 906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1645 906L1646 907L1645 906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1774 906L1775 907L1774 906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M275 907L276 908L275 907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M403 907L404 908L403 907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1646 907L1647 908L1646 907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M274 908L275 909L274 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M402 908L403 909L402 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1647 908L1648 909L1647 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1775 908L1776 909L1775 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1648 909L1649 910L1648 909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M273 910L274 911L273 910z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1776 910L1777 911L1776 910z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M272 912L273 913L272 912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1777 912L1778 913L1777 912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M398 913L399 914L398 913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1651 913L1652 914L1651 913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1778 913L1779 914L1778 913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M271 914L272 915L271 914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M397 914L398 915L397 914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1652 914L1653 915L1652 914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M270 915L271 916L270 915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M396 915L397 916L396 915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1653 915L1654 916L1653 915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1779 915L1780 916L1779 915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1654 916L1655 917L1654 916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M269 917L270 918L269 917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1780 917L1781 918L1780 917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M268 919L269 920L268 919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M393 919L394 920L393 919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1781 919L1782 920L1781 919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M392 920L393 921L392 920z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1657 920L1658 921L1657 920z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1782 920L1783 921L1782 920z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M267 921L268 922L267 921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M391 921L392 922L391 921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1658 921L1659 922L1658 921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1782 921L1783 922L1782 921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1783 922L1784 923L1783 922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M266 923L267 924L266 923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M639 923C644.951 925.497 653.58 924 660 924L706 924L864 924L1414 924C1408.05 921.503 1399.42 923 1393 923L1347 923L1189 923L639 923M265 924L266 925L265 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M389 924L390 925L389 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cbdd",
      stroke: "none"
    },
    d: "M626 924C627.248 924.685 627.548 924.749 629 925C627.751 924.315 627.452 924.251 626 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M629 924C630.248 924.685 630.549 924.749 632 925C630.751 924.315 630.452 924.251 629 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M632 924C633.248 924.685 633.549 924.749 635 925C633.751 924.315 633.452 924.251 632 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#092d75",
      stroke: "none"
    },
    d: "M635 924C640.951 926.497 649.58 925 656 925L702 925L863 925L1418 925C1412.05 922.503 1403.42 924 1397 924L1351 924L1190 924L635 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1418 924C1419.25 924.685 1419.55 924.749 1421 925C1419.75 924.315 1419.45 924.251 1418 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1421 924C1422.25 924.685 1422.55 924.749 1424 925C1422.75 924.315 1422.45 924.251 1421 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cbdd",
      stroke: "none"
    },
    d: "M1424 924C1425.25 924.685 1425.55 924.749 1427 925C1425.75 924.315 1425.45 924.251 1424 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1784 924L1785 925L1784 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M265 925L266 926L265 925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M388 925L389 926L388 925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cbdd",
      stroke: "none"
    },
    d: "M618.667 925.333C618.222 925.778 619.278 925.722 619.333 925.667C619.778 925.222 618.722 925.278 618.667 925.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8597bb",
      stroke: "none"
    },
    d: "M620.667 925.333C620.222 925.778 621.278 925.722 621.333 925.667C621.778 925.222 620.722 925.278 620.667 925.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476298",
      stroke: "none"
    },
    d: "M622.667 925.333C622.222 925.778 623.278 925.722 623.333 925.667C623.778 925.222 622.722 925.278 622.667 925.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b2f76",
      stroke: "none"
    },
    d: "M617 926C623.194 928.599 632.314 927 639 927L687 927L855 927L1436 927C1429.6 924.246 1420.87 926 1414 926L1366 926L1199 926L811 926C746.372 926 681.592 924.845 617 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2e76",
      stroke: "none"
    },
    d: "M625 925C631.194 927.599 640.314 926 647 926L694 926L858 926L1428 926C1421.81 923.401 1412.69 925 1406 925L1359 925L1195 925L625 925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#576fa1",
      stroke: "none"
    },
    d: "M1429.67 925.333C1429.22 925.778 1430.28 925.722 1430.33 925.667C1430.78 925.223 1429.72 925.278 1429.67 925.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b1cc",
      stroke: "none"
    },
    d: "M1431 925C1432.25 925.685 1432.55 925.749 1434 926C1432.75 925.315 1432.45 925.251 1431 925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1661 925L1662 926L1661 925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M264 926L265 927L264 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cbdd",
      stroke: "none"
    },
    d: "M613 926L614 927L613 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#677daa",
      stroke: "none"
    },
    d: "M614 926C615.248 926.685 615.548 926.749 617 927C615.752 926.315 615.452 926.251 614 926M1436 926C1437.25 926.685 1437.55 926.749 1439 927C1437.75 926.315 1437.45 926.251 1436 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e1e5ee",
      stroke: "none"
    },
    d: "M1439.67 926.333C1439.22 926.778 1440.28 926.722 1440.33 926.667C1440.78 926.222 1439.72 926.278 1439.67 926.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1662 926L1663 927L1662 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1785 926L1786 927L1785 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4b1cc",
      stroke: "none"
    },
    d: "M607 927C608.248 927.685 608.548 927.749 610 928C608.752 927.315 608.452 927.251 607 927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#486399",
      stroke: "none"
    },
    d: "M610 927L611 928L610 927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b2f77",
      stroke: "none"
    },
    d: "M611 927C617.194 929.599 626.314 928 633 928L682 928L852 928L1441 928C1434.81 925.401 1425.69 927 1419 927L1370 927L1200 927L611 927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c3078",
      stroke: "none"
    },
    d: "M606 928C612.436 930.701 622.049 929 629 929L678 929L850 929L1446 929C1440.51 926.242 1432.09 928 1426 928L1379 928L1211 928L606 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#768ab3",
      stroke: "none"
    },
    d: "M1442.67 927.333C1442.22 927.777 1443.28 927.722 1443.33 927.667C1443.78 927.222 1442.72 927.277 1442.67 927.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d8e6",
      stroke: "none"
    },
    d: "M1444.67 927.333C1444.22 927.778 1445.28 927.722 1445.33 927.667C1445.78 927.223 1444.72 927.278 1444.67 927.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M263 928L264 929L263 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M386 928L387 929L386 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8698bc",
      stroke: "none"
    },
    d: "M603.667 928.333C603.222 928.778 604.278 928.722 604.333 928.667C604.778 928.222 603.722 928.278 603.667 928.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49649a",
      stroke: "none"
    },
    d: "M605 928L606 929L605 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d3179",
      stroke: "none"
    },
    d: "M602 929C608.436 931.701 618.049 930 625 930L675 930L848 930L1451 930C1445.51 927.242 1437.09 929 1431 929L1383 929L1213 929L602 929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49649a",
      stroke: "none"
    },
    d: "M1447 928L1448 929L1447 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3bfd5",
      stroke: "none"
    },
    d: "M1448.67 928.333C1448.22 928.778 1449.28 928.722 1449.33 928.667C1449.78 928.222 1448.72 928.278 1448.67 928.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1786 928L1787 929L1786 928M385 929L386 930L385 929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4b2cd",
      stroke: "none"
    },
    d: "M599 929L600 930L599 929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#687fab",
      stroke: "none"
    },
    d: "M600 929L601 930L600 929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d327a",
      stroke: "none"
    },
    d: "M598 930C604.436 932.701 614.049 931 621 931L671 931L847 931L1455 931C1449.94 928.277 1441.71 930 1436 930L1390 930L1222 930L803 930L665 930L620 930C612.748 930 605.193 929.232 598 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#687fab",
      stroke: "none"
    },
    d: "M1452 929L1453 930L1452 929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4b2cd",
      stroke: "none"
    },
    d: "M1453 929L1454 930L1453 929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1664 929L1665 930L1664 929M262 930L263 931L262 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M384 930L385 931L384 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4bfd5",
      stroke: "none"
    },
    d: "M595 930L596 931L595 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#687fac",
      stroke: "none"
    },
    d: "M596 930L597 931L596 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e337b",
      stroke: "none"
    },
    d: "M594 931C600.436 933.701 610.049 932 617 932L668 932L845 932L1459 932C1453.75 929.174 1444.94 931 1439 931L1393 931L1224 931L801 931L662 931L616 931C608.748 931 601.193 930.232 594 931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#687fac",
      stroke: "none"
    },
    d: "M1456 930L1457 931L1456 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4bfd5",
      stroke: "none"
    },
    d: "M1457 930L1458 931L1457 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1665 930L1666 931L1665 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1787 930L1788 931L1787 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8799bd",
      stroke: "none"
    },
    d: "M592 931L593 932L592 931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f347c",
      stroke: "none"
    },
    d: "M591 932C597.436 934.701 607.049 933 614 933L666 933L844 933L1462 933C1457.16 930.238 1448.57 932 1443 932L1397 932L1228 932L800 932L660 932L614 932C606.449 932 598.474 931.165 591 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8799bd",
      stroke: "none"
    },
    d: "M1460 931L1461 932L1460 931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M261 932L262 933L261 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M383 932L384 933L383 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4c0d6",
      stroke: "none"
    },
    d: "M588 932L589 933L588 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6980ad",
      stroke: "none"
    },
    d: "M589 932L590 933L589 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f357d",
      stroke: "none"
    },
    d: "M587 933C593.436 935.701 603.049 934 610 934L662 934L842 934L1466 934C1460.75 931.174 1451.94 933 1446 933L1399 933L1227 933L797 933L656 933L610 933C602.424 933 594.512 932.198 587 933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6980ad",
      stroke: "none"
    },
    d: "M1463 932L1464 933L1463 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4c0d6",
      stroke: "none"
    },
    d: "M1464 932L1465 933L1464 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1788 932L1789 933L1788 932M382 933L383 934L382 933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5b3ce",
      stroke: "none"
    },
    d: "M585 933L586 934L585 933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a74a6",
      stroke: "none"
    },
    d: "M586 933L587 934L586 933M1466 933L1467 934L1466 933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5b3ce",
      stroke: "none"
    },
    d: "M1467 933L1468 934L1467 933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1667 933L1668 934L1667 933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M260 934L261 935L260 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M381 934L382 935L381 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5b4cf",
      stroke: "none"
    },
    d: "M582 934L583 935L582 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b75a6",
      stroke: "none"
    },
    d: "M583 934L584 935L583 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10367e",
      stroke: "none"
    },
    d: "M584 934C590.678 936.802 600.784 935 608 935L660 935L841 935L1469 935C1462.32 932.198 1452.22 934 1445 934L1393 934L1212 934L584 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b75a6",
      stroke: "none"
    },
    d: "M1469 934L1470 935L1469 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5b4cf",
      stroke: "none"
    },
    d: "M1470 934L1471 935L1470 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1668 934L1669 935L1668 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1789 934L1790 935L1789 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6b4cf",
      stroke: "none"
    },
    d: "M579 935L580 936L579 935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b76a7",
      stroke: "none"
    },
    d: "M580 935L581 936L580 935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11377f",
      stroke: "none"
    },
    d: "M581 935C587.678 937.802 597.784 936 605 936L657 936L840 936L1472 936C1465.32 933.198 1455.22 935 1448 935L1396 935L1214 935L581 935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b76a7",
      stroke: "none"
    },
    d: "M1472 935L1473 936L1472 935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6b4cf",
      stroke: "none"
    },
    d: "M1473 935L1474 936L1473 935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M259 936L260 937L259 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M380 936L381 937L380 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4cddf",
      stroke: "none"
    },
    d: "M576 936L577 937L576 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a83af",
      stroke: "none"
    },
    d: "M577 936L578 937L577 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#123980",
      stroke: "none"
    },
    d: "M576 937C582.678 939.802 592.784 938 600 938L653 938L838 938L1477 938C1471.98 935.134 1462.79 937 1457 937L1410 937L1235 937L793 937L647 937L599 937C591.449 937 583.474 936.165 576 937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11387f",
      stroke: "none"
    },
    d: "M579 936C585.678 938.802 595.784 937 603 937L656 937L839 937L1474 937C1467.32 934.198 1457.22 936 1450 936L1397 936L1214 936L579 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a83af",
      stroke: "none"
    },
    d: "M1475 936L1476 937L1475 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4cddf",
      stroke: "none"
    },
    d: "M1476 936L1477 937L1476 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1790 936L1791 937L1790 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M379 937L380 938L379 937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#899cc0",
      stroke: "none"
    },
    d: "M574 937L575 938L574 937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#133a81",
      stroke: "none"
    },
    d: "M573 938C579.678 940.802 589.784 939 597 939L651 939L836 939L1480 939C1474.98 936.134 1465.79 938 1460 938L1413 938L1237 938L791 938L645 938L597 938C589.125 938 580.794 937.129 573 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#899cc0",
      stroke: "none"
    },
    d: "M1478 937L1479 938L1478 937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1670 937L1671 938L1670 937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M258 938L259 939L258 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5c1d8",
      stroke: "none"
    },
    d: "M571 938L572 939L571 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d77a8",
      stroke: "none"
    },
    d: "M572 938L573 939L572 938M1480 938L1481 939L1480 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5c1d8",
      stroke: "none"
    },
    d: "M1481 938L1482 939L1481 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1671 938L1672 939L1671 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1791 938L1792 939L1791 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#899dc1",
      stroke: "none"
    },
    d: "M569 939L570 940L569 939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#143b83",
      stroke: "none"
    },
    d: "M568 940C574.678 942.802 584.784 941 592 941L646 941L834 941L1485 941C1479.98 938.134 1470.79 940 1465 940L1417 940L1239 940L788 940L640 940L592 940C584.126 940 575.794 939.129 568 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#133b82",
      stroke: "none"
    },
    d: "M571 939C577.678 941.802 587.784 940 595 940L649 940L836 940L1482 940C1475.32 937.198 1465.22 939 1458 939L1404 939L1218 939L571 939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#899dc1",
      stroke: "none"
    },
    d: "M1483 939L1484 940L1483 939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M257 940L258 941L257 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M377 940L378 941L377 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4cee0",
      stroke: "none"
    },
    d: "M566 940L567 941L566 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c85b2",
      stroke: "none"
    },
    d: "M567 940L568 941L567 940M1485 940L1486 941L1485 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1672 940L1673 941L1672 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1792 940L1793 941L1792 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7b6d1",
      stroke: "none"
    },
    d: "M564 941L565 942L564 941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f6da3",
      stroke: "none"
    },
    d: "M565 941L566 942L565 941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#143c84",
      stroke: "none"
    },
    d: "M566 941C572.919 943.903 583.52 942 591 942L645 942L833 942L1487 942C1480.08 939.097 1469.48 941 1462 941L1408 941L1219 941L566 941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f6da3",
      stroke: "none"
    },
    d: "M1487 941L1488 942L1487 941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7b6d1",
      stroke: "none"
    },
    d: "M1488 941L1489 942L1488 941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1673 941L1674 942L1673 941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M256 942L257 943L256 942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7b6d1",
      stroke: "none"
    },
    d: "M562 942L563 943L562 942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163e86",
      stroke: "none"
    },
    d: "M562 943C568.919 945.903 579.52 944 587 944L642 944L832 944L1491 944C1486.08 941.154 1476.73 943 1471 943L1422 943L1242 943L785 943L635 943L586 943C578.132 943 569.777 942.145 562 943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#153d85",
      stroke: "none"
    },
    d: "M564 942C570.919 944.903 581.52 943 589 943L643 943L832 943L1489 943C1482.08 940.097 1471.48 942 1464 942L1410 942L1221 942L564 942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7b6d1",
      stroke: "none"
    },
    d: "M1490 942L1491 943L1490 942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1793 942L1794 943L1793 942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M375 943L376 944L375 943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b9fc3",
      stroke: "none"
    },
    d: "M560 943L561 944L560 943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163f87",
      stroke: "none"
    },
    d: "M560 944C566.919 946.903 577.52 945 585 945L640 945L831 945L1493 945C1488.08 942.154 1478.73 944 1473 944L1424 944L1243 944L784 944L633 944L584 944C576.132 944 567.777 943.145 560 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b9fc3",
      stroke: "none"
    },
    d: "M1492 943L1493 944L1492 943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1674 943L1675 944L1674 943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M255 944L256 945L255 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M374 944L375 945L374 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b9fc3",
      stroke: "none"
    },
    d: "M558 944L559 945L558 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#174088",
      stroke: "none"
    },
    d: "M558 945C564.919 947.903 575.52 946 583 946L638 946L830 946L1495 946C1490.08 943.154 1480.73 945 1475 945L1426 945L1245 945L783 945L632 945L582 945C574.132 945 565.777 944.145 558 945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b9fc3",
      stroke: "none"
    },
    d: "M1494 944L1495 945L1494 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1675 944L1676 945L1675 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1794 944L1795 945L1794 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M255 945L256 946L255 945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ba0c3",
      stroke: "none"
    },
    d: "M556 945L557 946L556 945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184188",
      stroke: "none"
    },
    d: "M556 946C562.919 948.903 573.52 947 581 947L636 947L829 947L1497 947C1492.08 944.154 1482.73 946 1477 946L1427 946L1245 946L782 946L630 946L580 946C572.132 946 563.777 945.145 556 946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ba0c3",
      stroke: "none"
    },
    d: "M1496 945L1497 946L1496 945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M254 946L255 947L254 946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M373 946L374 947L373 946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ba0c4",
      stroke: "none"
    },
    d: "M554 946L555 947L554 946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184289",
      stroke: "none"
    },
    d: "M554 947C560.919 949.903 571.52 948 579 948L635 948L828 948L1499 948C1494.08 945.154 1484.73 947 1479 947L1429 947L1246 947L781 947L629 947L579 947C570.808 947 562.098 946.11 554 947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ba0c4",
      stroke: "none"
    },
    d: "M1498 946L1499 947L1498 946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1676 946L1677 947L1676 946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1795 946L1796 947L1795 946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M254 947L255 948L254 947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M372 947L373 948L372 947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c4",
      stroke: "none"
    },
    d: "M552 947L553 948L552 947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19438a",
      stroke: "none"
    },
    d: "M552 948C558.919 950.903 569.52 949 577 949L633 949L827 949L1501 949C1496.08 946.154 1486.73 948 1481 948L1431 948L1247 948L780 948L627 948L577 948C568.808 948 560.098 947.11 552 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c4",
      stroke: "none"
    },
    d: "M1500 947L1501 948L1500 947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1677 947L1678 948L1677 947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9aadcc",
      stroke: "none"
    },
    d: "M550 948L551 949L550 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a448b",
      stroke: "none"
    },
    d: "M550 949C556.919 951.903 567.52 950 575 950L632 950L827 950L1503 950C1498.08 947.154 1488.73 949 1483 949L1433 949L1248 949L779 949L625 949L575 949C566.808 949 558.098 948.11 550 949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9b9d3",
      stroke: "none"
    },
    d: "M1502 948L1503 949L1502 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1796 948L1797 949L1796 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M253 949L254 950L253 949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M371 949L372 950L371 949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9b9d4",
      stroke: "none"
    },
    d: "M548 949L549 950L548 949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a458c",
      stroke: "none"
    },
    d: "M548 950C554.919 952.903 565.52 951 573 951L630 951L826 951L1505 951C1499.89 948.048 1489.95 950 1484 950L1434 950L1249 950L778 950L623 950L573 950C564.808 950 556.098 949.11 548 950z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7c5db",
      stroke: "none"
    },
    d: "M1504 949L1505 950L1504 949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1678 949L1679 950L1678 949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1796 949L1797 950L1796 949M370 950L371 951L370 950z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6d1e2",
      stroke: "none"
    },
    d: "M546 950L547 951L546 950z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5373a9",
      stroke: "none"
    },
    d: "M547 950L548 951L547 950M1505 950L1506 951L1505 950z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6d1e2",
      stroke: "none"
    },
    d: "M1506 950L1507 951L1506 950z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1679 950L1680 951L1679 950z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M252 951L253 952L252 951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#718bb8",
      stroke: "none"
    },
    d: "M545 951L546 952L545 951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b468d",
      stroke: "none"
    },
    d: "M546 951C552.919 953.903 563.52 952 571 952L628 952L825 952L1507 952C1500.08 949.097 1489.48 951 1482 951L1425 951L1228 951L546 951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#718bb8",
      stroke: "none"
    },
    d: "M1507 951L1508 952L1507 951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1797 951L1798 952L1797 951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M369 952L370 953L369 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8da3c7",
      stroke: "none"
    },
    d: "M543 952L544 953L543 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c478f",
      stroke: "none"
    },
    d: "M543 953C549.919 955.903 560.52 954 568 954L625 954L823 954L1510 954C1504.89 951.048 1494.95 953 1489 953L1439 953L1251 953L776 953L620 953L568 953C559.808 953 551.098 952.11 543 953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b478e",
      stroke: "none"
    },
    d: "M545 952C551.919 954.903 562.52 953 570 953L627 953L824 953L1508 953C1501.08 950.097 1490.48 952 1483 952L1426 952L1229 952L545 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8da3c7",
      stroke: "none"
    },
    d: "M1509 952L1510 953L1509 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1680 952L1681 953L1680 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M251 953L252 954L251 953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6d1e3",
      stroke: "none"
    },
    d: "M541 953L542 954L541 953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4890",
      stroke: "none"
    },
    d: "M541 954C548.159 957.004 559.256 955 567 955L624 955L822 955L1512 955C1506.89 952.048 1496.95 954 1491 954L1440 954L1252 954L775 954L618 954L566 954C557.808 954 549.098 953.11 541 954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6d1e3",
      stroke: "none"
    },
    d: "M1511 953L1512 954L1511 953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1681 953L1682 954L1681 953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1798 953L1799 954L1798 953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M368 954L369 955L368 954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6481b3",
      stroke: "none"
    },
    d: "M540 954L541 955L540 954M1512 954L1513 955L1512 954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M250 955L251 956L250 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M367 955L368 956L367 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9cb0cf",
      stroke: "none"
    },
    d: "M538 955L539 956L538 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e4a92",
      stroke: "none"
    },
    d: "M538 956C545.159 959.004 556.256 957 564 957L622 957L822 957L1515 957C1509.89 954.048 1499.95 956 1494 956L1443 956L1254 956L773 956L615 956L563 956C554.808 956 546.098 955.11 538 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d4991",
      stroke: "none"
    },
    d: "M540 955C547.159 958.004 558.256 956 566 956L623 956L822 956L1513 956C1505.84 952.996 1494.74 955 1487 955L1430 955L1231 955L540 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9cb0cf",
      stroke: "none"
    },
    d: "M1514 955L1515 956L1514 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1682 955L1683 956L1682 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1799 955L1800 956L1799 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M250 956L251 957L250 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f4b92",
      stroke: "none"
    },
    d: "M536 957C543.159 960.004 554.256 958 562 958L620 958L821 958L1517 958C1509.84 954.996 1498.74 957 1491 957L1434 957L1234 957L765 957L611 957L561 957C552.808 957 544.098 956.11 536 957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5677ad",
      stroke: "none"
    },
    d: "M1515 956L1516 957L1515 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M366 957L367 958L366 957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8fa5c9",
      stroke: "none"
    },
    d: "M535 957L536 958L535 957M1517 957L1518 958L1517 957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1683 957L1684 958L1683 957M1800 957L1801 958L1800 957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M249 958L250 959L249 958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M365 958L366 959L365 958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#204d94",
      stroke: "none"
    },
    d: "M533 959C540.159 962.004 551.256 960 559 960L617 960L819 960L1520 960C1514.89 957.048 1504.95 959 1499 959L1447 959L1256 959L770 959L611 959L559 959C550.484 959 541.42 958.075 533 959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f4c93",
      stroke: "none"
    },
    d: "M535 958C542.159 961.004 553.256 959 561 959L619 959L820 959L1518 959C1510.84 955.996 1499.74 958 1492 958L1434 958L1233 958L535 958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1684 958L1685 959L1684 958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1800 958L1801 959L1800 958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90a6ca",
      stroke: "none"
    },
    d: "M532 959L533 960L532 959M1520 959L1521 960L1520 959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M248 960L249 961L248 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M364 960L365 961L364 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#214f96",
      stroke: "none"
    },
    d: "M530 961C537.159 964.004 548.256 962 556 962L615 962L818 962L1522 962C1514.84 958.996 1503.74 961 1496 961L1438 961L1236 961L762 961L606 961L555 961C546.808 961 538.098 960.11 530 961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#214e95",
      stroke: "none"
    },
    d: "M532 960C539.159 963.004 550.256 961 558 961L616 961L819 961L1521 961C1513.84 957.996 1502.74 960 1495 960L1437 960L1235 960L532 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#587ab0",
      stroke: "none"
    },
    d: "M1521 960L1522 961L1521 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1685 960L1686 961L1685 960M1801 960L1802 961L1801 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9eb2d1",
      stroke: "none"
    },
    d: "M529 961L530 962L529 961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#225097",
      stroke: "none"
    },
    d: "M529 962C536.159 965.004 547.256 963 555 963L614 963L818 963L1524 963C1518.71 959.942 1508.17 962 1502 962L1449 962L1252 962L529 962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9eb2d1",
      stroke: "none"
    },
    d: "M1523 961L1524 962L1523 961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M247 962L248 963L247 962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M363 962L364 963L363 962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#597cb1",
      stroke: "none"
    },
    d: "M528 962L529 963L528 962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6787b8",
      stroke: "none"
    },
    d: "M1524 962L1525 963L1524 962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1686 962L1687 963L1686 962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1802 962L1803 963L1802 962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M247 963L248 964L247 963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bac9df",
      stroke: "none"
    },
    d: "M526 963L527 964L526 963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#235299",
      stroke: "none"
    },
    d: "M526 964C533.159 967.004 544.256 965 552 965L611 965L816 965L1527 965C1521.89 962.048 1511.95 964 1506 964L1453 964L1259 964L767 964L605 964L552 964C543.484 964 534.42 963.075 526 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#235198",
      stroke: "none"
    },
    d: "M528 963C535.159 966.004 546.256 964 554 964L613 964L817 964L1525 964C1517.84 960.996 1506.74 963 1499 963L1440 963L1236 963L528 963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8d4e5",
      stroke: "none"
    },
    d: "M1526 963L1527 964L1526 963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1687 963L1688 964L1687 963M1802 963L1803 964L1802 963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M362 964L363 965L362 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#839ec6",
      stroke: "none"
    },
    d: "M525 964L526 965L525 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91a8cc",
      stroke: "none"
    },
    d: "M1527 964L1528 965L1527 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M246 965L247 966L246 965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M361 965L362 966L361 965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#25539b",
      stroke: "none"
    },
    d: "M524 965C527.197 968.658 535.423 967 540 967L586 967L773 967L1529 967C1522.56 964.299 1512.95 966 1506 966L1455 966L1278 966L763 966L602 966L552 966C542.866 966 532.923 967.125 524 965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24539a",
      stroke: "none"
    },
    d: "M525 965C532.399 968.105 543.993 966 552 966L611 966L816 966L1528 966C1520.6 962.895 1509.01 965 1501 965L1442 965L1237 965L525 965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b7eb3",
      stroke: "none"
    },
    d: "M1528 965L1529 966L1528 965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1688 965L1689 966L1688 965M1803 965L1804 966L1803 965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbc9e0",
      stroke: "none"
    },
    d: "M522 966L523 967L522 966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#25549b",
      stroke: "none"
    },
    d: "M522 967C529.399 970.105 540.993 968 549 968L608 968L815 968L1531 968C1525.89 965.048 1515.95 967 1510 967L1457 967L1261 967L765 967L602 967L548 967C539.484 967 530.42 966.075 522 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9d4e6",
      stroke: "none"
    },
    d: "M1530 966L1531 967L1530 966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M245 967L246 968L245 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M360 967L361 968L360 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849fc7",
      stroke: "none"
    },
    d: "M521 967L522 968L521 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0b4d4",
      stroke: "none"
    },
    d: "M1531 967L1532 968L1531 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1689 967L1690 968L1689 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1804 967L1805 968L1804 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M245 968L246 969L245 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26569d",
      stroke: "none"
    },
    d: "M520 968C523.304 971.781 532.26 970 537 970L583 970L771 970L1533 970C1526.56 967.299 1516.95 969 1510 969L1458 969L1280 969L762 969L599 969L548 969C538.866 969 528.923 970.125 520 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26559c",
      stroke: "none"
    },
    d: "M521 968C528.399 971.105 539.993 969 548 969L607 969L814 969L1532 969C1524.6 965.895 1513.01 968 1505 968L1446 968L1239 968L521 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a8abb",
      stroke: "none"
    },
    d: "M1532 968L1533 969L1532 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M359 969L360 970L359 969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27579e",
      stroke: "none"
    },
    d: "M519 969C521.97 972.399 528.759 971 533 971L569 971L716 971L1315 971L1479 971L1519 971C1523.41 971 1530.91 972.531 1534 969C1525.98 970.91 1517.21 970 1509 970L1465 970L1325 970L877 970L634 970L558 970C545.494 970 531.197 971.904 519 969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1690 969L1691 970L1690 969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M244 970L245 971L244 970z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aec0db",
      stroke: "none"
    },
    d: "M517 970L518 971L517 970z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28589f",
      stroke: "none"
    },
    d: "M517 971C524.399 974.105 535.993 972 544 972L604 972L813 972L1536 972C1530.71 968.942 1520.17 971 1514 971L1461 971L1264 971L762 971L597 971L543 971C534.484 971 525.42 970.075 517 971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1805 970L1806 971L1805 970z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M358 971L359 972L358 971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#86a1c9",
      stroke: "none"
    },
    d: "M516 971L517 972L516 971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aec0db",
      stroke: "none"
    },
    d: "M1536 971L1537 972L1536 971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1691 971L1692 972L1691 971M243 972L244 973L243 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M357 972L358 973L357 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b8dbe",
      stroke: "none"
    },
    d: "M515 972L516 973L515 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2859a0",
      stroke: "none"
    },
    d: "M516 972C523.399 975.105 534.993 973 543 973L603 973L812 973L1537 973C1529.6 969.895 1518.01 972 1510 972L1450 972L1241 972L516 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7997c4",
      stroke: "none"
    },
    d: "M1537 972L1538 973L1537 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1692 972L1693 973L1692 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1806 972L1807 973L1806 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M243 973L244 974L243 973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M357 973L358 974L357 973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a5ba2",
      stroke: "none"
    },
    d: "M514 973C516.97 976.399 523.759 975 528 975L564 975L713 975L1317 975L1483 975L1524 975C1528.41 975 1535.91 976.531 1539 973C1530.98 974.91 1522.21 974 1514 974L1470 974L1328 974L876 974L630 974L554 974C541.188 974 526.494 975.975 514 973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#295aa1",
      stroke: "none"
    },
    d: "M515 973C522.399 976.105 533.993 974 542 974L602 974L812 974L1538 974C1530.6 970.895 1519.01 973 1511 973L1451 973L1241 973L515 973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1692 973L1693 974L1692 973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1806 973L1807 974L1806 973M356 974L357 975L356 974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a5ca3",
      stroke: "none"
    },
    d: "M513 974C515.97 977.399 522.759 976 527 976L563 976L713 976L1318 976L1484 976L1525 976C1529.41 976 1536.91 977.531 1540 974C1531.98 975.91 1523.21 975 1515 975L1471 975L1329 975L877 975L630 975L553 975C540.188 975 525.494 976.975 513 974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1693 974L1694 975L1693 974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M242 975L243 976L242 975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M356 975L357 976L356 975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdcce2",
      stroke: "none"
    },
    d: "M511 975L512 976L511 975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b5da4",
      stroke: "none"
    },
    d: "M511 976C516.951 978.497 525.58 977 532 977L579 977L741 977L1302 977L1481 977L1525 977C1529.58 977 1537.8 978.658 1541 975C1531.18 977.338 1520.06 976 1510 976L1452 976L1268 976L760 976L593 976L538 976C529.159 976 519.742 975.039 511 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1807 975L1808 976L1807 975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M242 976L243 977L242 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M355 976L356 977L355 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0c2dd",
      stroke: "none"
    },
    d: "M510 976L511 977L510 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c5ea4",
      stroke: "none"
    },
    d: "M510 977C517.399 980.105 528.993 978 537 978L598 978L810 978L1543 978C1537.71 974.942 1527.17 977 1521 977L1465 977L1261 977L510 977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdcce3",
      stroke: "none"
    },
    d: "M1542 976L1543 977L1542 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1694 976L1695 977L1694 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95aed2",
      stroke: "none"
    },
    d: "M509 977L510 978L509 977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0c3dd",
      stroke: "none"
    },
    d: "M1543 977C1543.55 978.635 1543.36 978.455 1545 979C1544.45 977.365 1544.64 977.545 1543 977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1808 977L1809 978L1808 977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M241 978L242 979L241 978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M354 978L355 979L354 978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b9bc7",
      stroke: "none"
    },
    d: "M508 978L509 979L508 978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c5fa5",
      stroke: "none"
    },
    d: "M509 978C516.399 981.105 527.993 979 536 979L597 979L809 979L1544 979C1536.6 975.895 1525.01 978 1517 978L1456 978L1244 978L509 978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1695 978L1696 979L1695 978M1808 978L1809 979L1808 978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c9bc7",
      stroke: "none"
    },
    d: "M507 979L508 980L507 979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d5fa6",
      stroke: "none"
    },
    d: "M508 979C515.399 982.105 526.993 980 535 980L596 980L809 980L1545 980C1537.6 976.895 1526.01 979 1518 979L1456 979L1244 979L508 979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c9bc7",
      stroke: "none"
    },
    d: "M1545 979L1546 980L1545 979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M353 980L354 981L353 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e61a8",
      stroke: "none"
    },
    d: "M506 980C509.304 983.781 518.26 982 523 982L571 982L764 982L1547 982C1540.32 979.198 1530.22 981 1523 981L1470 981L1286 981L754 981L587 981L535 981C525.559 981 515.222 982.196 506 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e60a7",
      stroke: "none"
    },
    d: "M507 980C514.399 983.105 525.993 981 534 981L595 981L808 981L1546 981C1538.6 977.895 1527.01 980 1519 980L1457 980L1244 980L507 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c9cc8",
      stroke: "none"
    },
    d: "M1546 980L1547 981L1546 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1696 980L1697 981L1696 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1809 980L1810 981L1809 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M240 981L241 982L240 981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f62a9",
      stroke: "none"
    },
    d: "M505 981C508.304 984.781 517.26 983 522 983L570 983L763 983L1548 983C1541.32 980.198 1531.22 982 1524 982L1471 982L1287 982L753 982L586 982L534 982C524.559 982 514.222 983.196 505 981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c9dc9",
      stroke: "none"
    },
    d: "M1547 981L1548 982L1547 981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1809 981L1810 982L1809 981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M352 982L353 983L352 982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f63aa",
      stroke: "none"
    },
    d: "M504 982C507.304 985.781 516.26 984 521 984L569 984L763 984L1549 984C1542.32 981.198 1532.22 983 1525 983L1472 983L1288 983L753 983L585 983L533 983C523.559 983 513.222 984.196 504 982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9dc9",
      stroke: "none"
    },
    d: "M1548 982L1549 983L1548 982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1697 982L1698 983L1697 982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M239 983L240 984L239 983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3064ab",
      stroke: "none"
    },
    d: "M503 983C506.304 986.781 515.26 985 520 985L568 985L762 985L1550 985C1543.32 982.198 1533.22 984 1526 984L1473 984L1288 984L752 984L584 984L532 984C522.559 984 512.222 985.196 503 983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d9eca",
      stroke: "none"
    },
    d: "M1549 983L1550 984L1549 983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1810 983L1811 984L1810 983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M239 984L240 985L239 984M351 984L352 985L351 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3165ac",
      stroke: "none"
    },
    d: "M502 984C505.304 987.781 514.26 986 519 986L567 986L762 986L1551 986C1544.32 983.198 1534.22 985 1527 985L1474 985L1289 985L752 985L583 985L531 985C521.559 985 511.222 986.196 502 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9eca",
      stroke: "none"
    },
    d: "M1550 984L1551 985L1550 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1698 984L1699 985L1698 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3166ad",
      stroke: "none"
    },
    d: "M501 985C504.304 988.781 513.26 987 518 987L566 987L761 987L1552 987C1545.32 984.198 1535.22 986 1528 986L1475 986L1289 986L751 986L582 986L530 986C520.559 986 510.222 987.196 501 985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9fcb",
      stroke: "none"
    },
    d: "M1551 985L1552 986L1551 985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M238 986L239 987L238 986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M350 986L351 987L350 986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3267ad",
      stroke: "none"
    },
    d: "M500 986C503.304 989.781 512.26 988 517 988L565 988L761 988L1553 988C1546.32 985.198 1536.22 987 1529 987L1475 987L1289 987L750 987L582 987L529 987C519.559 987 509.222 988.196 500 986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f9fcc",
      stroke: "none"
    },
    d: "M1552 986L1553 987L1552 986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1699 986L1700 987L1699 986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1811 986L1812 987L1811 986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M238 987L239 988L238 987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M350 987L351 988L350 987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3368ae",
      stroke: "none"
    },
    d: "M499 987C502.304 990.781 511.26 989 516 989L564 989L760 989L1554 989C1547.32 986.198 1537.22 988 1530 988L1476 988L1290 988L750 988L581 988L528 988C518.559 988 508.222 989.196 499 987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7fa0cc",
      stroke: "none"
    },
    d: "M1553 987L1554 988L1553 987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M349 988L350 989L349 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3369af",
      stroke: "none"
    },
    d: "M498 988C501.304 991.781 510.26 990 515 990L564 990L760 990L1555 990C1548.32 987.198 1538.22 989 1531 989L1477 989L1290 989L749 989L580 989L527 989C517.559 989 507.222 990.196 498 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7fa0cd",
      stroke: "none"
    },
    d: "M1554 988L1555 989L1554 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1700 988L1701 989L1700 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M237 989L238 990L237 989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M349 989L350 990L349 989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#346ab0",
      stroke: "none"
    },
    d: "M497 989C500.304 992.781 509.26 991 514 991L563 991L759 991L1556 991C1549.32 988.198 1539.22 990 1532 990L1478 990L1291 990L749 990L579 990L526 990C516.559 990 506.222 991.196 497 989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80a1cd",
      stroke: "none"
    },
    d: "M1555 989L1556 990L1555 989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1700 989L1701 990L1700 989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1812 989L1813 990L1812 989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M237 990L238 991L237 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#356ab1",
      stroke: "none"
    },
    d: "M496 990C499.304 993.781 508.26 992 513 992L562 992L759 992L1557 992C1550.32 989.198 1540.22 991 1533 991L1479 991L1291 991L748 991L578 991L525 991C515.559 991 505.222 992.196 496 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80a2ce",
      stroke: "none"
    },
    d: "M1556 990L1557 991L1556 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1701 990L1702 991L1701 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M348 991L349 992L348 991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81a2ce",
      stroke: "none"
    },
    d: "M495 991L496 992L495 991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7bedd",
      stroke: "none"
    },
    d: "M1557 991L1558 992L1557 991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1701 991L1702 992L1701 991M236 992L237 993L236 992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81a3cf",
      stroke: "none"
    },
    d: "M494 992L495 993L494 992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#356bb2",
      stroke: "none"
    },
    d: "M495 992C502.639 995.206 514.729 993 523 993L586 993L803 993L1558 993C1550.36 989.794 1538.27 992 1530 992L1468 992L1250 992L495 992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3c8e2",
      stroke: "none"
    },
    d: "M1558 992L1559 993L1558 992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1813 992L1814 993L1813 992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M236 993L237 994L236 993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M347 993L348 994L347 993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7bfde",
      stroke: "none"
    },
    d: "M493 993L494 994L493 993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#366cb3",
      stroke: "none"
    },
    d: "M494 993C501.639 996.206 513.729 994 522 994L585 994L803 994L1559 994C1551.36 990.794 1539.27 993 1531 993L1468 993L1250 993L494 993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0d1e7",
      stroke: "none"
    },
    d: "M1559 993L1560 994L1559 993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1702 993L1703 994L1702 993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4c8e3",
      stroke: "none"
    },
    d: "M492 994L493 995L492 994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#376db4",
      stroke: "none"
    },
    d: "M493 994C500.639 997.206 512.729 995 521 995L584 995L802 995L1559 995C1551.36 991.794 1539.27 994 1531 994L1468 994L1250 994L493 994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#376eb5",
      stroke: "none"
    },
    d: "M1559 994C1548.76 997.028 1535.66 995 1525 995L1456 995L1231 995L492 995C496.416 997.545 504.83 996 510 996L554 996L715 996L1307 996L1500 996L1546 996C1548.49 996 1560.3 997.154 1559 994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M235 995L236 996L235 995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M346 995L347 996L346 995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386fb6",
      stroke: "none"
    },
    d: "M1560 995C1549.76 998.028 1536.66 996 1526 996L1457 996L1231 996L492 996C496.416 998.545 504.83 997 510 997L554 997L715 997L1308 997L1501 997L1547 997C1549.49 997 1561.3 998.154 1560 995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1703 995L1704 996L1703 995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1814 995L1815 996L1814 995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M235 996L236 997L235 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3870b6",
      stroke: "none"
    },
    d: "M491 996C494.086 999.531 501.589 998 506 998L549 998L723 998L1354 998L1510 998L1548 998C1552.24 998 1559.03 999.399 1562 996C1553.68 997.982 1544.52 997 1536 997L1490 997L1342 997L870 997L613 997L532 997C518.882 997 503.79 999.045 491 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M345 997L346 998L345 997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3971b7",
      stroke: "none"
    },
    d: "M490 997C493.086 1000.53 500.589 999 505 999L548 999L722 999L1354 999L1511 999L1549 999C1553.24 999 1560.03 1000.4 1563 997C1550.21 1000.05 1535.12 998 1522 998L1441 998L1184 998L711 998L562 998L516 998C507.482 998 498.324 998.982 490 997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1704 997L1705 998L1704 997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M234 998L235 999L234 998M345 998L346 999L345 998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a72b8",
      stroke: "none"
    },
    d: "M489 998C492.407 1001.9 502.099 1000 507 1000L556 1000L755 1000L1564 1000C1557.08 997.097 1546.48 999 1539 999L1485 999L1295 999L745 999L572 999L518 999C508.559 999 498.222 1000.2 489 998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83a6d2",
      stroke: "none"
    },
    d: "M1563 998L1564 999L1563 998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1704 998L1705 999L1704 998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1815 998L1816 999L1815 998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M234 999L235 1000L234 999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84a7d3",
      stroke: "none"
    },
    d: "M488 999L489 1000L488 999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9c1e0",
      stroke: "none"
    },
    d: "M1564 999L1565 1000L1564 999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1815 999L1816 1000L1815 999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M344 1000L345 1001L344 1000z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9c2e0",
      stroke: "none"
    },
    d: "M487 1000L488 1001L487 1000z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a73b9",
      stroke: "none"
    },
    d: "M488 1000C495.639 1003.21 507.729 1001 516 1001L580 1001L801 1001L1565 1001C1557.36 997.794 1545.27 1000 1537 1000L1473 1000L1253 1000L488 1000z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1705 1000L1706 1001L1705 1000z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b74ba",
      stroke: "none"
    },
    d: "M487 1001C494.639 1004.21 506.729 1002 515 1002L579 1002L800 1002L1565 1002C1557.36 998.794 1545.27 1001 1537 1001L1473 1001L1253 1001L487 1001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c75bb",
      stroke: "none"
    },
    d: "M1565 1001C1554.76 1004.03 1541.66 1002 1531 1002L1461 1002L1233 1002L487 1002C491.416 1004.54 499.83 1003 505 1003L549 1003L712 1003L1310 1003L1505 1003L1551 1003C1553.58 1003 1566.3 1004.14 1565 1001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1816 1001L1817 1002L1816 1001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M233 1002L234 1003L233 1002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M343 1002L344 1003L343 1002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c76bc",
      stroke: "none"
    },
    d: "M486 1002C489.197 1005.66 497.423 1004 502 1004L545 1004L720 1004L1357 1004L1514 1004L1553 1004C1557.24 1004 1564.03 1005.4 1567 1002C1554.21 1005.05 1539.12 1003 1526 1003L1445 1003L1186 1003L708 1003L559 1003L512 1003C503.482 1003 494.324 1003.98 486 1002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1706 1002L1707 1003L1706 1002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1816 1002L1817 1003L1816 1002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d77bd",
      stroke: "none"
    },
    d: "M485 1003C488.407 1006.9 498.099 1005 503 1005L552 1005L753 1005L1568 1005C1561.08 1002.1 1550.48 1004 1543 1004L1488 1004L1297 1004L743 1004L569 1004L515 1004C505.251 1004 494.521 1005.27 485 1003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85a9d5",
      stroke: "none"
    },
    d: "M1567 1003L1568 1004L1567 1003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#86aad6",
      stroke: "none"
    },
    d: "M484 1004L485 1005L484 1004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aac3e2",
      stroke: "none"
    },
    d: "M1568 1004L1569 1005L1568 1004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1707 1004L1708 1005L1707 1004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1817 1004L1818 1005L1817 1004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M232 1005L233 1006L232 1005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M342 1005L343 1006L342 1005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7cce7",
      stroke: "none"
    },
    d: "M483 1005L484 1006L483 1005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e77be",
      stroke: "none"
    },
    d: "M484 1005C491.639 1008.21 503.729 1006 512 1006L576 1006L799 1006L1569 1006C1561.12 1002.69 1548.53 1005 1540 1005L1476 1005L1254 1005L484 1005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1707 1005L1708 1006L1707 1005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1817 1005L1818 1006L1817 1005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M232 1006L233 1007L232 1006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e78bf",
      stroke: "none"
    },
    d: "M483 1006C490.639 1009.21 502.729 1007 511 1007L575 1007L798 1007L1569 1007C1561.36 1003.79 1549.27 1006 1541 1006L1477 1006L1254 1006L483 1006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f79bf",
      stroke: "none"
    },
    d: "M1569 1006C1558.76 1009.03 1545.66 1007 1535 1007L1465 1007L1235 1007L483 1007C487.416 1009.54 495.83 1008 501 1008L546 1008L709 1008L1312 1008L1509 1008L1555 1008C1557.58 1008 1570.3 1009.14 1569 1006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M341 1007L342 1008L341 1007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407ac0",
      stroke: "none"
    },
    d: "M482 1007C485.197 1010.66 493.423 1009 498 1009L541 1009L717 1009L1359 1009L1518 1009L1557 1009C1561.24 1009 1568.03 1010.4 1571 1007C1557.91 1010.12 1542.42 1008 1529 1008L1447 1008L1187 1008L706 1008L555 1008L508 1008C499.482 1008 490.324 1008.98 482 1007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1708 1007L1709 1008L1708 1007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M231 1008L232 1009L231 1008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ba4d4",
      stroke: "none"
    },
    d: "M481 1008L482 1009L481 1008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9fbde0",
      stroke: "none"
    },
    d: "M1571 1008L1572 1009L1571 1008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1818 1008L1819 1009L1818 1008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M231 1009L232 1010L231 1009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#abc5e4",
      stroke: "none"
    },
    d: "M480 1009L481 1010L480 1009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407bc1",
      stroke: "none"
    },
    d: "M481 1009C488.879 1012.31 501.466 1010 510 1010L574 1010L798 1010L1572 1010C1564.12 1006.69 1551.53 1009 1543 1009L1479 1009L1256 1009L481 1009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1709 1009L1710 1010L1709 1009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1818 1009L1819 1010L1818 1009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M340 1010L341 1011L340 1010z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#417cc2",
      stroke: "none"
    },
    d: "M480 1010C487.879 1013.31 500.466 1011 509 1011L573 1011L796 1011L1572 1011C1564.12 1007.69 1551.53 1010 1543 1010L1479 1010L1255 1010L480 1010z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#427dc3",
      stroke: "none"
    },
    d: "M1572 1010C1561.48 1013.11 1547.96 1011 1537 1011L1467 1011L1236 1011L480 1011C484.416 1013.54 492.83 1012 498 1012L543 1012L708 1012L1314 1012L1511 1012L1558 1012C1560.58 1012 1573.3 1013.14 1572 1010z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1709 1010L1710 1011L1709 1010z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#427ec4",
      stroke: "none"
    },
    d: "M479 1011C482.407 1014.9 492.099 1013 497 1013L547 1013L750 1013L1574 1013C1567.08 1010.1 1556.48 1012 1549 1012L1493 1012L1300 1012L740 1012L564 1012L509 1012C499.251 1012 488.521 1013.27 479 1011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da6d6",
      stroke: "none"
    },
    d: "M1573 1011L1574 1012L1573 1011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1819 1011L1820 1012L1819 1011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M230 1012L231 1013L230 1012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M339 1012L340 1013L339 1012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95b6de",
      stroke: "none"
    },
    d: "M478 1012L479 1013L478 1012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8cfe9",
      stroke: "none"
    },
    d: "M1574 1012L1575 1013L1574 1012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1710 1012L1711 1013L1710 1012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1819 1012L1820 1013L1819 1012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M230 1013L231 1014L230 1013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M339 1013L340 1014L339 1013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4d7ed",
      stroke: "none"
    },
    d: "M477 1013L478 1014L477 1013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#437fc5",
      stroke: "none"
    },
    d: "M478 1013C485.879 1016.31 498.466 1014 507 1014L571 1014L796 1014L1574 1014C1566.12 1010.69 1553.53 1013 1545 1013L1481 1013L1256 1013L478 1013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4380c6",
      stroke: "none"
    },
    d: "M1574 1013C1563.48 1016.11 1549.95 1014 1539 1014L1469 1014L1237 1014L478 1014C482.416 1016.54 490.83 1015 496 1015L541 1015L707 1015L1315 1015L1513 1015L1560 1015C1562.58 1015 1575.3 1016.14 1574 1013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1710 1013L1711 1014L1710 1013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4481c7",
      stroke: "none"
    },
    d: "M477 1014C480.197 1017.66 488.423 1016 493 1016L537 1016L715 1016L1363 1016L1523 1016L1562 1016C1566.24 1016 1573.03 1017.4 1576 1014C1567.38 1016.05 1557.83 1015 1549 1015L1502 1015L1350 1015L865 1015L602 1015L519 1015C505.577 1015 490.087 1017.12 477 1014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M229 1015L230 1016L229 1015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M338 1015L339 1016L338 1015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4582c8",
      stroke: "none"
    },
    d: "M476 1015C479.407 1018.9 489.099 1017 494 1017L544 1017L749 1017L1577 1017C1570.08 1014.1 1559.48 1016 1552 1016L1496 1016L1301 1016L738 1016L561 1016L506 1016C496.251 1016 485.521 1017.27 476 1015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adc8e6",
      stroke: "none"
    },
    d: "M1576 1015L1577 1016L1576 1015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1711 1015L1712 1016L1711 1015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1820 1015L1821 1016L1820 1015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M229 1016L230 1017L229 1016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1820 1016L1821 1017L1820 1016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4683c9",
      stroke: "none"
    },
    d: "M475 1017C478.197 1020.66 486.423 1019 491 1019L535 1019L714 1019L1364 1019L1524 1019L1564 1019C1568.24 1019 1575.03 1020.4 1578 1017C1569.38 1019.05 1559.83 1018 1551 1018L1504 1018L1351 1018L864 1018L600 1018L517 1018C503.577 1018 488.087 1020.12 475 1017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4583c9",
      stroke: "none"
    },
    d: "M476 1017C483.879 1020.31 496.466 1018 505 1018L570 1018L795 1018L1577 1018C1569.12 1014.69 1556.53 1017 1548 1017L1483 1017L1258 1017L476 1017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M337 1018L338 1019L337 1018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4784ca",
      stroke: "none"
    },
    d: "M474 1018C477.407 1021.9 487.099 1020 492 1020L542 1020L747 1020L1578 1020C1571.08 1017.1 1560.48 1019 1553 1019L1497 1019L1302 1019L737 1019L560 1019L504 1019C494.251 1019 483.521 1020.27 474 1018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3c1e4",
      stroke: "none"
    },
    d: "M1578 1018L1579 1019L1578 1018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1712 1018L1713 1019L1712 1018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M228 1019L229 1020L228 1019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4785cb",
      stroke: "none"
    },
    d: "M1578 1019C1567.48 1022.11 1553.95 1020 1543 1020L1472 1020L1238 1020L474 1020C478.609 1022.66 487.602 1021 493 1021L538 1021L704 1021L1317 1021L1517 1021L1564 1021C1566.58 1021 1579.3 1022.14 1578 1019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1821 1019L1822 1020L1821 1019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M228 1020L229 1021L228 1020z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4886cc",
      stroke: "none"
    },
    d: "M473 1020C476.197 1023.66 484.423 1022 489 1022L533 1022L712 1022L1365 1022L1526 1022L1566 1022C1570.24 1022 1577.03 1023.4 1580 1020C1571.38 1022.05 1561.83 1021 1553 1021L1505 1021L1352 1021L864 1021L599 1021L516 1021C502.271 1021 486.383 1023.19 473 1020z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1713 1020L1714 1021L1713 1020M1821 1020L1822 1021L1821 1020z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M336 1021L337 1022L336 1021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98bbe2",
      stroke: "none"
    },
    d: "M472 1021L473 1022L472 1021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afcae9",
      stroke: "none"
    },
    d: "M1580 1021L1581 1022L1580 1021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1713 1021L1714 1022L1713 1021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4987cd",
      stroke: "none"
    },
    d: "M472 1022C479.879 1025.31 492.466 1023 501 1023L566 1023L793 1023L1580 1023C1572.12 1019.69 1559.53 1022 1551 1022L1486 1022L1259 1022L472 1022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4988ce",
      stroke: "none"
    },
    d: "M1580 1022C1569.48 1025.11 1555.95 1023 1545 1023L1473 1023L1239 1023L472 1023C476.609 1025.66 485.602 1024 491 1024L536 1024L703 1024L1318 1024L1518 1024L1566 1024C1568.58 1024 1581.3 1025.14 1580 1022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M227 1023L228 1024L227 1023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a89cf",
      stroke: "none"
    },
    d: "M471 1023C474.407 1026.9 484.099 1025 489 1025L540 1025L746 1025L1582 1025C1575.08 1022.1 1564.48 1024 1557 1024L1500 1024L1304 1024L735 1024L557 1024L501 1024C491.251 1024 480.521 1025.27 471 1023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8db5e0",
      stroke: "none"
    },
    d: "M1581 1023L1582 1024L1581 1023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1714 1023L1715 1024L1714 1023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1822 1023L1823 1024L1822 1023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M227 1024L228 1025L227 1024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M335 1024L336 1025L335 1024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5c4e7",
      stroke: "none"
    },
    d: "M470 1024L471 1025L470 1024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1714 1024L1715 1025L1714 1024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1822 1024L1823 1025L1822 1024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4b8bd1",
      stroke: "none"
    },
    d: "M470 1025C473.197 1028.66 481.423 1027 486 1027L530 1027L711 1027L1367 1027L1529 1027L1569 1027C1573.24 1027 1580.03 1028.4 1583 1025C1569.62 1028.19 1553.73 1026 1540 1026L1457 1026L1190 1026L699 1026L545 1026L497 1026C488.174 1026 478.624 1027.05 470 1025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4b8ad0",
      stroke: "none"
    },
    d: "M471 1025C478.879 1028.31 491.466 1026 500 1026L566 1026L793 1026L1582 1026C1574.12 1022.69 1561.53 1025 1553 1025L1487 1025L1260 1025L471 1025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8fb6e2",
      stroke: "none"
    },
    d: "M469 1026L470 1027L469 1026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0cceb",
      stroke: "none"
    },
    d: "M1583 1026L1584 1027L1583 1026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1715 1026L1716 1027L1715 1026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M226.333 1027.67C226.278 1027.72 226.222 1028.78 226.667 1028.33C226.722 1028.28 226.778 1027.22 226.333 1027.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M334 1027L335 1028L334 1027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8cd2",
      stroke: "none"
    },
    d: "M469 1027C476.879 1030.31 489.466 1028 498 1028L564 1028L792 1028L1583 1028C1575.12 1024.69 1562.53 1027 1554 1027L1488 1027L1260 1027L469 1027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8dd2",
      stroke: "none"
    },
    d: "M1583 1027C1572.48 1030.11 1558.95 1028 1548 1028L1476 1028L1240 1028L469 1028C473.609 1030.66 482.602 1029 488 1029L533 1029L702 1029L1320 1029L1521 1029L1569 1029C1571.58 1029 1584.3 1030.14 1583 1027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1715 1027L1716 1028L1715 1027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1823.33 1027.67C1823.28 1027.72 1823.22 1028.78 1823.67 1028.33C1823.72 1028.28 1823.78 1027.22 1823.33 1027.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d8ed3",
      stroke: "none"
    },
    d: "M468 1028C471.407 1031.9 481.099 1030 486 1030L537 1030L745 1030L1585 1030C1578.08 1027.1 1567.48 1029 1560 1029L1503 1029L1306 1029L734 1029L554 1029L498 1029C488.251 1029 477.521 1030.27 468 1028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8fb8e3",
      stroke: "none"
    },
    d: "M1584 1028L1585 1029L1584 1028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M226 1029L227 1030L226 1029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcd5ef",
      stroke: "none"
    },
    d: "M467 1029L468 1030L467 1029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M333 1030L334 1031L333 1030z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e8fd5",
      stroke: "none"
    },
    d: "M467 1030C470.197 1033.66 478.423 1032 483 1032L528 1032L709 1032L1369 1032L1532 1032L1572 1032C1576.24 1032 1583.03 1033.4 1586 1030C1577.38 1032.05 1567.83 1031 1559 1031L1511 1031L1356 1031L862 1031L594 1031L510 1031C496.271 1031 480.383 1033.19 467 1030z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e8ed4",
      stroke: "none"
    },
    d: "M468 1030C475.879 1033.31 488.466 1031 497 1031L563 1031L792 1031L1585 1031C1577.12 1027.69 1564.53 1030 1556 1030L1490 1030L1261 1030L468 1030z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1716 1030L1717 1031L1716 1030M225.333 1031.67C225.278 1031.72 225.222 1032.78 225.667 1032.33C225.722 1032.28 225.778 1031.22 225.333 1031.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7c7ea",
      stroke: "none"
    },
    d: "M466 1031L467 1032L466 1031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1824 1031L1825 1032L1824 1031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5091d7",
      stroke: "none"
    },
    d: "M466 1032C469.197 1035.66 477.423 1034 482 1034L527 1034L708 1034L1369 1034L1532 1034L1572 1034C1576.41 1034 1583.91 1035.53 1587 1032C1573.62 1035.19 1557.73 1033 1544 1033L1460 1033L1191 1033L696 1033L541 1033L493 1033C484.174 1033 474.624 1034.05 466 1032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f90d6",
      stroke: "none"
    },
    d: "M467 1032C474.879 1035.31 487.466 1033 496 1033L562 1033L791 1033L1586 1033C1578.12 1029.69 1565.53 1032 1557 1032L1491 1032L1262 1032L467 1032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1824 1032L1825 1033L1824 1032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284685",
      stroke: "none"
    },
    d: "M225.333 1033.67C225.278 1033.72 225.222 1034.78 225.667 1034.33C225.722 1034.28 225.778 1033.22 225.333 1033.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M332 1033L333 1034L332 1033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91bae6",
      stroke: "none"
    },
    d: "M465 1033L466 1034L465 1033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd6f0",
      stroke: "none"
    },
    d: "M1587 1033L1588 1034L1587 1033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1717 1033L1718 1034L1717 1033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M332 1034L333 1035L332 1034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5092d8",
      stroke: "none"
    },
    d: "M465 1034C472.879 1037.31 485.466 1035 494 1035L560 1035L790 1035L1587 1035C1579.12 1031.69 1566.53 1034 1558 1034L1492 1034L1262 1034L465 1034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5193d9",
      stroke: "none"
    },
    d: "M1587 1034C1576.2 1037.19 1562.25 1035 1551 1035L1479 1035L1242 1035L465 1035C469.609 1037.66 478.602 1036 484 1036L530 1036L699 1036L1322 1036L1525 1036L1573 1036C1575.58 1036 1588.3 1037.14 1587 1034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1717 1034L1718 1035L1717 1034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92bce7",
      stroke: "none"
    },
    d: "M464 1035L465 1036L464 1035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8c9ec",
      stroke: "none"
    },
    d: "M1588 1035L1589 1036L1588 1035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1825.33 1035.67C1825.28 1035.72 1825.22 1036.78 1825.67 1036.33C1825.72 1036.28 1825.78 1035.22 1825.33 1035.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M224.333 1036.67C224.278 1036.72 224.222 1037.78 224.667 1037.33C224.722 1037.28 224.778 1036.22 224.333 1036.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M331 1036L332 1037L331 1036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5294da",
      stroke: "none"
    },
    d: "M464 1036C471.879 1039.31 484.466 1037 493 1037L560 1037L790 1037L1588 1037C1580.12 1033.69 1567.53 1036 1559 1036L1492 1036L1262 1036L464 1036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5295db",
      stroke: "none"
    },
    d: "M1588 1036C1577.2 1039.19 1563.25 1037 1552 1037L1480 1037L1242 1037L464 1037C468.609 1039.66 477.602 1038 483 1038L529 1038L698 1038L1322 1038L1525 1038L1574 1038C1576.58 1038 1589.3 1039.14 1588 1036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1718 1036L1719 1037L1718 1036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M331 1037L332 1038L331 1037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5396db",
      stroke: "none"
    },
    d: "M463 1037C466.407 1040.9 476.099 1039 481 1039L533 1039L742 1039L1589 1039C1581.84 1036 1570.74 1038 1563 1038L1506 1038L1308 1038L731 1038L550 1038L494 1038C483.944 1038 472.819 1039.34 463 1037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9caed",
      stroke: "none"
    },
    d: "M1589 1037L1590 1038L1589 1037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1718 1037L1719 1038L1718 1037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284685",
      stroke: "none"
    },
    d: "M1825.33 1037.67C1825.28 1037.72 1825.22 1038.78 1825.67 1038.33C1825.72 1038.28 1825.78 1037.22 1825.33 1037.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M224 1038L225 1039L224 1038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5497dc",
      stroke: "none"
    },
    d: "M1589 1038C1578.2 1041.19 1564.25 1039 1553 1039L1481 1039L1243 1039L463 1039C467.61 1041.66 476.602 1040 482 1040L528 1040L698 1040L1323 1040L1526 1040L1575 1040C1577.58 1040 1590.3 1041.14 1589 1038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5498dd",
      stroke: "none"
    },
    d: "M462 1039C465.407 1042.9 475.099 1041 480 1041L532 1041L741 1041L1590 1041C1582.84 1038 1571.74 1040 1564 1040L1507 1040L1308 1040L730 1040L549 1040L493 1040C482.944 1040 471.819 1041.34 462 1039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9cbee",
      stroke: "none"
    },
    d: "M1590 1039L1591 1040L1590 1039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M223.333 1040.67C223.278 1040.72 223.222 1041.78 223.667 1041.33C223.722 1041.28 223.778 1040.22 223.333 1040.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M330 1040L331 1041L330 1040z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5599de",
      stroke: "none"
    },
    d: "M1590 1040C1579.2 1043.19 1565.25 1041 1554 1041L1482 1041L1243 1041L462 1041C466.609 1043.66 475.602 1042 481 1042L527 1042L697 1042L1323 1042L1527 1042L1576 1042C1578.58 1042 1591.3 1043.14 1590 1040z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1719 1040L1720 1041L1719 1040z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1826 1040L1827 1041L1826 1040z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M330 1041L331 1042L330 1041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#559adf",
      stroke: "none"
    },
    d: "M461 1041C464.407 1044.9 474.099 1043 479 1043L531 1043L741 1043L1591 1043C1583.84 1040 1572.74 1042 1565 1042L1508 1042L1309 1042L730 1042L548 1042L492 1042C481.944 1042 470.819 1043.34 461 1041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aaccef",
      stroke: "none"
    },
    d: "M1591 1041L1592 1042L1591 1041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1719 1041L1720 1042L1719 1041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1826.33 1041.67C1826.28 1041.72 1826.22 1042.78 1826.67 1042.33C1826.72 1042.28 1826.78 1041.22 1826.33 1041.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M223.333 1042.67C223.278 1042.72 223.222 1043.78 223.667 1043.33C223.722 1043.28 223.778 1042.22 223.333 1042.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#569be0",
      stroke: "none"
    },
    d: "M1591 1042C1580.2 1045.19 1566.25 1043 1555 1043L1482 1043L1243 1043L461 1043C465.609 1045.66 474.602 1044 480 1044L526 1044L697 1044L1324 1044L1528 1044L1577 1044C1579.58 1044 1592.3 1045.14 1591 1042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95c0ec",
      stroke: "none"
    },
    d: "M460 1043L461 1044L460 1043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5d3f1",
      stroke: "none"
    },
    d: "M1592 1043L1593 1044L1592 1043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1720 1043L1721 1044L1720 1043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M329 1044L330 1045L329 1044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#579be1",
      stroke: "none"
    },
    d: "M460 1044C467.879 1047.31 480.466 1045 489 1045L556 1045L788 1045L1592 1045C1584.12 1041.69 1571.53 1044 1563 1044L1496 1044L1264 1044L460 1044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#579ce2",
      stroke: "none"
    },
    d: "M1592 1044C1581.2 1047.19 1567.25 1045 1556 1045L1483 1045L1244 1045L460 1045C464.609 1047.66 473.602 1046 479 1046L525 1046L696 1046L1324 1046L1529 1046L1578 1046C1580.58 1046 1593.3 1047.14 1592 1044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1720 1044L1721 1045L1720 1044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M222 1045L222 1048C222.696 1046.45 222.696 1046.55 222 1045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M329 1045L330 1046L329 1045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#589de3",
      stroke: "none"
    },
    d: "M459 1045C462.407 1048.9 472.099 1047 477 1047L529 1047L740 1047L1593 1047C1585.84 1044 1574.74 1046 1567 1046L1510 1046L1310 1046L729 1046L547 1046L490 1046C479.944 1046 468.819 1047.34 459 1045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0daf4",
      stroke: "none"
    },
    d: "M1593 1045L1594 1046L1593 1045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1827 1045L1828 1046L1827 1045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#599ee4",
      stroke: "none"
    },
    d: "M1593 1046C1582.2 1049.19 1568.25 1047 1557 1047L1484 1047L1244 1047L459 1047C463.609 1049.66 472.602 1048 478 1048L525 1048L696 1048L1325 1048L1530 1048L1579 1048C1581.58 1048 1594.3 1049.14 1593 1046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1827.33 1046.67C1827.28 1046.72 1827.22 1047.78 1827.67 1047.33C1827.72 1047.28 1827.78 1046.22 1827.33 1046.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#accff1",
      stroke: "none"
    },
    d: "M458 1047L459 1048L458 1047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1721 1047L1722 1048L1721 1047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M328 1048L329 1049L328 1048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5aa0e5",
      stroke: "none"
    },
    d: "M458 1048C461.197 1051.66 469.423 1050 474 1050L520 1050L704 1050L1374 1050L1540 1050L1580 1050C1584.41 1050 1591.91 1051.53 1595 1048C1581.32 1051.26 1565.03 1049 1551 1049L1466 1049L1194 1049L692 1049L534 1049L485 1049C476.174 1049 466.624 1050.05 458 1048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#599fe4",
      stroke: "none"
    },
    d: "M459 1048C467.118 1051.41 480.203 1049 489 1049L556 1049L788 1049L1594 1049C1586.12 1045.69 1573.53 1048 1565 1048L1498 1048L1265 1048L459 1048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1721 1048L1722 1049L1721 1048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M328 1049L329 1050L328 1049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ba2e7",
      stroke: "none"
    },
    d: "M457 1050C460.407 1053.9 470.099 1052 475 1052L527 1052L739 1052L1595 1052C1587.84 1049 1576.74 1051 1569 1051L1511 1051L1310 1051L727 1051L545 1051L488 1051C477.944 1051 466.819 1052.34 457 1050z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ba1e6",
      stroke: "none"
    },
    d: "M458 1050C466.118 1053.41 479.203 1051 488 1051L555 1051L788 1051L1595 1051C1586.88 1047.59 1573.8 1050 1565 1050L1498 1050L1266 1050L458 1050z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ca3e8",
      stroke: "none"
    },
    d: "M1595 1050C1589.73 1054 1579.42 1052 1573 1052L1516 1052L1298 1052L457 1052C462.571 1054.69 471.812 1053 478 1053L528 1053L703 1053L1326 1053L1532 1053L1581 1053C1583.96 1053 1596.77 1054.7 1595 1050z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1828 1050L1828 1053C1828.7 1051.45 1828.7 1051.55 1828 1050z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M221 1051L222 1052L221 1051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1722.33 1051.67C1722.28 1051.72 1722.22 1052.78 1722.67 1052.33C1722.72 1052.28 1722.78 1051.22 1722.33 1051.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M221 1052L221 1055C221.696 1053.45 221.696 1053.55 221 1052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M327 1052L328 1053L327 1052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5da4e9",
      stroke: "none"
    },
    d: "M456 1052C459.407 1055.9 469.099 1054 474 1054L526 1054L738 1054L1596 1054C1588.84 1051 1577.74 1053 1570 1053L1512 1053L1311 1053L727 1053L544 1053L487 1053C476.944 1053 465.819 1054.34 456 1052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8d7f5",
      stroke: "none"
    },
    d: "M1596 1052L1597 1053L1596 1052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e5ee",
      stroke: "none"
    },
    d: "M327.333 1053.67C327.278 1053.72 327.222 1054.78 327.667 1054.33C327.722 1054.28 327.778 1053.22 327.333 1053.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5da5ea",
      stroke: "none"
    },
    d: "M1596 1053C1585.2 1056.19 1571.25 1054 1560 1054L1486 1054L1245 1054L456 1054C460.609 1056.66 469.602 1055 475 1055L522 1055L694 1055L1327 1055L1533 1055L1582 1055C1584.58 1055 1597.3 1056.14 1596 1053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1722 1053L1723 1054L1722 1053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5fa7ec",
      stroke: "none"
    },
    d: "M455 1054C456.064 1058.96 464.811 1057 469 1057L514 1057L704 1057L1383 1057L1546 1057L1585 1057C1588.78 1057 1595.98 1058.5 1598 1055C1588.18 1057.34 1577.06 1056 1567 1056L1511 1056L1330 1056L751 1056L538 1056L481 1056C473.007 1056 462.156 1057.98 455 1054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ea6eb",
      stroke: "none"
    },
    d: "M456 1055C464.118 1058.41 477.203 1056 486 1056L553 1056L787 1056L1597 1056C1588.88 1052.59 1575.8 1055 1567 1055L1500 1055L1266 1055L456 1055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1723.33 1055.67C1723.28 1055.72 1723.22 1056.78 1723.67 1056.33C1723.72 1056.28 1723.78 1055.22 1723.33 1055.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M326 1056L327 1057L326 1056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9bc8f4",
      stroke: "none"
    },
    d: "M454.333 1056.67C454.278 1056.72 454.222 1057.78 454.667 1057.33C454.722 1057.28 454.778 1056.22 454.333 1056.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1829 1056L1829 1059C1829.7 1057.45 1829.7 1057.55 1829 1056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M220 1057L221 1058L220 1057M326.333 1057.67C326.278 1057.72 326.222 1058.78 326.667 1058.33C326.722 1058.28 326.778 1057.22 326.333 1057.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5fa7ed",
      stroke: "none"
    },
    d: "M455 1057C463.118 1060.41 476.203 1058 485 1058L552 1058L786 1058L1598 1058C1589.88 1054.59 1576.8 1057 1568 1057L1501 1057L1266 1057L455 1057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60a9ee",
      stroke: "none"
    },
    d: "M1598 1057C1592.73 1061 1582.42 1059 1576 1059L1519 1059L1300 1059L454 1059C459.571 1061.69 468.812 1060 475 1060L525 1060L701 1060L1327 1060L1535 1060L1584 1060C1586.96 1060 1599.77 1061.7 1598 1057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e5ee",
      stroke: "none"
    },
    d: "M1723.33 1057.67C1723.28 1057.72 1723.22 1058.78 1723.67 1058.33C1723.72 1058.28 1723.78 1057.22 1723.33 1057.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M220 1058L220 1061C220.696 1059.45 220.696 1059.55 220 1058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60a8ed",
      stroke: "none"
    },
    d: "M454 1058C462.118 1061.41 475.203 1059 484 1059L551 1059L785 1059L1598 1059C1589.88 1055.59 1576.8 1058 1568 1058L1501 1058L1266 1058L454 1058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62abf0",
      stroke: "none"
    },
    d: "M453 1059C454.085 1064.06 463.712 1062 468 1062L516 1062L722 1062L1599 1062C1592.32 1059.2 1582.22 1061 1575 1061L1523 1061L1343 1061L718 1061L528 1061L476 1061C468.736 1061 459.518 1062.62 453 1059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M325.333 1060.67C325.278 1060.72 325.222 1061.78 325.667 1061.33C325.722 1061.28 325.778 1060.22 325.333 1060.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61aaef",
      stroke: "none"
    },
    d: "M454 1060C462.118 1063.41 475.203 1061 484 1061L551 1061L786 1061L1599 1061C1590.88 1057.59 1577.8 1060 1569 1060L1502 1060L1267 1060L454 1060z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62acf1",
      stroke: "none"
    },
    d: "M1599 1060C1593.73 1064 1583.42 1062 1577 1062L1520 1062L1300 1062L453 1062C458.571 1064.69 467.812 1063 474 1063L524 1063L700 1063L1328 1063L1536 1063L1585 1063C1587.96 1063 1600.77 1064.7 1599 1060z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1724.33 1060.67C1724.28 1060.72 1724.22 1061.78 1724.67 1061.33C1724.72 1061.28 1724.78 1060.22 1724.33 1060.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d7e5",
      stroke: "none"
    },
    d: "M325.333 1062.67C325.278 1062.72 325.222 1063.78 325.667 1063.33C325.722 1063.28 325.778 1062.22 325.333 1062.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63aef2",
      stroke: "none"
    },
    d: "M452 1062C453.085 1067.06 462.712 1065 467 1065L516 1065L722 1065L1600 1065C1593.32 1062.2 1583.22 1064 1576 1064L1524 1064L1344 1064L717 1064L527 1064L475 1064C467.736 1064 458.518 1065.62 452 1062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9eccf7",
      stroke: "none"
    },
    d: "M1600.33 1062.67C1600.28 1062.72 1600.22 1063.78 1600.67 1063.33C1600.72 1063.28 1600.78 1062.22 1600.33 1062.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1830 1062L1830 1065C1830.7 1063.45 1830.7 1063.55 1830 1062M219 1063L219 1066C219.696 1064.45 219.696 1064.55 219 1063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63adf2",
      stroke: "none"
    },
    d: "M453 1063C461.118 1066.41 474.203 1064 483 1064L551 1064L786 1064L1600 1064C1591.88 1060.59 1578.8 1063 1570 1063L1503 1063L1268 1063L453 1063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63aff2",
      stroke: "none"
    },
    d: "M1600 1064C1589.2 1067.19 1575.25 1065 1564 1065L1490 1065L1247 1065L452 1065C456.609 1067.66 465.602 1066 471 1066L518 1066L691 1066L1329 1066L1536 1066L1585 1066C1587.67 1066 1601.29 1067.11 1600 1064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M324 1065L324 1068C324.696 1066.45 324.696 1066.55 324 1065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64b1f3",
      stroke: "none"
    },
    d: "M451 1065C452.085 1070.06 461.712 1068 466 1068L515 1068L721 1068L1601 1068C1594.32 1065.2 1584.22 1067 1577 1067L1525 1067L1344 1067L716 1067L526 1067L474 1067C466.736 1067 457.518 1068.62 451 1065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ecef7",
      stroke: "none"
    },
    d: "M1601.33 1065.67C1601.28 1065.72 1601.22 1066.78 1601.67 1066.33C1601.72 1066.28 1601.78 1065.22 1601.33 1065.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1725.33 1065.67C1725.28 1065.72 1725.22 1066.78 1725.67 1066.33C1725.72 1066.28 1725.78 1065.22 1725.33 1065.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1830.33 1065.67C1830.28 1065.72 1830.22 1066.78 1830.67 1066.33C1830.72 1066.28 1830.78 1065.22 1830.33 1065.67M219.333 1066.67C219.278 1066.72 219.222 1067.78 219.667 1067.33C219.722 1067.28 219.778 1066.22 219.333 1066.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64b0f2",
      stroke: "none"
    },
    d: "M452 1066C460.118 1069.41 473.203 1067 482 1067L550 1067L785 1067L1601 1067C1592.88 1063.59 1579.8 1066 1571 1066L1503 1066L1268 1066L452 1066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64b2f3",
      stroke: "none"
    },
    d: "M1601 1067C1590.2 1070.19 1576.25 1068 1565 1068L1490 1068L1247 1068L451 1068C455.609 1070.66 464.602 1069 470 1069L517 1069L691 1069L1329 1069L1537 1069L1586 1069C1588.67 1069 1602.29 1070.11 1601 1067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e5ee",
      stroke: "none"
    },
    d: "M1725.33 1067.67C1725.28 1067.72 1725.22 1068.78 1725.67 1068.33C1725.72 1068.28 1725.78 1067.22 1725.33 1067.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M324 1068L325 1069L324 1068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64b4f3",
      stroke: "none"
    },
    d: "M450 1068C451.085 1073.06 460.712 1071 465 1071L514 1071L721 1071L1602 1071C1595.32 1068.2 1585.22 1070 1578 1070L1526 1070L1345 1070L716 1070L525 1070L473 1070C465.736 1070 456.518 1071.62 450 1068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64b3f3",
      stroke: "none"
    },
    d: "M451 1069C459.118 1072.41 472.203 1070 481 1070L549 1070L785 1070L1602 1070C1593.88 1066.59 1580.8 1069 1572 1069L1504 1069L1268 1069L451 1069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65b5f3",
      stroke: "none"
    },
    d: "M1602 1069C1596.57 1073.12 1585.63 1071 1579 1071L1522 1071L1301 1071L450 1071C455.571 1073.69 464.812 1072 471 1072L521 1072L698 1072L1329 1072L1538 1072L1588 1072C1590.96 1072 1603.77 1073.7 1602 1069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1831 1069L1831 1072C1831.7 1070.45 1831.7 1070.55 1831 1069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M218.333 1070.67C218.278 1070.72 218.222 1071.78 218.667 1071.33C218.722 1071.28 218.778 1070.22 218.333 1070.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1726 1070L1726 1073C1726.7 1071.45 1726.7 1071.55 1726 1070z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M323 1071L324 1072L323 1071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65b7f4",
      stroke: "none"
    },
    d: "M449 1071C450.085 1076.06 459.712 1074 464 1074L513 1074L720 1074L1603 1074C1596.32 1071.2 1586.22 1073 1579 1073L1527 1073L1345 1073L715 1073L524 1073L472 1073C464.736 1073 455.518 1074.62 449 1071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M218 1072L218 1075C218.696 1073.45 218.696 1073.55 218 1072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M323 1072L323 1075C323.696 1073.45 323.696 1073.55 323 1072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65b6f3",
      stroke: "none"
    },
    d: "M450 1072C458.118 1075.41 471.203 1073 480 1073L548 1073L784 1073L1603 1073C1594.88 1069.59 1581.8 1072 1573 1072L1505 1072L1268 1072L450 1072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65b8f4",
      stroke: "none"
    },
    d: "M1603 1072C1597.57 1076.12 1586.63 1074 1580 1074L1523 1074L1302 1074L449 1074C454.571 1076.69 463.812 1075 470 1075L520 1075L698 1075L1330 1075L1539 1075L1589 1075C1591.96 1075 1604.77 1076.7 1603 1072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1831.33 1072.67C1831.28 1072.72 1831.22 1073.78 1831.67 1073.33C1831.72 1073.28 1831.78 1072.22 1831.33 1072.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9fd3f8",
      stroke: "none"
    },
    d: "M448.333 1074.67C448.278 1074.72 448.222 1075.78 448.667 1075.33C448.722 1075.28 448.778 1074.22 448.333 1074.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66b9f4",
      stroke: "none"
    },
    d: "M449 1075C457.118 1078.41 470.203 1076 479 1076L547 1076L784 1076L1604 1076C1595.88 1072.59 1582.8 1075 1574 1075L1506 1075L1269 1075L449 1075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96cff7",
      stroke: "none"
    },
    d: "M1604.33 1075.67C1604.28 1075.72 1604.22 1076.78 1604.67 1076.33C1604.72 1076.28 1604.78 1075.22 1604.33 1075.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66baf4",
      stroke: "none"
    },
    d: "M448 1076L448 1078L1604 1078L1604 1076L448 1076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1727 1076L1727 1079C1727.7 1077.45 1727.7 1077.55 1727 1076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M322 1077L323 1078L322 1077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66bbf4",
      stroke: "none"
    },
    d: "M1604 1077C1592.92 1080.28 1578.54 1078 1567 1078L1493 1078L1249 1078L448 1078C452.609 1080.66 461.602 1079 467 1079L515 1079L689 1079L1331 1079L1540 1079L1589 1079C1591.67 1079 1605.29 1080.11 1604 1077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1832.33 1077.67C1832.28 1077.72 1832.22 1078.78 1832.67 1078.33C1832.72 1078.28 1832.78 1077.22 1832.33 1077.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M217.333 1078.67C217.278 1078.72 217.222 1079.78 217.667 1079.33C217.722 1079.28 217.778 1078.22 217.333 1078.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M322.333 1078.67C322.278 1078.72 322.222 1079.78 322.667 1079.33C322.722 1079.28 322.778 1078.22 322.333 1078.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ccdf7",
      stroke: "none"
    },
    d: "M447.333 1078.67C447.278 1078.72 447.222 1079.78 447.667 1079.33C447.722 1079.28 447.778 1078.22 447.333 1078.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3defa",
      stroke: "none"
    },
    d: "M1605 1078L1605 1081C1605.7 1079.45 1605.7 1079.55 1605 1078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66bcf4",
      stroke: "none"
    },
    d: "M448 1079C456.118 1082.41 469.203 1080 478 1080L546 1080L783 1080L1605 1080C1596.88 1076.59 1583.8 1079 1575 1079L1507 1079L1270 1079L448 1079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e5ee",
      stroke: "none"
    },
    d: "M1727.33 1079.67C1727.28 1079.72 1727.22 1080.78 1727.67 1080.33C1727.72 1080.28 1727.78 1079.22 1727.33 1079.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1832.33 1079.67C1832.28 1079.72 1832.22 1080.78 1832.67 1080.33C1832.72 1080.28 1832.78 1079.22 1832.33 1079.67M217.333 1080.67C217.278 1080.72 217.222 1081.78 217.667 1081.33C217.722 1081.28 217.778 1080.22 217.333 1080.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e5ee",
      stroke: "none"
    },
    d: "M322.333 1080.67C322.278 1080.72 322.222 1081.78 322.667 1081.33C322.722 1081.28 322.778 1080.22 322.333 1080.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67bdf5",
      stroke: "none"
    },
    d: "M447 1080C455.118 1083.41 468.203 1081 477 1081L546 1081L783 1081L1605 1081C1596.88 1077.59 1583.8 1080 1575 1080L1507 1080L1269 1080L447 1080z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67bef5",
      stroke: "none"
    },
    d: "M447 1081C455.118 1084.41 468.203 1082 477 1082L546 1082L783 1082L1606 1082C1597.88 1078.59 1584.8 1081 1576 1081L1507 1081L1270 1081L447 1081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1832.33 1081.67C1832.28 1081.72 1832.22 1082.78 1832.67 1082.33C1832.72 1082.28 1832.78 1081.22 1832.33 1081.67M217 1082L217 1085C217.696 1083.45 217.696 1083.55 217 1082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8dd0f8",
      stroke: "none"
    },
    d: "M446.333 1082.67C446.278 1082.72 446.222 1083.78 446.667 1083.33C446.722 1083.28 446.778 1082.22 446.333 1082.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67bff5",
      stroke: "none"
    },
    d: "M447 1082C455.118 1085.41 468.203 1083 477 1083L546 1083L783 1083L1606 1083C1597.88 1079.59 1584.8 1082 1576 1082L1507 1082L1270 1082L447 1082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3e0fa",
      stroke: "none"
    },
    d: "M1606.33 1082.67C1606.28 1082.72 1606.22 1083.78 1606.67 1083.33C1606.72 1083.28 1606.78 1082.22 1606.33 1082.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1728.33 1082.67C1728.28 1082.72 1728.22 1083.78 1728.67 1083.33C1728.72 1083.28 1728.78 1082.22 1728.33 1082.67M321.333 1083.67C321.278 1083.72 321.222 1084.78 321.667 1084.33C321.722 1084.28 321.778 1083.22 321.333 1083.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67c0f5",
      stroke: "none"
    },
    d: "M447 1083C455.118 1086.41 468.203 1084 477 1084L546 1084L783 1084L1606 1084C1597.88 1080.59 1584.8 1083 1576 1083L1507 1083L1270 1083L447 1083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67c1f5",
      stroke: "none"
    },
    d: "M446 1084C454.118 1087.41 467.203 1085 476 1085L545 1085L782 1085L1606 1085C1597.88 1081.59 1584.8 1084 1576 1084L1507 1084L1270 1084L446 1084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c2f5",
      stroke: "none"
    },
    d: "M1606 1084C1594.92 1087.28 1580.54 1085 1569 1085L1495 1085L1249 1085L446 1085C450.609 1087.66 459.602 1086 465 1086L513 1086L688 1086L1332 1086L1541 1086L1591 1086C1593.67 1086 1607.29 1087.11 1606 1084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1728.33 1084.67C1728.28 1084.72 1728.22 1085.78 1728.67 1085.33C1728.72 1085.28 1728.78 1084.22 1728.33 1084.67M321.333 1085.67C321.278 1085.72 321.222 1086.78 321.667 1086.33C321.722 1086.28 321.778 1085.22 321.333 1085.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bde5fb",
      stroke: "none"
    },
    d: "M445.333 1085.67C445.278 1085.72 445.222 1086.78 445.667 1086.33C445.722 1086.28 445.778 1085.22 445.333 1085.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c3f6",
      stroke: "none"
    },
    d: "M446 1086C454.118 1089.41 467.203 1087 476 1087L545 1087L783 1087L1607 1087C1598.88 1083.59 1585.8 1086 1577 1086L1508 1086L1270 1086L446 1086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1728.33 1086.67C1728.28 1086.72 1728.22 1087.78 1728.67 1087.33C1728.72 1087.28 1728.78 1086.22 1728.33 1086.67M1833 1086L1833 1089C1833.7 1087.45 1833.7 1087.55 1833 1086M216 1087L216 1090C216.696 1088.45 216.696 1088.55 216 1087M321.333 1087.67C321.278 1087.72 321.222 1088.78 321.667 1088.33C321.722 1088.28 321.778 1087.22 321.333 1087.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69c6f6",
      stroke: "none"
    },
    d: "M445 1087C446.085 1092.06 455.712 1090 460 1090L509 1090L718 1090L1607 1090C1600.32 1087.2 1590.22 1089 1583 1089L1531 1089L1348 1089L713 1089L521 1089L469 1089C461.492 1089 451.733 1090.74 445 1087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c4f6",
      stroke: "none"
    },
    d: "M446 1087C454.118 1090.41 467.203 1088 476 1088L545 1088L783 1088L1607 1088C1598.88 1084.59 1585.8 1087 1577 1087L1508 1087L1270 1087L446 1087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1dbf9",
      stroke: "none"
    },
    d: "M1607.33 1087.67C1607.28 1087.72 1607.22 1088.78 1607.67 1088.33C1607.72 1088.28 1607.78 1087.22 1607.33 1087.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68c5f6",
      stroke: "none"
    },
    d: "M446 1088C454.118 1091.41 467.203 1089 476 1089L545 1089L783 1089L1607 1089C1598.88 1085.59 1585.8 1088 1577 1088L1508 1088L1270 1088L446 1088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69c7f6",
      stroke: "none"
    },
    d: "M1607 1089C1595.92 1092.28 1581.54 1090 1570 1090L1496 1090L1250 1090L445 1090C449.609 1092.66 458.602 1091 464 1091L512 1091L687 1091L1332 1091L1542 1091L1592 1091C1594.67 1091 1608.29 1092.11 1607 1089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1833.33 1089.67C1833.28 1089.72 1833.22 1090.78 1833.67 1090.33C1833.72 1090.28 1833.78 1089.22 1833.33 1089.67M216 1090L216 1093C216.696 1091.45 216.696 1091.55 216 1090z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4e4fb",
      stroke: "none"
    },
    d: "M444.333 1090.67C444.278 1090.72 444.222 1091.78 444.667 1091.33C444.722 1091.28 444.778 1090.22 444.333 1090.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1729 1090L1729 1093C1729.7 1091.45 1729.7 1091.55 1729 1090M320 1091L320 1094C320.696 1092.45 320.696 1092.55 320 1091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69c8f6",
      stroke: "none"
    },
    d: "M445 1091C453.118 1094.41 466.203 1092 475 1092L544 1092L782 1092L1608 1092C1599.88 1088.59 1586.8 1091 1578 1091L1509 1091L1271 1091L445 1091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1833 1091L1833 1095C1833.71 1093.24 1833.71 1092.76 1833 1091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6acbf7",
      stroke: "none"
    },
    d: "M444 1092C445.103 1097.15 455.615 1095 460 1095L509 1095L718 1095L1608 1095C1601.32 1092.2 1591.22 1094 1584 1094L1531 1094L1348 1094L713 1094L520 1094L468 1094C460.492 1094 450.733 1095.74 444 1092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69c9f6",
      stroke: "none"
    },
    d: "M445 1092C453.118 1095.41 466.203 1093 475 1093L544 1093L782 1093L1608 1093C1599.88 1089.59 1586.8 1092 1578 1092L1509 1092L1271 1092L445 1092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98dafa",
      stroke: "none"
    },
    d: "M1608 1092L1608 1095C1608.7 1093.45 1608.7 1093.55 1608 1092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M216 1093L216 1096C216.696 1094.45 216.696 1094.55 216 1093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69caf7",
      stroke: "none"
    },
    d: "M445 1093C453.118 1096.41 466.203 1094 475 1094L544 1094L782 1094L1608 1094C1599.88 1090.59 1586.8 1093 1578 1093L1509 1093L1271 1093L445 1093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1729.33 1093.67C1729.28 1093.72 1729.22 1094.78 1729.67 1094.33C1729.72 1094.28 1729.78 1093.22 1729.33 1093.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M320.333 1094.67C320.278 1094.72 320.222 1095.78 320.667 1095.33C320.722 1095.28 320.778 1094.22 320.333 1094.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bee9fc",
      stroke: "none"
    },
    d: "M443.333 1095.67C443.278 1095.72 443.222 1096.78 443.667 1096.33C443.722 1096.28 443.778 1095.22 443.333 1095.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6accf7",
      stroke: "none"
    },
    d: "M444 1095C452.118 1098.41 465.203 1096 474 1096L543 1096L782 1096L1609 1096C1600.88 1092.59 1587.8 1095 1579 1095L1510 1095L1272 1095L444 1095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1729.33 1095.67C1729.28 1095.72 1729.22 1096.78 1729.67 1096.33C1729.72 1096.28 1729.78 1095.22 1729.33 1095.67M320 1096L320 1099C320.696 1097.45 320.696 1097.55 320 1096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6acdf7",
      stroke: "none"
    },
    d: "M444 1096C452.118 1099.41 465.203 1097 474 1097L543 1097L782 1097L1609 1097C1600.88 1093.59 1587.8 1096 1579 1096L1510 1096L1272 1096L444 1096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7edfc",
      stroke: "none"
    },
    d: "M1609 1096L1609 1099C1609.7 1097.45 1609.7 1097.55 1609 1096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6bd0f8",
      stroke: "none"
    },
    d: "M443 1097C444.103 1102.15 454.615 1100 459 1100L508 1100L717 1100L1609 1100C1602.32 1097.2 1592.22 1099 1585 1099L1532 1099L1349 1099L712 1099L519 1099L467 1099C459.492 1099 449.733 1100.74 443 1097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6acef7",
      stroke: "none"
    },
    d: "M444 1097C452.118 1100.41 465.203 1098 474 1098L543 1098L782 1098L1609 1098C1600.88 1094.59 1587.8 1097 1579 1097L1510 1097L1272 1097L444 1097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6acff7",
      stroke: "none"
    },
    d: "M444 1098C452.118 1101.41 465.203 1099 474 1099L543 1099L782 1099L1609 1099C1600.88 1095.59 1587.8 1098 1579 1098L1510 1098L1271 1098L444 1098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1834 1098L1834 1102C1834.71 1100.24 1834.71 1099.76 1834 1098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6bd2f8",
      stroke: "none"
    },
    d: "M1609 1099C1603.57 1103.12 1592.63 1101 1586 1101L1529 1101L1305 1101L443 1101C448.792 1103.8 458.562 1102 465 1102L515 1102L695 1102L1333 1102L1544 1102L1594 1102C1597.04 1102 1610.78 1103.73 1609 1099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M215 1100L215 1105C215.83 1102.97 215.83 1102.03 215 1100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6bd1f8",
      stroke: "none"
    },
    d: "M443 1100C451.118 1103.41 464.203 1101 473 1101L542 1101L781 1101L1609 1101C1600.88 1097.59 1587.8 1100 1579 1100L1510 1100L1271 1100L443 1100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1730 1100L1730 1103C1730.7 1101.45 1730.7 1101.55 1730 1100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8eefc",
      stroke: "none"
    },
    d: "M442 1101L442 1104C442.696 1102.45 442.696 1102.55 442 1101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M319 1102L319 1105C319.696 1103.45 319.696 1103.55 319 1102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6bd3f8",
      stroke: "none"
    },
    d: "M443 1102C451.118 1105.41 464.203 1103 473 1103L542 1103L781 1103L1610 1103C1601.88 1099.59 1588.8 1102 1580 1102L1511 1102L1272 1102L443 1102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6eafc",
      stroke: "none"
    },
    d: "M1610 1102L1610 1106C1610.71 1104.24 1610.71 1103.76 1610 1102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1834 1102L1834 1107C1834.83 1104.97 1834.83 1104.03 1834 1102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6bd4f8",
      stroke: "none"
    },
    d: "M443 1103C451.118 1106.41 464.203 1104 473 1104L542 1104L781 1104L1610 1104C1601.88 1100.59 1588.8 1103 1580 1103L1511 1103L1272 1103L443 1103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1730 1103L1730 1107C1730.71 1105.24 1730.71 1104.76 1730 1103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6cd6f9",
      stroke: "none"
    },
    d: "M442 1104C443.103 1109.15 453.615 1107 458 1107L507 1107L717 1107L1610 1107C1603.32 1104.2 1593.22 1106 1586 1106L1533 1106L1349 1106L712 1106L518 1106L466 1106C458.492 1106 448.733 1107.74 442 1104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6cd5f8",
      stroke: "none"
    },
    d: "M443 1104L443 1106L1610 1106L1610 1104L443 1104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M215 1105L215 1110C215.83 1107.97 215.83 1107.03 215 1105M319 1105L319 1109C319.71 1107.24 319.71 1106.76 319 1105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6dd8f9",
      stroke: "none"
    },
    d: "M1610 1106C1604.57 1110.12 1593.63 1108 1587 1108L1529 1108L1305 1108L442 1108C447.792 1110.8 457.562 1109 464 1109L514 1109L694 1109L1334 1109L1545 1109L1595 1109C1598.04 1109 1611.78 1110.73 1610 1106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6cd7f9",
      stroke: "none"
    },
    d: "M442 1107C450.118 1110.41 463.203 1108 472 1108L541 1108L780 1108L1610 1108C1601.88 1104.59 1588.8 1107 1580 1107L1511 1107L1271 1107L442 1107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1730 1107L1730 1111C1730.71 1109.24 1730.71 1108.76 1730 1107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1834 1107L1834 1113C1834.95 1110.71 1834.95 1109.29 1834 1107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M319 1109L319 1114C319.83 1111.97 319.83 1111.03 319 1109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6dd9f9",
      stroke: "none"
    },
    d: "M442 1109C450.118 1112.41 463.203 1110 472 1110L541 1110L781 1110L1611 1110C1602.88 1106.59 1589.8 1109 1581 1109L1512 1109L1272 1109L442 1109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M215 1110L215 1118C216.161 1115.23 216.161 1112.77 215 1110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92e6fb",
      stroke: "none"
    },
    d: "M441 1110L441 1116C441.951 1113.71 441.951 1112.29 441 1110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6ddaf9",
      stroke: "none"
    },
    d: "M442 1110C450.118 1113.41 463.203 1111 472 1111L541 1111L781 1111L1611 1111C1602.88 1107.59 1589.8 1110 1581 1110L1512 1110L1272 1110L442 1110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7effd",
      stroke: "none"
    },
    d: "M1611 1110L1611 1116C1611.95 1113.71 1611.95 1112.29 1611 1110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6ddbf9",
      stroke: "none"
    },
    d: "M442 1111C450.118 1114.41 463.203 1112 472 1112L541 1112L781 1112L1611 1112C1602.88 1108.59 1589.8 1111 1581 1111L1512 1111L1272 1111L442 1111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6ddcf9",
      stroke: "none"
    },
    d: "M442 1112C450.118 1115.41 463.203 1113 472 1113L541 1113L781 1113L1611 1113C1602.88 1109.59 1589.8 1112 1581 1112L1512 1112L1272 1112L442 1112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6eddfa",
      stroke: "none"
    },
    d: "M442 1113C450.118 1116.41 463.203 1114 472 1114L541 1114L781 1114L1611 1114C1602.88 1110.59 1589.8 1113 1581 1113L1512 1113L1272 1113L442 1113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6edefa",
      stroke: "none"
    },
    d: "M442 1114C450.118 1117.41 463.203 1115 472 1115L541 1115L781 1115L1611 1115C1602.88 1111.59 1589.8 1114 1581 1114L1512 1114L1272 1114L442 1114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6edffa",
      stroke: "none"
    },
    d: "M442 1115C450.118 1118.41 463.203 1116 472 1116L541 1116L781 1116L1611 1116C1602.88 1112.59 1589.8 1115 1581 1115L1512 1115L1272 1115L442 1115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6ee0fa",
      stroke: "none"
    },
    d: "M441 1116C449.118 1119.41 462.203 1117 471 1117L540 1117L780 1117L1611 1117C1602.88 1113.59 1589.8 1116 1581 1116L1512 1116L1272 1116L441 1116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fe4fb",
      stroke: "none"
    },
    d: "M1611 1116L1611 1120L441 1120C449.118 1123.41 462.203 1121 471 1121L540 1121L780 1121L1612 1121C1611.91 1119.04 1611.78 1117.77 1611 1116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6ee1fa",
      stroke: "none"
    },
    d: "M441 1117C449.118 1120.41 462.203 1118 471 1118L540 1118L780 1118L1611 1118C1602.88 1114.59 1589.8 1117 1581 1117L1512 1117L1272 1117L441 1117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1731 1117L1731 1138C1733.15 1132.87 1733.15 1122.13 1731 1117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fe2fa",
      stroke: "none"
    },
    d: "M441 1118C449.118 1121.41 462.203 1119 471 1119L540 1119L780 1119L1611 1119C1602.88 1115.59 1589.8 1118 1581 1118L1512 1118L1272 1118L441 1118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fe3fb",
      stroke: "none"
    },
    d: "M441 1119C449.118 1122.41 462.203 1120 471 1120L540 1120L780 1120L1611 1120C1602.88 1116.59 1589.8 1119 1581 1119L1512 1119L1272 1119L441 1119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbf9fe",
      stroke: "none"
    },
    d: "M440 1120L440 1125C440.83 1122.97 440.83 1122.03 440 1120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fe5fb",
      stroke: "none"
    },
    d: "M441 1121C449.118 1124.41 462.203 1122 471 1122L540 1122L780 1122L1612 1122C1603.64 1118.49 1590.06 1121 1581 1121L1512 1121L1272 1121L441 1121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fe6fb",
      stroke: "none"
    },
    d: "M441 1122C449.118 1125.41 462.203 1123 471 1123L540 1123L780 1123L1612 1123C1603.64 1119.49 1590.06 1122 1581 1122L1512 1122L1272 1122L441 1122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M318 1123L318 1132C319.256 1129.01 319.256 1125.99 318 1123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70e7fb",
      stroke: "none"
    },
    d: "M441 1123C449.118 1126.41 462.203 1124 471 1124L540 1124L780 1124L1612 1124C1603.88 1120.59 1590.8 1123 1582 1123L1513 1123L1273 1123L441 1123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70e8fb",
      stroke: "none"
    },
    d: "M441 1124C449.118 1127.41 462.203 1125 471 1125L540 1125L780 1125L1612 1125C1603.88 1121.59 1590.8 1124 1582 1124L1513 1124L1273 1124L441 1124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcfbfe",
      stroke: "none"
    },
    d: "M1612 1124L1612 1140C1613.81 1135.68 1613.81 1128.32 1612 1124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9f8fe",
      stroke: "none"
    },
    d: "M440 1125L440 1140C441.74 1135.85 441.74 1129.15 440 1125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70e9fb",
      stroke: "none"
    },
    d: "M441 1125C449.118 1128.41 462.203 1126 471 1126L540 1126L780 1126L1612 1126C1603.64 1122.49 1590.06 1125 1581 1125L1512 1125L1273 1125L441 1125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70eafc",
      stroke: "none"
    },
    d: "M441 1126C449.118 1129.41 462.203 1127 471 1127L540 1127L780 1127L1612 1127C1603.64 1123.49 1590.06 1126 1581 1126L1512 1126L1273 1126L441 1126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71ebfc",
      stroke: "none"
    },
    d: "M441 1127C449.118 1130.41 462.203 1128 471 1128L540 1128L780 1128L1612 1128C1603.88 1124.59 1590.8 1127 1582 1127L1513 1127L1273 1127L441 1127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71ecfc",
      stroke: "none"
    },
    d: "M441 1128C449.118 1131.41 462.203 1129 471 1129L540 1129L780 1129L1612 1129C1603.88 1125.59 1590.8 1128 1582 1128L1513 1128L1273 1128L441 1128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71edfc",
      stroke: "none"
    },
    d: "M441 1129C449.118 1132.41 462.203 1130 471 1130L540 1130L780 1130L1612 1130C1603.88 1126.59 1590.8 1129 1582 1129L1513 1129L1273 1129L441 1129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71eefc",
      stroke: "none"
    },
    d: "M441 1130C449.118 1133.41 462.203 1131 471 1131L540 1131L780 1131L1612 1131C1603.88 1127.59 1590.8 1130 1582 1130L1513 1130L1273 1130L441 1130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71effc",
      stroke: "none"
    },
    d: "M441 1131C449.118 1134.41 462.203 1132 471 1132L540 1132L780 1132L1612 1132C1603.64 1128.49 1590.06 1131 1581 1131L1512 1131L1272 1131L441 1131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72f0fd",
      stroke: "none"
    },
    d: "M441 1132C449.118 1135.41 462.203 1133 471 1133L540 1133L780 1133L1612 1133C1603.64 1129.49 1590.06 1132 1581 1132L1512 1132L1273 1132L441 1132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72f1fd",
      stroke: "none"
    },
    d: "M441 1133L441 1135L1612 1135L1612 1133L441 1133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72f2fd",
      stroke: "none"
    },
    d: "M441 1135C449.118 1138.41 462.203 1136 471 1136L540 1136L780 1136L1612 1136C1603.88 1132.59 1590.8 1135 1582 1135L1513 1135L1273 1135L441 1135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72f3fd",
      stroke: "none"
    },
    d: "M441 1136C449.118 1139.41 462.203 1137 471 1137L540 1137L780 1137L1612 1137C1603.88 1133.59 1590.8 1136 1582 1136L1513 1136L1273 1136L441 1136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73f4fd",
      stroke: "none"
    },
    d: "M441 1137C449.118 1140.41 462.203 1138 471 1138L540 1138L780 1138L1612 1138C1603.64 1134.49 1590.06 1137 1581 1137L1512 1137L1273 1137L441 1137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M215 1138L215 1146C216.161 1143.23 216.161 1140.77 215 1138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73f5fd",
      stroke: "none"
    },
    d: "M441 1138C449.357 1141.51 462.94 1139 472 1139L541 1139L781 1139L1612 1139C1603.88 1135.59 1590.8 1138 1582 1138L1513 1138L1273 1138L441 1138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73f6fe",
      stroke: "none"
    },
    d: "M441 1139C449.118 1142.41 462.203 1140 471 1140L540 1140L780 1140L1612 1140C1603.88 1136.59 1590.8 1139 1582 1139L1513 1139L1273 1139L441 1139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcfeff",
      stroke: "none"
    },
    d: "M440 1140L440 1145C440.83 1142.97 440.83 1142.03 440 1140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73f7fe",
      stroke: "none"
    },
    d: "M441 1140C449.118 1143.41 462.203 1141 471 1141L540 1141L780 1141L1612 1141C1603.64 1137.49 1590.06 1140 1581 1140L1512 1140L1272 1140L441 1140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M319 1141L319 1147C319.951 1144.71 319.951 1143.29 319 1141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74f8fe",
      stroke: "none"
    },
    d: "M441 1141C449.118 1144.41 462.203 1142 471 1142L540 1142L780 1142L1612 1142C1603.88 1138.59 1590.8 1141 1582 1141L1513 1141L1273 1141L441 1141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74f9fe",
      stroke: "none"
    },
    d: "M441 1142C449.357 1145.51 462.94 1143 472 1143L541 1143L781 1143L1612 1143C1603.88 1139.59 1590.8 1142 1582 1142L1513 1142L1273 1142L441 1142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74fafe",
      stroke: "none"
    },
    d: "M441 1143C449.357 1146.51 462.94 1144 472 1144L541 1144L781 1144L1612 1144C1603.88 1140.59 1590.8 1143 1582 1143L1513 1143L1273 1143L441 1143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1834 1143L1834 1149C1834.95 1146.71 1834.95 1145.29 1834 1143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74fbfe",
      stroke: "none"
    },
    d: "M441 1144C449.118 1147.41 462.203 1145 471 1145L540 1145L780 1145L1612 1145C1603.88 1141.59 1590.8 1144 1582 1144L1513 1144L1273 1144L441 1144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74fcff",
      stroke: "none"
    },
    d: "M441 1145C449.118 1148.41 462.203 1146 471 1146L540 1146L780 1146L1611 1146C1602.88 1142.59 1589.8 1145 1581 1145L1512 1145L1272 1145L441 1145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97feff",
      stroke: "none"
    },
    d: "M1611 1145L1611 1149C1611.71 1147.24 1611.71 1146.76 1611 1145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1730 1145L1730 1149C1730.71 1147.24 1730.71 1146.76 1730 1145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M215 1146L215 1151C215.83 1148.97 215.83 1148.03 215 1146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75fdff",
      stroke: "none"
    },
    d: "M441 1146C449.118 1149.41 462.203 1147 471 1147L540 1147L780 1147L1611 1147C1602.88 1143.59 1589.8 1146 1581 1146L1512 1146L1272 1146L441 1146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M319 1147L319 1150C319.696 1148.45 319.696 1148.55 319 1147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75feff",
      stroke: "none"
    },
    d: "M441 1147C449.118 1150.41 462.203 1148 471 1148L540 1148L780 1148L1611 1148C1602.88 1144.59 1589.8 1147 1581 1147L1512 1147L1272 1147L441 1147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75ffff",
      stroke: "none"
    },
    d: "M441 1148C449.118 1151.41 462.203 1149 471 1149L540 1149L780 1149L1611 1149C1602.88 1145.59 1589.8 1148 1581 1148L1512 1148L1272 1148L441 1148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9fcfe",
      stroke: "none"
    },
    d: "M441 1149L441 1157C442.161 1154.23 442.161 1151.77 441 1149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75feff",
      stroke: "none"
    },
    d: "M442 1149C450.118 1152.41 463.203 1150 472 1150L541 1150L781 1150L1611 1150C1602.88 1146.59 1589.8 1149 1581 1149L1512 1149L1272 1149L442 1149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcfdfe",
      stroke: "none"
    },
    d: "M1611 1149L1611 1154C1611.83 1151.97 1611.83 1151.03 1611 1149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1730 1149L1730 1152C1730.7 1150.45 1730.7 1150.55 1730 1149M1834 1149L1834 1154C1834.83 1151.97 1834.83 1151.03 1834 1149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M319 1150L319 1154C319.71 1152.24 319.71 1151.76 319 1150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74fcfe",
      stroke: "none"
    },
    d: "M442 1150C450.118 1153.41 463.203 1151 472 1151L541 1151L781 1151L1611 1151C1602.88 1147.59 1589.8 1150 1581 1150L1512 1150L1272 1150L442 1150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M215 1151L215 1155C215.71 1153.24 215.71 1152.76 215 1151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74fbfe",
      stroke: "none"
    },
    d: "M442 1151C450.118 1154.41 463.203 1152 472 1152L541 1152L781 1152L1611 1152C1602.88 1148.59 1589.8 1151 1581 1151L1512 1151L1272 1151L442 1151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73f9fd",
      stroke: "none"
    },
    d: "M442 1152C450.118 1155.41 463.203 1153 472 1153L541 1153L781 1153L1611 1153C1602.88 1149.59 1589.8 1152 1581 1152L1512 1152L1272 1152L442 1152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1730 1152L1730 1155C1730.7 1153.45 1730.7 1153.55 1730 1152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73f8fd",
      stroke: "none"
    },
    d: "M442 1153C450.118 1156.41 463.203 1154 472 1154L541 1154L781 1154L1611 1154C1602.88 1150.59 1589.8 1153 1581 1153L1512 1153L1272 1153L442 1153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72f6fc",
      stroke: "none"
    },
    d: "M442 1154C450.118 1157.41 463.203 1155 472 1155L541 1155L781 1155L1611 1155C1602.88 1151.59 1589.8 1154 1581 1154L1512 1154L1272 1154L442 1154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1834 1154L1834 1157C1834.7 1155.45 1834.7 1155.55 1834 1154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72f5fc",
      stroke: "none"
    },
    d: "M442 1155C449.399 1158.1 460.993 1156 469 1156L528 1156L734 1156L1333 1156L1521 1156L1579 1156C1589.36 1156 1600.88 1154.59 1611 1157C1607.49 1152.99 1597.06 1155 1592 1155L1539 1155L1322 1155L442 1155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71f3fb",
      stroke: "none"
    },
    d: "M442 1156C450.118 1159.41 463.203 1157 472 1157L541 1157L781 1157L1610 1157C1601.88 1153.59 1588.8 1156 1580 1156L1511 1156L1271 1156L442 1156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M320 1157L320 1160C320.696 1158.45 320.696 1158.55 320 1157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71f2fb",
      stroke: "none"
    },
    d: "M442 1159C454.79 1155.95 469.882 1158 483 1158L561 1158L811 1158L1610 1158C1603.32 1155.2 1593.22 1157 1586 1157L1533 1157L1350 1157L713 1157L510 1157L460 1157C455.099 1157 445.407 1155.1 442 1159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9f8fd",
      stroke: "none"
    },
    d: "M1610 1157L1610 1162C1610.83 1159.97 1610.83 1159.03 1610 1157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70f0fa",
      stroke: "none"
    },
    d: "M443 1158C451.118 1161.41 464.203 1159 473 1159L542 1159L781 1159L1610 1159C1601.88 1155.59 1588.8 1158 1580 1158L1511 1158L1272 1158L443 1158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1729 1158L1729 1161C1729.7 1159.45 1729.7 1159.55 1729 1158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M216 1159L216 1163C216.71 1161.24 216.71 1160.76 216 1159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5f4fb",
      stroke: "none"
    },
    d: "M442 1159L442 1162C442.696 1160.45 442.696 1160.55 442 1159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70eefa",
      stroke: "none"
    },
    d: "M443 1159C451.118 1162.41 464.203 1160 473 1160L542 1160L781 1160L1610 1160C1601.88 1156.59 1588.8 1159 1580 1159L1511 1159L1272 1159L443 1159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M320.333 1160.67C320.278 1160.72 320.222 1161.78 320.667 1161.33C320.722 1161.28 320.778 1160.22 320.333 1160.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fedf9",
      stroke: "none"
    },
    d: "M443 1160C451.118 1163.41 464.203 1161 473 1161L542 1161L781 1161L1610 1161C1601.88 1157.59 1588.8 1160 1580 1160L1511 1160L1272 1160L443 1160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6febf9",
      stroke: "none"
    },
    d: "M443 1161C451.118 1164.41 464.203 1162 473 1162L542 1162L781 1162L1610 1162C1601.88 1158.59 1588.8 1161 1580 1161L1511 1161L1272 1161L443 1161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1729.33 1161.67C1729.28 1161.72 1729.22 1162.78 1729.67 1162.33C1729.72 1162.28 1729.78 1161.22 1729.33 1161.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1833 1161L1833 1164C1833.7 1162.45 1833.7 1162.55 1833 1161M320.333 1162.67C320.278 1162.72 320.222 1163.78 320.667 1163.33C320.723 1163.28 320.778 1162.22 320.333 1162.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6eeaf8",
      stroke: "none"
    },
    d: "M443 1162C451.118 1165.41 464.203 1163 473 1163L542 1163L781 1163L1610 1163C1601.88 1159.59 1588.8 1162 1580 1162L1511 1162L1272 1162L443 1162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M216 1163L216 1166C216.696 1164.45 216.696 1164.55 216 1163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6ee8f8",
      stroke: "none"
    },
    d: "M443 1163C451.118 1166.41 464.203 1164 473 1164L542 1164L781 1164L1610 1164C1601.88 1160.59 1588.8 1163 1580 1163L1511 1163L1272 1163L443 1163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1729.33 1163.67C1729.28 1163.72 1729.22 1164.78 1729.67 1164.33C1729.72 1164.28 1729.78 1163.22 1729.33 1163.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6de7f7",
      stroke: "none"
    },
    d: "M443 1167C450.366 1162.9 461.767 1165 470 1165L533 1165L764 1165L1609 1165C1604.2 1162.23 1594.63 1164 1589 1164L1541 1164L1363 1164L709 1164L506 1164L458 1164C453.712 1164 444.085 1161.94 443 1167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4effa",
      stroke: "none"
    },
    d: "M1609 1164L1609 1167C1609.7 1165.45 1609.7 1165.55 1609 1164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1833 1164L1833 1167C1833.7 1165.45 1833.7 1165.55 1833 1164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6de5f7",
      stroke: "none"
    },
    d: "M444 1165C452.118 1168.41 465.203 1166 474 1166L543 1166L782 1166L1609 1166C1600.88 1162.59 1587.8 1165 1579 1165L1510 1165L1272 1165L444 1165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M216.333 1166.67C216.278 1166.72 216.222 1167.78 216.667 1167.33C216.722 1167.28 216.778 1166.22 216.333 1166.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6ce4f6",
      stroke: "none"
    },
    d: "M444 1166C452.118 1169.41 465.203 1167 474 1167L543 1167L782 1167L1609 1167C1600.88 1163.59 1587.8 1166 1579 1166L1510 1166L1271 1166L444 1166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M321 1167L321 1170C321.696 1168.45 321.696 1168.55 321 1167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8f4fb",
      stroke: "none"
    },
    d: "M443 1167L443 1170C443.696 1168.45 443.696 1168.55 443 1167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6ce2f6",
      stroke: "none"
    },
    d: "M444 1167C452.118 1170.41 465.203 1168 474 1168L543 1168L782 1168L1609 1168C1600.88 1164.59 1587.8 1167 1579 1167L1510 1167L1271 1167L444 1167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1833 1167L1833 1170C1833.7 1168.45 1833.7 1168.55 1833 1167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6be1f5",
      stroke: "none"
    },
    d: "M444 1168C452.118 1171.41 465.203 1169 474 1169L543 1169L782 1169L1609 1169C1600.88 1165.59 1587.8 1168 1579 1168L1510 1168L1272 1168L444 1168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1728.33 1168.67C1728.28 1168.72 1728.22 1169.78 1728.67 1169.33C1728.72 1169.28 1728.78 1168.22 1728.33 1168.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6bdff5",
      stroke: "none"
    },
    d: "M444 1169C452.118 1172.41 465.203 1170 474 1170L543 1170L782 1170L1609 1170C1600.88 1166.59 1587.8 1169 1579 1169L1510 1169L1272 1169L444 1169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M321.333 1170.67C321.278 1170.72 321.222 1171.78 321.667 1171.33C321.722 1171.28 321.778 1170.22 321.333 1170.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6adef4",
      stroke: "none"
    },
    d: "M444 1170C452.118 1173.41 465.203 1171 474 1171L543 1171L781 1171L1608 1171C1599.88 1167.59 1586.8 1170 1578 1170L1509 1170L1271 1170L444 1170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#abebf9",
      stroke: "none"
    },
    d: "M1608 1170L1608 1173C1608.7 1171.45 1608.7 1171.55 1608 1170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1728 1170L1728 1173C1728.7 1171.45 1728.7 1171.55 1728 1170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M217.333 1171.67C217.278 1171.72 217.222 1172.78 217.667 1172.33C217.722 1172.28 217.778 1171.22 217.333 1171.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1e8f8",
      stroke: "none"
    },
    d: "M444 1171L444 1174C444.696 1172.45 444.696 1172.55 444 1171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6adcf4",
      stroke: "none"
    },
    d: "M445 1171C453.118 1174.41 466.203 1172 475 1172L544 1172L782 1172L1608 1172C1599.88 1168.59 1586.8 1171 1578 1171L1509 1171L1271 1171L445 1171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69daf3",
      stroke: "none"
    },
    d: "M445 1172C453.118 1175.41 466.203 1173 475 1173L544 1173L782 1173L1608 1173C1599.88 1169.59 1586.8 1172 1578 1172L1509 1172L1271 1172L445 1172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1832 1172L1832 1175C1832.7 1173.45 1832.7 1173.55 1832 1172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M217 1173L217 1176C217.696 1174.45 217.696 1174.55 217 1173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69d9f3",
      stroke: "none"
    },
    d: "M445 1173C453.118 1176.41 466.203 1174 475 1174L544 1174L782 1174L1608 1174C1599.88 1170.59 1586.8 1173 1578 1173L1509 1173L1271 1173L445 1173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M322.333 1174.67C322.278 1174.72 322.222 1175.78 322.667 1175.33C322.722 1175.28 322.778 1174.22 322.333 1174.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68d7f2",
      stroke: "none"
    },
    d: "M445 1174C453.118 1177.41 466.203 1175 475 1175L544 1175L782 1175L1608 1175C1599.88 1171.59 1586.8 1174 1578 1174L1509 1174L1271 1174L445 1174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68d6f2",
      stroke: "none"
    },
    d: "M445 1177C457.494 1174.03 472.188 1176 485 1176L563 1176L813 1176L1607 1176C1600.32 1173.2 1590.22 1175 1583 1175L1531 1175L1348 1175L715 1175L513 1175L463 1175C458.099 1175 448.407 1173.1 445 1177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aae7f7",
      stroke: "none"
    },
    d: "M1607.33 1175.67C1607.28 1175.72 1607.22 1176.78 1607.67 1176.33C1607.72 1176.28 1607.78 1175.22 1607.33 1175.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1727.33 1175.67C1727.28 1175.72 1727.22 1176.78 1727.67 1176.33C1727.72 1176.28 1727.78 1175.22 1727.33 1175.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1832.33 1175.67C1832.28 1175.72 1832.22 1176.78 1832.67 1176.33C1832.72 1176.28 1832.78 1175.22 1832.33 1175.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d7e5",
      stroke: "none"
    },
    d: "M217.333 1176.67C217.278 1176.72 217.222 1177.78 217.667 1177.33C217.722 1177.28 217.778 1176.22 217.333 1176.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M322 1176L322 1179C322.696 1177.45 322.696 1177.55 322 1176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67d4f1",
      stroke: "none"
    },
    d: "M446 1176C454.118 1179.41 467.203 1177 476 1177L545 1177L783 1177L1607 1177C1598.88 1173.59 1585.8 1176 1577 1176L1508 1176L1270 1176L446 1176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6eef9",
      stroke: "none"
    },
    d: "M445.333 1177.67C445.278 1177.72 445.222 1178.78 445.667 1178.33C445.723 1178.28 445.778 1177.22 445.333 1177.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67d3f1",
      stroke: "none"
    },
    d: "M446 1177C454.118 1180.41 467.203 1178 476 1178L545 1178L782 1178L1607 1178C1598.88 1174.59 1585.8 1177 1577 1177L1508 1177L1270 1177L446 1177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1727 1177L1727 1180C1727.7 1178.45 1727.7 1178.55 1727 1177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1832.33 1177.67C1832.28 1177.72 1832.22 1178.78 1832.67 1178.33C1832.72 1178.28 1832.78 1177.22 1832.33 1177.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66d1f0",
      stroke: "none"
    },
    d: "M446 1178C450.72 1179.98 456.92 1179 462 1179L496 1179L613 1179C747.648 1179 882.38 1180.02 1017 1179C1012.28 1177.02 1006.08 1178 1001 1178L967 1178L851 1178L446 1178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8dddf4",
      stroke: "none"
    },
    d: "M1018 1178C1021.43 1179.44 1025.3 1179 1029 1179C1025.57 1177.56 1021.7 1178 1018 1178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66d1f0",
      stroke: "none"
    },
    d: "M1029 1178C1034.09 1180.2 1039.61 1179.07 1045 1179C1054.33 1178.9 1063.67 1179 1073 1179L1175 1179L1468 1179L1560 1179C1574.95 1179 1592.43 1176.53 1607 1180C1604.57 1177.21 1600.52 1178 1597 1178L1571 1178L1463 1178L1029 1178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66d0f0",
      stroke: "none"
    },
    d: "M446 1181C452.513 1179.45 459.341 1180 466 1180L498 1180L603 1180L874 1180L964 1180C978.511 1180 993.568 1181.2 1008 1180C1004.04 1178.34 999.26 1179 995 1179L970 1179L882 1179L577 1179L479 1179L456 1179C452.484 1179 448.435 1178.21 446 1181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9e5f7",
      stroke: "none"
    },
    d: "M1009 1179C1010.25 1179.68 1010.55 1179.75 1012 1180C1010.75 1179.32 1010.45 1179.25 1009 1179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9f3fb",
      stroke: "none"
    },
    d: "M1012 1179C1013.25 1179.68 1013.55 1179.75 1015 1180C1013.75 1179.32 1013.45 1179.25 1012 1179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3e8f8",
      stroke: "none"
    },
    d: "M1032 1179C1033.51 1179.68 1034.31 1179.83 1036 1180C1034.49 1179.32 1033.69 1179.17 1032 1179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66d0f0",
      stroke: "none"
    },
    d: "M1038 1179C1042.47 1181.25 1048.1 1180 1053 1180L1084 1180L1198 1180L1606 1180C1601.28 1178.02 1595.08 1179 1590 1179L1557 1179L1441 1179L1038 1179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M218.333 1180.67C218.278 1180.72 218.222 1181.78 218.667 1181.33C218.722 1181.28 218.778 1180.22 218.333 1180.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66ceef",
      stroke: "none"
    },
    d: "M447 1180C451.72 1181.98 457.92 1181 463 1181L495 1181L606 1181L875 1181L962 1181C975.142 1181 990.11 1183.05 1003 1181C998.28 1179.02 992.08 1180 987 1180L955 1180L841 1180L447 1180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3e7f7",
      stroke: "none"
    },
    d: "M1004.67 1180.33C1004.22 1180.78 1005.28 1180.72 1005.33 1180.67C1005.78 1180.22 1004.72 1180.28 1004.67 1180.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bceaf8",
      stroke: "none"
    },
    d: "M1039 1180C1040.25 1180.68 1040.55 1180.75 1042 1181C1040.75 1180.32 1040.45 1180.25 1039 1180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66ceef",
      stroke: "none"
    },
    d: "M1043 1180C1047.1 1182.2 1052.43 1181 1057 1181L1087 1181L1199 1181L1606 1181C1601.28 1179.02 1595.08 1180 1590 1180L1557 1180L1442 1180L1043 1180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bce9f8",
      stroke: "none"
    },
    d: "M1606.33 1180.67C1606.28 1180.72 1606.22 1181.78 1606.67 1181.33C1606.72 1181.28 1606.78 1180.22 1606.33 1180.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M323 1181L323 1184C323.696 1182.45 323.696 1182.55 323 1181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbe8f8",
      stroke: "none"
    },
    d: "M446.333 1181.67C446.278 1181.72 446.222 1182.78 446.667 1182.33C446.722 1182.28 446.778 1181.22 446.333 1181.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65cdef",
      stroke: "none"
    },
    d: "M447 1181C451.72 1182.98 457.92 1182 463 1182L495 1182L607 1182L870 1182L957 1182C970.721 1182 985.412 1183.52 999 1182C994.28 1180.02 988.08 1181 983 1181L951 1181L838 1181L447 1181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8e3f6",
      stroke: "none"
    },
    d: "M1044.67 1181.33C1044.22 1181.78 1045.28 1181.72 1045.33 1181.67C1045.78 1181.22 1044.72 1181.28 1044.67 1181.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65cdef",
      stroke: "none"
    },
    d: "M1047 1181C1051.72 1182.98 1057.92 1182 1063 1182L1096 1182L1210 1182L1606 1182C1601.28 1180.02 1595.08 1181 1590 1181L1557 1181L1443 1181L1047 1181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1831.33 1181.67C1831.28 1181.72 1831.22 1182.78 1831.67 1182.33C1831.72 1182.28 1831.78 1181.22 1831.33 1181.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M218.333 1182.67C218.278 1182.72 218.222 1183.78 218.667 1183.33C218.722 1183.28 218.778 1182.22 218.333 1182.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65cbee",
      stroke: "none"
    },
    d: "M447 1182C451.72 1183.98 457.92 1183 463 1183L495 1183L606 1183L868 1183L954 1183C967.721 1183 982.412 1184.52 996 1183C991.28 1181.02 985.08 1182 980 1182L948 1182L836 1182L447 1182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95dcf3",
      stroke: "none"
    },
    d: "M1048.67 1182.33C1048.22 1182.78 1049.28 1182.72 1049.33 1182.67C1049.78 1182.22 1048.72 1182.28 1048.67 1182.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65cbee",
      stroke: "none"
    },
    d: "M1050 1182C1053.96 1183.66 1058.74 1183 1063 1183L1087 1183L1172 1183L1469 1183L1568 1183L1593 1183C1597.25 1183 1601.51 1182.36 1605 1185C1606.35 1181.41 1601.55 1182.01 1599 1182L1575 1182L1474 1182L1050 1182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1726 1182L1727 1183L1726 1182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64c9ee",
      stroke: "none"
    },
    d: "M447 1185C460.679 1181.74 476.965 1184 491 1184L578 1184L859 1184L950 1184L979 1184C983.626 1184 988.479 1184.77 993 1184C989.041 1182.34 984.26 1183 980 1183L956 1183L870 1183L574 1183L479 1183L456 1183C452.683 1183 449.276 1182.4 447 1185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94daf3",
      stroke: "none"
    },
    d: "M1051.67 1183.33C1051.22 1183.78 1052.28 1183.72 1052.33 1183.67C1052.78 1183.22 1051.72 1183.28 1051.67 1183.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64c9ee",
      stroke: "none"
    },
    d: "M1053 1183C1056.73 1185.13 1061.76 1184 1066 1184L1095 1184L1204 1184L1605 1184C1600.28 1182.02 1594.08 1183 1589 1183L1557 1183L1444 1183L1053 1183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1726 1183L1726 1186C1726.7 1184.45 1726.7 1184.55 1726 1183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1831.33 1183.67C1831.28 1183.72 1831.22 1184.78 1831.67 1184.33C1831.72 1184.28 1831.78 1183.22 1831.33 1183.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d7e5",
      stroke: "none"
    },
    d: "M218.333 1184.67C218.278 1184.72 218.222 1185.78 218.667 1185.33C218.722 1185.28 218.778 1184.22 218.333 1184.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64c8ed",
      stroke: "none"
    },
    d: "M448 1184C452.72 1185.98 458.92 1185 464 1185L495 1185L605 1185L863 1185L948 1185C961.724 1185 976.416 1186.49 990 1185C985.28 1183.02 979.08 1184 974 1184L943 1184L832 1184L448 1184M1056 1184C1059.63 1186.1 1064.82 1185 1069 1185L1098 1185L1206 1185L1605 1185C1600.28 1183.02 1594.08 1184 1589 1184L1557 1184L1445 1184L1056 1184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4e9f8",
      stroke: "none"
    },
    d: "M447.333 1185.67C447.278 1185.72 447.222 1186.78 447.667 1186.33C447.722 1186.28 447.778 1185.22 447.333 1185.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63c7ed",
      stroke: "none"
    },
    d: "M448 1185C452.72 1186.98 458.92 1186 464 1186L495 1186L605 1186L862 1186L947 1186C960.398 1186 974.739 1187.46 988 1186C983.28 1184.02 977.08 1185 972 1185L941 1185L830 1185L448 1185M1058 1185C1061.42 1187.21 1065.98 1186.01 1070 1186L1098 1186L1205 1186L1605 1186C1600.28 1184.02 1594.08 1185 1589 1185L1557 1185L1446 1185L1058 1185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d7e5",
      stroke: "none"
    },
    d: "M1831.33 1185.67C1831.28 1185.72 1831.22 1186.78 1831.67 1186.33C1831.72 1186.28 1831.78 1185.22 1831.33 1185.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63c5ec",
      stroke: "none"
    },
    d: "M448 1186C452.72 1187.98 458.92 1187 464 1187L495 1187L604 1187L860 1187L945 1187C958.398 1187 972.739 1188.46 986 1187C981.28 1185.02 975.08 1186 970 1186L939 1186L829 1186L448 1186M1061 1186C1064.44 1187.99 1069.04 1187 1073 1187L1100 1187L1202 1187L1476 1187L1561 1187C1575.03 1187 1591.32 1184.74 1605 1188C1602.57 1185.21 1598.52 1186 1595 1186L1571 1186L1470 1186L1061 1186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M324 1187L325 1188L324 1187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c3ec",
      stroke: "none"
    },
    d: "M448 1189C462.864 1185.46 480.744 1188 496 1188L591 1188L855 1188L942 1188C955.724 1188 970.416 1189.49 984 1188C980.041 1186.34 975.26 1187 971 1187L948 1187L864 1187L573 1187L480 1187L457 1187C453.683 1187 450.276 1186.4 448 1189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1e1f5",
      stroke: "none"
    },
    d: "M1061 1187L1062 1188L1061 1187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c3ec",
      stroke: "none"
    },
    d: "M1063 1187C1066.63 1189.1 1071.82 1188 1076 1188L1104 1188L1211 1188L1604 1188C1599.28 1186.02 1593.08 1187 1588 1187L1557 1187L1446 1187L1063 1187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1725 1187L1725 1190C1725.7 1188.45 1725.7 1188.55 1725 1187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M219 1188L219 1191C219.696 1189.45 219.696 1189.55 219 1188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M324.333 1188.67C324.278 1188.72 324.222 1189.78 324.667 1189.33C324.722 1189.28 324.778 1188.22 324.333 1188.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2eb",
      stroke: "none"
    },
    d: "M449 1188C453.469 1189.88 459.191 1189 464 1189L495 1189L604 1189L858 1189L941 1189C954.398 1189 968.739 1190.46 982 1189C977.531 1187.12 971.809 1188 967 1188L936 1188L827 1188L449 1188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0e0f5",
      stroke: "none"
    },
    d: "M1063 1188L1064 1189L1063 1188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62c2eb",
      stroke: "none"
    },
    d: "M1065 1188C1069.72 1189.98 1075.92 1189 1081 1189L1112 1189L1222 1189L1604 1189C1599.28 1187.02 1593.08 1188 1588 1188L1557 1188L1447 1188L1065 1188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ceebf9",
      stroke: "none"
    },
    d: "M1604.33 1188.67C1604.28 1188.72 1604.22 1189.78 1604.67 1189.33C1604.72 1189.28 1604.78 1188.22 1604.33 1188.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7effa",
      stroke: "none"
    },
    d: "M448.333 1189.67C448.278 1189.72 448.222 1190.78 448.667 1190.33C448.723 1190.28 448.778 1189.22 448.333 1189.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61c0ea",
      stroke: "none"
    },
    d: "M449 1189C453.469 1190.88 459.191 1190 464 1190L495 1190L603 1190L856 1190L939 1190C952.398 1190 966.739 1191.46 980 1190C975.531 1188.12 969.809 1189 965 1189L934 1189L825 1189L449 1189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6dcf3",
      stroke: "none"
    },
    d: "M1065 1189L1066 1190L1065 1189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61c0ea",
      stroke: "none"
    },
    d: "M1066 1189C1069.63 1191.1 1074.82 1190 1079 1190L1107 1190L1213 1190L1604 1190C1599.28 1188.02 1593.08 1189 1588 1189L1557 1189L1447 1189L1066 1189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1830 1189L1830 1192C1830.7 1190.45 1830.7 1190.55 1830 1189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61bfea",
      stroke: "none"
    },
    d: "M449 1193C453.681 1190.4 458.785 1191 464 1191L492 1191L596 1191L978 1191C975.184 1189.38 971.306 1190 968 1190L946 1190L866 1190L570 1190L478 1190L457 1190C453.47 1190 449.855 1189.01 449 1193M1068 1190C1071.63 1192.1 1076.82 1191 1081 1191L1109 1191L1215 1191L1604 1191C1599.28 1189.02 1593.08 1190 1588 1190L1557 1190L1448 1190L1068 1190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d7e5",
      stroke: "none"
    },
    d: "M219.333 1191.67C219.278 1191.72 219.222 1192.78 219.667 1192.33C219.722 1192.28 219.778 1191.22 219.333 1191.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60bdea",
      stroke: "none"
    },
    d: "M450 1191C454.469 1192.88 460.191 1192 465 1192L496 1192L603 1192L854 1192L937 1192C950.072 1192 964.063 1193.42 977 1192C972.531 1190.12 966.809 1191 962 1191L931 1191L823 1191L450 1191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6daf3",
      stroke: "none"
    },
    d: "M977 1191L978 1192L977 1191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60bdea",
      stroke: "none"
    },
    d: "M1070 1191C1074.47 1192.88 1080.19 1192 1085 1192L1116 1192L1225 1192L1603 1192C1598.53 1190.12 1592.81 1191 1588 1191L1557 1191L1448 1191L1070 1191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9e2f5",
      stroke: "none"
    },
    d: "M1603.33 1191.67C1603.28 1191.72 1603.22 1192.78 1603.67 1192.33C1603.72 1192.28 1603.78 1191.22 1603.33 1191.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M325.333 1192.67C325.278 1192.72 325.222 1193.78 325.667 1193.33C325.722 1193.28 325.778 1192.22 325.333 1192.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60bce9",
      stroke: "none"
    },
    d: "M450 1192C454.469 1193.88 460.191 1193 465 1193L496 1193L603 1193L975 1193C970.531 1191.12 964.809 1192 960 1192L929 1192L822 1192L450 1192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5d9f3",
      stroke: "none"
    },
    d: "M1070 1192L1071 1193L1070 1192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60bce9",
      stroke: "none"
    },
    d: "M1071 1192C1074.63 1194.1 1079.82 1193 1084 1193L1112 1193L1217 1193L1603 1193C1598.53 1191.12 1592.81 1192 1588 1192L1557 1192L1448 1192L1071 1192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d7e5",
      stroke: "none"
    },
    d: "M1830.33 1192.67C1830.28 1192.72 1830.22 1193.78 1830.67 1193.33C1830.72 1193.28 1830.78 1192.22 1830.33 1192.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5fbae8",
      stroke: "none"
    },
    d: "M450 1193C454.469 1194.88 460.191 1194 465 1194L496 1194L602 1194L852 1194L934 1194C947.072 1194 961.063 1195.42 974 1194C969.531 1192.12 963.809 1193 959 1193L928 1193L821 1193L450 1193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afddf4",
      stroke: "none"
    },
    d: "M974 1193L975 1194L974 1193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5fbae8",
      stroke: "none"
    },
    d: "M1073 1193C1077.22 1194.77 1082.46 1194 1087 1194L1113 1194L1207 1194L1476 1194L1560 1194C1573.73 1194 1589.62 1191.81 1603 1195C1600.57 1192.21 1596.52 1193 1593 1193L1569 1193L1471 1193L1073 1193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1724.33 1193.67C1724.28 1193.72 1724.22 1194.78 1724.67 1194.33C1724.72 1194.28 1724.78 1193.22 1724.33 1193.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284685",
      stroke: "none"
    },
    d: "M325.333 1194.67C325.278 1194.72 325.222 1195.78 325.667 1195.33C325.722 1195.28 325.778 1194.22 325.333 1194.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5fb9e8",
      stroke: "none"
    },
    d: "M450 1196C461.604 1193.24 475.105 1195 487 1195L558 1195L784 1195L910 1195L949 1195C956.591 1195 964.578 1194.23 972 1196C969.897 1193.59 967.106 1194.01 964 1194L946 1194L870 1194L563 1194L479 1194L459 1194C455.683 1194 452.276 1193.4 450 1196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5d8f2",
      stroke: "none"
    },
    d: "M1073 1194L1074 1195L1073 1194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5fb9e8",
      stroke: "none"
    },
    d: "M1074 1194C1077.44 1195.99 1082.04 1195 1086 1195L1114 1195L1218 1195L1602 1195C1597.53 1193.12 1591.81 1194 1587 1194L1556 1194L1448 1194L1074 1194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M220 1195L221 1196L220 1195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5eb7e7",
      stroke: "none"
    },
    d: "M451 1195C455.469 1196.88 461.191 1196 466 1196L496 1196L602 1196L850 1196L931 1196C944.072 1196 958.063 1197.42 971 1196C966.531 1194.12 960.809 1195 956 1195L925 1195L819 1195L451 1195M1076 1197C1082.82 1195.38 1090.03 1196 1097 1196L1132 1196L1244 1196L1602 1196C1598.04 1194.34 1593.26 1195 1589 1195L1566 1195L1484 1195L1198 1195L1107 1195L1085 1195C1081.68 1195 1078.28 1194.4 1076 1197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1829.33 1195.67C1829.28 1195.72 1829.22 1196.78 1829.67 1196.33C1829.72 1196.28 1829.78 1195.22 1829.33 1195.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M220.333 1196.67C220.278 1196.72 220.222 1197.78 220.667 1197.33C220.722 1197.28 220.778 1196.22 220.333 1196.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5eb6e7",
      stroke: "none"
    },
    d: "M451 1196C454.959 1197.66 459.74 1197 464 1197L490 1197L581 1197L844 1197L927 1197C940.424 1197 955.913 1194.88 969 1198C966.565 1195.21 962.516 1196 959 1196L936 1196L840 1196L451 1196M1077 1198C1088.6 1195.24 1102.11 1197 1114 1197L1185 1197L1413 1197L1540 1197L1579 1197C1586.59 1197 1594.58 1196.23 1602 1198C1599.72 1195.4 1596.32 1196 1593 1196L1573 1196L1488 1196L1179 1196L1103 1196L1085 1196C1081.89 1196.01 1079.1 1195.59 1077 1198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M326 1197L327 1198L326 1197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5db4e6",
      stroke: "none"
    },
    d: "M451 1199C462.307 1196.31 475.412 1198 487 1198L557 1198L781 1198L906 1198L945 1198C952.591 1198 960.578 1197.23 968 1199C965.897 1196.59 963.106 1197.01 960 1197L942 1197L867 1197L563 1197L480 1197L460 1197C456.683 1197 453.276 1196.4 451 1199M1078 1197C1082.47 1198.88 1088.19 1198 1093 1198L1124 1198L1230 1198L1601 1198C1596.53 1196.12 1590.81 1197 1586 1197L1555 1197L1449 1197L1078 1197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1723.33 1197.67C1723.28 1197.72 1723.22 1198.78 1723.67 1198.33C1723.72 1198.28 1723.78 1197.22 1723.33 1197.67M1829 1197L1829 1200C1829.7 1198.45 1829.7 1198.55 1829 1197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M326 1198L327 1199L326 1198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5db2e6",
      stroke: "none"
    },
    d: "M452 1198C455.959 1199.66 460.74 1199 465 1199L491 1199L582 1199L843 1199L925 1199C938.424 1199 953.913 1196.88 967 1200C964.565 1197.21 960.516 1198 957 1198L934 1198L839 1198L452 1198M1079 1198C1082.44 1199.99 1087.04 1199 1091 1199L1119 1199L1222 1199L1601 1199C1596.53 1197.12 1590.81 1198 1586 1198L1555 1198L1449 1198L1079 1198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5cb1e5",
      stroke: "none"
    },
    d: "M452 1199C456.469 1200.88 462.191 1200 467 1200L497 1200L602 1200L966 1200C961.531 1198.12 955.809 1199 951 1199L921 1199L816 1199L452 1199M1081 1201C1092.6 1198.24 1106.11 1200 1118 1200L1189 1200L1414 1200L1539 1200L1578 1200C1585.59 1200 1593.58 1199.23 1601 1201C1598.9 1198.59 1596.11 1199.01 1593 1199L1575 1199L1500 1199L1194 1199L1110 1199L1090 1199C1086.68 1199 1083.28 1198.4 1081 1201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37548e",
      stroke: "none"
    },
    d: "M1723.33 1199.67C1723.28 1199.72 1723.22 1200.78 1723.67 1200.33C1723.72 1200.28 1723.78 1199.22 1723.33 1199.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5cafe5",
      stroke: "none"
    },
    d: "M452 1202C458.817 1200.38 466.03 1201 473 1201L507 1201L616 1201L965 1201C961.301 1199.45 956.983 1200 953 1200L930 1200L850 1200L571 1200L482 1200L461 1200C457.683 1200 454.276 1199.4 452 1202M1082 1202C1088.82 1200.38 1096.03 1201 1103 1201L1137 1201L1247 1201L1600 1201C1596.3 1199.45 1591.98 1200 1588 1200L1565 1200L1484 1200L1203 1200L1113 1200L1091 1200C1087.68 1200 1084.28 1199.4 1082 1202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M221 1201L222 1202L221 1201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5baee4",
      stroke: "none"
    },
    d: "M453 1201C457.469 1202.88 463.191 1202 468 1202L497 1202L601 1202L845 1202L925 1202C937.746 1202 951.386 1203.39 964 1202C959.531 1200.12 953.809 1201 949 1201L919 1201L815 1201L453 1201M1083 1203C1089.82 1201.38 1097.03 1202 1104 1202L1138 1202L1248 1202L1600 1202C1596.3 1200.45 1591.98 1201 1588 1201L1565 1201L1484 1201L1203 1201L1114 1201L1092 1201C1088.68 1201 1085.28 1200.4 1083 1203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M221 1202L221 1205C221.696 1203.45 221.696 1203.55 221 1202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M327.333 1202.67C327.278 1202.72 327.222 1203.78 327.667 1203.33C327.722 1203.28 327.778 1202.22 327.333 1202.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5aabe3",
      stroke: "none"
    },
    d: "M453 1202L453 1204L838 1204L931 1204C938.332 1204 945.668 1203.93 953 1204C956.527 1204.04 959.794 1205.03 962 1202L453 1202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5bace4",
      stroke: "none"
    },
    d: "M1084 1204C1095.6 1201.24 1109.11 1203 1121 1203L1190 1203L1414 1203L1539 1203L1577 1203C1584.59 1203 1592.58 1202.23 1600 1204C1597.72 1201.4 1594.32 1202 1591 1202L1571 1202L1488 1202L1185 1202L1110 1202L1092 1202C1088.89 1202.01 1086.1 1201.59 1084 1204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1722.33 1202.67C1722.28 1202.72 1722.22 1203.78 1722.67 1203.33C1722.72 1203.28 1722.78 1202.22 1722.33 1202.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1828 1202L1829 1203L1828 1202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5aabe3",
      stroke: "none"
    },
    d: "M1085 1205C1091.82 1203.38 1099.03 1204 1106 1204L1140 1204L1249 1204L1599 1204C1595.3 1202.45 1590.98 1203 1587 1203L1564 1203L1484 1203L1205 1203L1116 1203L1094 1203C1090.68 1203 1087.28 1202.4 1085 1205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1828 1203L1828 1206C1828.7 1204.45 1828.7 1204.55 1828 1203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbe4f6",
      stroke: "none"
    },
    d: "M453.333 1204.67C453.278 1204.72 453.222 1205.78 453.667 1205.33C453.722 1205.28 453.778 1204.22 453.333 1204.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59a8e2",
      stroke: "none"
    },
    d: "M454 1207C467.087 1203.88 482.576 1206 496 1206L576 1206L834 1206L929 1206C936.332 1206 943.668 1205.93 951 1206C954.527 1206.04 957.794 1207.03 960 1204L573 1204L482 1204L461 1204C457.61 1204 454.797 1203.28 454 1207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5aa9e3",
      stroke: "none"
    },
    d: "M1086 1206C1092.82 1204.38 1100.03 1205 1107 1205L1141 1205L1250 1205L1599 1205C1595.3 1203.45 1590.98 1204 1587 1204L1564 1204L1484 1204L1205 1204L1116 1204L1095 1204C1091.68 1204 1088.28 1203.4 1086 1206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1722 1204L1723 1205L1722 1204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59a8e2",
      stroke: "none"
    },
    d: "M1087 1207C1098.6 1204.24 1112.11 1206 1124 1206L1193 1206L1415 1206L1538 1206L1576 1206C1583.59 1206 1591.58 1205.23 1599 1207C1596.72 1204.4 1593.32 1205 1590 1205L1571 1205L1488 1205L1187 1205L1113 1205L1095 1205C1091.89 1205.01 1089.1 1204.59 1087 1207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M222 1206L222 1209C222.696 1207.45 222.696 1207.55 222 1206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M328 1206L329 1207L328 1206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58a5e1",
      stroke: "none"
    },
    d: "M455 1206L455 1208L835 1208L927 1208C934.332 1208 941.668 1207.93 949 1208C952.527 1208.04 955.794 1209.03 958 1206L455 1206M1088 1206C1088 1207.8 1088.01 1207.52 1089 1209C1100.31 1206.31 1113.41 1208 1125 1208L1194 1208L1414 1208L1537 1208L1575 1208C1582.59 1208 1590.58 1207.23 1598 1209C1597.2 1205.28 1594.39 1206 1591 1206L1570 1206L1478 1206L1088 1206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1721 1206L1722 1207L1721 1206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M328 1207L329 1208L328 1207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1721 1207L1722 1208L1721 1207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1827 1207L1827 1210C1827.7 1208.45 1827.7 1208.55 1827 1207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57a2e0",
      stroke: "none"
    },
    d: "M455 1208L456 1212C468.79 1208.95 483.882 1211 497 1211L577 1211L833 1211L926 1211C932.665 1211 939.335 1210.94 946 1211C950.246 1211.05 953.665 1212.02 956 1208L455 1208M1090 1208C1092.33 1212.02 1095.75 1211.05 1100 1211C1107 1210.94 1114 1211 1121 1211L1214 1211L1474 1211L1555 1211C1568.42 1211 1583.91 1208.88 1597 1212L1597 1208L1090 1208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1721 1208L1722 1209L1721 1208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#abd0f0",
      stroke: "none"
    },
    d: "M1597 1209L1598 1210L1597 1209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M329 1210L330 1211L329 1210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1720 1210L1721 1211L1720 1210M1827 1210L1828 1211L1827 1210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M329 1211L330 1212L329 1211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#569ddf",
      stroke: "none"
    },
    d: "M457 1211L457 1213L832 1213L923 1213C929.999 1213 937.001 1212.94 944 1213C947.527 1213.04 950.794 1214.03 953 1211L457 1211M1093 1211C1093 1212.8 1093.01 1212.52 1094 1214C1105.31 1211.31 1118.41 1213 1130 1213L1198 1213L1415 1213L1536 1213L1574 1213C1581.28 1213 1588.88 1212.3 1596 1214C1595.2 1210.28 1592.39 1211 1589 1211L1568 1211L1478 1211L1093 1211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1720 1211L1721 1212L1720 1211M223.333 1212.67C223.278 1212.72 223.222 1213.78 223.667 1213.33C223.722 1213.28 223.778 1212.22 223.333 1212.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#abceef",
      stroke: "none"
    },
    d: "M456 1212L457 1213L456 1212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1826 1212L1826 1215C1826.7 1213.45 1826.7 1213.55 1826 1212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#559ade",
      stroke: "none"
    },
    d: "M457 1213C463.209 1217.7 477.375 1215 485 1215L558 1215L840 1215L923 1215C929.664 1215 936.337 1214.9 943 1215.01C946.339 1215.07 948.938 1215.83 951 1213L457 1213M1095 1213C1095 1214.8 1095.01 1214.52 1096 1216C1103.12 1214.3 1110.72 1215 1118 1215L1156 1215L1276 1215L1492 1215L1559 1215C1570.59 1215 1583.69 1213.31 1595 1216C1594.2 1212.28 1591.39 1213 1588 1213L1567 1213L1477 1213L1095 1213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M330 1214L331 1215L330 1214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95c0ea",
      stroke: "none"
    },
    d: "M457 1214L458 1215L457 1214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1719 1214L1720 1215L1719 1214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M330 1215L331 1216L330 1215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5497dd",
      stroke: "none"
    },
    d: "M458 1215L458 1217L829 1217L919 1217C925.999 1217 933.001 1216.94 940 1217C943.527 1217.04 946.794 1218.03 949 1215L458 1215M1097 1215C1097 1216.8 1097.01 1216.52 1098 1218C1104.51 1216.45 1111.34 1217 1118 1217L1151 1217L1256 1217L1594 1217L1594 1215L1097 1215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1719 1215L1720 1216L1719 1215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1826 1215L1827 1216L1826 1215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9cbee",
      stroke: "none"
    },
    d: "M1594 1216L1595 1217L1594 1216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M224 1217L225 1218L224 1217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M331 1217L332 1218L331 1217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5294da",
      stroke: "none"
    },
    d: "M459 1217L459 1219L828 1219L917 1219C923.999 1219 931.001 1218.94 938 1219C941.527 1219.04 944.794 1220.03 947 1217L459 1217M1099 1217C1099 1218.8 1099.01 1218.52 1100 1220C1113.09 1216.88 1128.58 1219 1142 1219L1222 1219L1479 1219L1556 1219C1567.83 1219 1582.64 1221.36 1594 1218C1589.78 1216.23 1584.54 1217 1580 1217L1551 1217L1450 1217L1099 1217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M224.333 1218.67C224.278 1218.72 224.222 1219.78 224.667 1219.33C224.722 1219.28 224.778 1218.22 224.333 1218.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M331 1218L332 1219L331 1218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93bce8",
      stroke: "none"
    },
    d: "M1593 1218L1594 1219L1593 1218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1718 1218L1719 1219L1718 1218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1825 1218L1825 1221C1825.7 1219.45 1825.7 1219.55 1825 1218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bed6f1",
      stroke: "none"
    },
    d: "M459 1219L460 1220L459 1219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5091d7",
      stroke: "none"
    },
    d: "M460 1219L461 1223C473.494 1220.03 488.188 1222 501 1222L578 1222L826 1222L916 1222C922.664 1222 929.337 1221.9 936 1222.01C940.034 1222.08 942.82 1222.75 945 1219L460 1219M1101 1219C1103.33 1223.02 1106.75 1222.05 1111 1222C1117.67 1221.94 1124.33 1222 1131 1222L1221 1222L1473 1222L1551 1222C1564.12 1222 1579.21 1219.95 1592 1223L1593 1219L1101 1219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1718 1219L1719 1220L1718 1219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M332 1221L333 1222L332 1221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7c7ea",
      stroke: "none"
    },
    d: "M460 1221L461 1222L460 1221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1717 1221L1718 1222L1717 1221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M225.333 1222.67C225.278 1222.72 225.222 1223.78 225.667 1223.33C225.722 1223.28 225.778 1222.22 225.333 1222.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M332 1222L333 1223L332 1222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d8cd3",
      stroke: "none"
    },
    d: "M462 1225C474.494 1222.03 489.188 1224 502 1224L578 1224L823 1224L912 1224C918.999 1224 926.001 1223.94 933 1224C936.527 1224.04 939.794 1225.03 942 1222L575 1222L489 1222L469 1222C465.61 1222 462.797 1221.28 462 1225M1104 1222C1104 1223.8 1104.01 1223.52 1105 1225C1116.01 1222.38 1128.72 1224 1140 1224L1205 1224L1416 1224L1533 1224L1569 1224C1576.28 1224 1583.88 1223.3 1591 1225C1590.2 1221.28 1587.39 1222 1584 1222L1564 1222L1476 1222L1104 1222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1717 1222L1718 1223L1717 1222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1824 1222L1825 1223L1824 1222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c6e9",
      stroke: "none"
    },
    d: "M461 1223L462 1224L461 1223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1824 1223L1825 1224L1824 1223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M333 1224L334 1225L333 1224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4b8ad0",
      stroke: "none"
    },
    d: "M463 1227C475.197 1224.1 489.493 1226 502 1226L578 1226L821 1226L910 1226C916.999 1226 924.001 1225.94 931 1226C934.527 1226.04 937.794 1227.03 940 1224L575 1224L490 1224L470 1224C466.61 1224 463.797 1223.28 463 1227M1106 1224C1106 1225.8 1106.01 1225.52 1107 1227C1114.12 1225.3 1121.72 1226 1129 1226L1165 1226L1282 1226L1490 1226L1555 1226C1566.28 1226 1578.99 1224.38 1590 1227C1589.2 1223.28 1586.39 1224 1583 1224L1563 1224L1476 1224L1106 1224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1824 1224L1825 1225L1824 1224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M333 1225L334 1226L333 1225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5c4e7",
      stroke: "none"
    },
    d: "M462 1225L463 1226L462 1225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1716 1225L1717 1226L1716 1225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M226 1226L227 1227L226 1226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4987cd",
      stroke: "none"
    },
    d: "M464 1226L464 1229L823 1229L910 1229C916.331 1229 922.67 1228.9 929 1229.01C933.034 1229.08 935.82 1229.75 938 1226L464 1226M1108 1226C1110.18 1229.75 1112.97 1229.08 1117 1229.01C1123.66 1228.9 1130.34 1229 1137 1229L1224 1229L1589 1229L1589 1226L1108 1226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M226 1227L227 1228L226 1227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M334 1227L335 1228L334 1227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4c3e6",
      stroke: "none"
    },
    d: "M463 1227L464 1228L463 1227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1823 1227L1824 1228L1823 1227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M334 1228L335 1229L334 1228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1715 1228L1716 1229L1715 1228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1823 1228L1824 1229L1823 1228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aec9e8",
      stroke: "none"
    },
    d: "M464 1229L465 1230L464 1229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4682c9",
      stroke: "none"
    },
    d: "M465 1229L466 1233C478.197 1230.1 492.493 1232 505 1232L580 1232L820 1232L907 1232C913.331 1232 919.67 1231.9 926 1232.01C930.034 1232.08 932.82 1232.75 935 1229L465 1229M1111 1229C1114.49 1235.01 1130.53 1232 1137 1232L1214 1232L1496 1232L1564 1232C1570.43 1232 1583.92 1234.66 1588 1229L1111 1229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M227 1230L228 1231L227 1230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M335 1230L336 1231L335 1230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8bb1dd",
      stroke: "none"
    },
    d: "M1587 1230L1588 1231L1587 1230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M227 1231L228 1232L227 1231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M335 1231L336 1232L335 1231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9d0ea",
      stroke: "none"
    },
    d: "M465 1231L466 1232L465 1231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1714 1231L1715 1232L1714 1231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1822 1231L1823 1232L1822 1231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#427ec4",
      stroke: "none"
    },
    d: "M467 1235C479.197 1232.1 493.494 1234 506 1234L580 1234L816 1234L903 1234C909.665 1234 916.335 1233.94 923 1234C926.527 1234.04 929.794 1235.03 932 1232L576 1232L493 1232L474 1232C470.61 1232 467.797 1231.28 467 1235M1114 1232C1114 1233.8 1114.01 1233.52 1115 1235C1130.46 1231.32 1149.13 1234 1165 1234L1266 1234L1586 1234L1586 1232L1114 1232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95b7df",
      stroke: "none"
    },
    d: "M1586 1232L1587 1233L1586 1232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1822 1232L1823 1233L1822 1232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M336 1233L337 1234L336 1233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M228 1234L229 1235L228 1234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M336 1234L337 1235L336 1234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407bc2",
      stroke: "none"
    },
    d: "M468 1234L469 1238C480.901 1235.17 494.799 1237 507 1237L581 1237L817 1237L902 1237C908.331 1237 914.67 1236.9 921 1237.01C925.034 1237.08 927.82 1237.75 930 1234L468 1234M1116 1234C1118.18 1237.75 1120.97 1237.08 1125 1237.01C1131.33 1236.9 1137.67 1237 1144 1237L1231 1237L1470 1237L1545 1237C1557.51 1237 1571.8 1235.1 1584 1238L1585 1234L1116 1234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0bee1",
      stroke: "none"
    },
    d: "M1585 1234L1586 1235L1585 1234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1713 1234L1714 1235L1713 1234M228 1235L229 1236L228 1235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1821 1235L1822 1236L1821 1235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M337 1236L338 1237L337 1236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9fbcdf",
      stroke: "none"
    },
    d: "M468 1236L469 1237L468 1236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3d5eb",
      stroke: "none"
    },
    d: "M1584 1236L1585 1237L1584 1236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1821 1236L1822 1237L1821 1236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M337 1237L338 1238L337 1237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d77bd",
      stroke: "none"
    },
    d: "M470 1237L470 1240L817 1240L900 1240C905.998 1240 912.003 1239.91 918 1240.01C922.034 1240.08 924.82 1240.75 927 1237L470 1237M1119 1237C1121.18 1240.75 1123.97 1240.08 1128 1240.01C1134.33 1239.9 1140.67 1240 1147 1240L1233 1240L1470 1240L1544 1240C1556.2 1240 1570.1 1238.17 1582 1241L1583 1237L1119 1237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1712 1237L1713 1238L1712 1237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M229 1238L230 1239L229 1238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6cce6",
      stroke: "none"
    },
    d: "M469 1238L470 1239L469 1238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M229 1239L230 1240L229 1239M338 1239L339 1240L338 1239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ebadd",
      stroke: "none"
    },
    d: "M1582 1239L1583 1240L1582 1239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1711 1239L1712 1240L1711 1239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1820 1239L1821 1240L1820 1239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M338 1240L339 1241L338 1240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a72b9",
      stroke: "none"
    },
    d: "M471 1240C474.92 1245.44 486.862 1243 493 1243L558 1243L826 1243L900 1243C906.226 1243 920.611 1245.83 924 1240L471 1240M1122 1240C1124.18 1243.75 1126.97 1243.08 1131 1243.01C1137.33 1242.9 1143.67 1243 1150 1243L1234 1243L1468 1243L1542 1243C1554.2 1243 1568.1 1241.17 1580 1244L1581 1240L1122 1240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1711 1240L1712 1241L1711 1240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1820 1240L1821 1241L1820 1240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9db9dc",
      stroke: "none"
    },
    d: "M471 1241L472 1242L471 1241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2d3e9",
      stroke: "none"
    },
    d: "M1581 1241L1582 1242L1581 1241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M230 1242L231 1243L230 1242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M339 1242L340 1243L339 1242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#779dce",
      stroke: "none"
    },
    d: "M1580 1242L1581 1243L1580 1242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1710 1242L1711 1243L1710 1242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1819 1242L1820 1243L1819 1242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M230 1243L231 1244L230 1243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#376eb5",
      stroke: "none"
    },
    d: "M473 1243L474 1246C485.604 1243.24 499.105 1245 511 1245L582 1245L810 1245L893 1245C899.664 1245 906.337 1244.9 913 1245.01C916.339 1245.07 918.938 1245.83 921 1243L473 1243M1125 1243C1125 1244.8 1125.01 1244.52 1126 1246C1136.41 1243.52 1148.33 1245 1159 1245L1220 1245L1415 1245L1524 1245L1558 1245C1564.97 1245 1572.18 1244.38 1579 1246C1578.2 1242.28 1575.39 1243 1572 1243L1554 1243L1472 1243L1125 1243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1710 1243L1711 1244L1710 1243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1819 1243L1820 1244L1819 1243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#769bcc",
      stroke: "none"
    },
    d: "M473 1244L474 1245L473 1244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8c0df",
      stroke: "none"
    },
    d: "M1579 1244L1580 1245L1579 1244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M231 1245L232 1246L231 1245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M340 1245L341 1246L340 1245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#356bb2",
      stroke: "none"
    },
    d: "M475 1245L476 1249C487.604 1246.24 501.105 1248 513 1248L584 1248L810 1248L892 1248C897.998 1248 904.003 1247.91 910 1248.01C914.034 1248.08 916.82 1248.75 919 1245L475 1245M1127 1245C1129.18 1248.75 1131.97 1248.08 1136 1248.01C1142 1247.91 1148 1248 1154 1248L1237 1248L1467 1248L1539 1248C1551.2 1248 1565.1 1246.17 1577 1249L1578 1245L1127 1245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1709 1245L1710 1246L1709 1245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M231 1246L232 1247L231 1246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0d1e7",
      stroke: "none"
    },
    d: "M474 1246L475 1247L474 1246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1818 1246L1819 1247L1818 1246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M341 1247L342 1248L341 1247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7398c9",
      stroke: "none"
    },
    d: "M475 1247L476 1248L475 1247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6bedd",
      stroke: "none"
    },
    d: "M1577 1247L1578 1248L1577 1247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1708 1247L1709 1248L1708 1247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1818 1247L1819 1248L1818 1247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M341 1248L342 1249L341 1248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3267ae",
      stroke: "none"
    },
    d: "M477 1248L477 1250L809 1250L889 1250C895.331 1250 901.67 1249.9 908 1250.01C911.339 1250.07 913.938 1250.83 916 1248L477 1248M1130 1248C1130 1249.8 1130.01 1249.52 1131 1251C1145.86 1247.46 1163.74 1250 1179 1250L1274 1250L1576 1250L1576 1248L1130 1248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1708 1248L1709 1249L1708 1248M232 1249L233 1250L232 1249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfcfe6",
      stroke: "none"
    },
    d: "M476 1249L477 1250L476 1249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1817 1249L1818 1250L1817 1249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M232 1250L233 1251L232 1250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M342 1250L343 1251L342 1250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ba9d0",
      stroke: "none"
    },
    d: "M477 1250L478 1251L477 1250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3064ab",
      stroke: "none"
    },
    d: "M478 1250L478 1252L807 1252L887 1252C893.331 1252 899.67 1251.9 906 1252.01C909.339 1252.07 911.938 1252.83 914 1250L478 1250M1132 1250C1132 1251.8 1132.01 1251.52 1133 1253C1144.6 1250.24 1158.11 1252 1170 1252L1240 1252L1464 1252L1547 1252C1553.33 1252 1559.67 1251.94 1566 1252C1569.59 1252.04 1572.61 1252.95 1575 1250L1132 1250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5bcdb",
      stroke: "none"
    },
    d: "M1575 1250L1576 1251L1575 1250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1707 1250L1708 1251L1707 1250M1817 1250L1818 1251L1817 1250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7194c5",
      stroke: "none"
    },
    d: "M1574 1251L1575 1252L1574 1251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M233 1252L234 1253L233 1252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M343 1252L344 1253L343 1252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e61a8",
      stroke: "none"
    },
    d: "M479 1252L480 1255C491.307 1252.31 504.412 1254 516 1254L585 1254L805 1254L885 1254C891.331 1254 897.67 1253.9 904 1254.01C907.339 1254.07 909.938 1254.83 912 1252L479 1252M1134 1252C1134 1253.8 1134.01 1253.52 1135 1255C1149.57 1251.53 1167.05 1254 1182 1254L1275 1254L1573 1254L1573 1252L1134 1252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1706 1252L1707 1253L1706 1252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M233 1253L234 1254L233 1253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4bad9",
      stroke: "none"
    },
    d: "M479 1253L480 1254L479 1253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1706 1253L1707 1254L1706 1253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1816 1253L1817 1254L1816 1253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c5ea5",
      stroke: "none"
    },
    d: "M481 1254L481 1256L805 1256L884 1256C889.998 1256 896.003 1255.91 902 1256.01C905.339 1256.07 907.938 1256.83 910 1254L481 1254M1136 1254C1136 1255.8 1136.01 1255.52 1137 1257C1148.6 1254.24 1162.11 1256 1174 1256L1243 1256L1464 1256L1545 1256C1551.33 1256 1557.67 1255.9 1564 1256.01C1567.34 1256.07 1569.94 1256.83 1572 1254L1136 1254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89a5cd",
      stroke: "none"
    },
    d: "M1572 1254L1573 1255L1572 1254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1816 1254L1817 1255L1816 1254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M344 1255L345 1256L344 1255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1705 1255L1706 1256L1705 1255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M234 1256L235 1257L234 1256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a5ba2",
      stroke: "none"
    },
    d: "M482 1256L484 1260C495.307 1257.31 508.411 1259 520 1259L587 1259L804 1259L882 1259C888.469 1259 904.511 1262.01 908 1256L482 1256M1138 1256C1141.49 1262.01 1157.53 1259 1164 1259L1244 1259L1464 1259L1533 1259C1544.59 1259 1557.69 1257.31 1569 1260L1570 1256L1138 1256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1815 1256L1816 1257L1815 1256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M345 1257L346 1258L345 1257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94add0",
      stroke: "none"
    },
    d: "M482 1257L483 1258L482 1257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bccce2",
      stroke: "none"
    },
    d: "M1570 1257L1571 1258L1570 1257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1704 1257L1705 1258L1704 1257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1815 1257L1816 1258L1815 1257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87a2ca",
      stroke: "none"
    },
    d: "M1569 1258L1570 1259L1569 1258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M235 1259L236 1260L235 1259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M346 1259L347 1260L346 1259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27579e",
      stroke: "none"
    },
    d: "M485 1259L485 1261L802 1261L879 1261C884.998 1261 891.003 1260.91 897 1261.01C900.339 1261.07 902.938 1261.83 905 1259L485 1259M1141 1259C1141 1260.8 1141.01 1260.52 1142 1262C1156.27 1258.6 1173.35 1261 1188 1261L1279 1261L1568 1261L1568 1259L1141 1259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1703 1259L1704 1260L1703 1259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1814 1259L1815 1260L1814 1259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M346 1260L347 1261L346 1260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1703 1260L1704 1261L1703 1260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1814 1260L1815 1261L1814 1260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M347 1261L348 1262L347 1261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aebfda",
      stroke: "none"
    },
    d: "M485 1261L486 1262L485 1261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#25549b",
      stroke: "none"
    },
    d: "M486 1261L488 1265C499.01 1262.38 511.718 1264 523 1264L589 1264L801 1264L878 1264C884.348 1264 899.561 1266.92 903 1261L486 1261M1143 1261C1146.49 1267.01 1162.53 1264 1169 1264L1247 1264L1462 1264L1529 1264C1540.59 1264 1553.69 1262.31 1565 1265L1567 1261L1143 1261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M236 1262L237 1263L236 1262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M347 1262L348 1263L347 1262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7794c0",
      stroke: "none"
    },
    d: "M486 1262L487 1263L486 1262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adbfda",
      stroke: "none"
    },
    d: "M1566 1262L1567 1263L1566 1262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1702 1262L1703 1263L1702 1262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1813 1262L1814 1263L1813 1262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7693c0",
      stroke: "none"
    },
    d: "M1565 1263L1566 1264L1565 1263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1813 1263L1814 1264L1813 1263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M348 1264L349 1265L348 1264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#224f97",
      stroke: "none"
    },
    d: "M489 1264C492.398 1269.24 503.347 1267 509 1267L568 1267L812 1267L878 1267C883.98 1267 896.716 1269.65 900 1264L489 1264M1146 1264C1149.34 1269.74 1162.9 1267 1169 1267L1236 1267L1484 1267L1544 1267C1549.65 1267 1560.6 1269.24 1564 1264L1146 1264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1701 1264L1702 1265L1701 1264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M237 1265L238 1266L237 1265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1812 1265L1813 1266L1812 1265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M349 1266L350 1267L349 1266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bac8de",
      stroke: "none"
    },
    d: "M489 1266L490 1267L489 1266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1700 1266L1701 1267L1700 1266M1812 1266L1813 1267L1812 1266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#abbcd7",
      stroke: "none"
    },
    d: "M490 1267L491 1268L490 1267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f4b92",
      stroke: "none"
    },
    d: "M491 1267L493 1271C503.712 1268.45 516.024 1270 527 1270L592 1270L798 1270L872 1270C878.348 1270 893.561 1272.92 897 1267L491 1267M1149 1267C1152.34 1272.74 1165.9 1270 1172 1270L1240 1270L1480 1270L1540 1270C1546.71 1270 1557 1272.11 1562 1267L1149 1267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7d2e4",
      stroke: "none"
    },
    d: "M1562 1267L1563 1268L1562 1267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M238 1268L239 1269L238 1268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M350 1268L351 1269L350 1268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#738ebb",
      stroke: "none"
    },
    d: "M491 1268L492 1269L491 1268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#abbcd6",
      stroke: "none"
    },
    d: "M1561 1268L1562 1269L1561 1268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1699 1268L1700 1269L1699 1268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1811 1268L1812 1269L1811 1268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6482b3",
      stroke: "none"
    },
    d: "M492 1269L493 1270L492 1269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8099c1",
      stroke: "none"
    },
    d: "M1560 1269L1561 1270L1560 1269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1811 1269L1812 1270L1811 1269M351 1270L352 1271L351 1270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c478e",
      stroke: "none"
    },
    d: "M494 1270C497.284 1275.65 510.02 1273 516 1273L580 1273L818 1273L875 1273C880.6 1273 890.886 1275.36 894 1270L494 1270M1152 1270C1155.44 1275.92 1170.65 1273 1177 1273L1251 1273L1458 1273L1523 1273C1533.98 1273 1546.29 1271.45 1557 1274L1559 1270L1152 1270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#728db9",
      stroke: "none"
    },
    d: "M1559 1270L1560 1271L1559 1270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1698 1270L1699 1271L1698 1270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M239 1271L240 1272L239 1271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5475aa",
      stroke: "none"
    },
    d: "M1558 1271L1559 1272L1558 1271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1698 1271L1699 1272L1698 1271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1810 1271L1811 1272L1810 1271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M352 1272L353 1273L352 1272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1697 1272L1698 1273L1697 1272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1810 1272L1811 1273L1810 1272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19428a",
      stroke: "none"
    },
    d: "M497 1273C500.319 1278.12 510.49 1276 516 1276L572 1276L806 1276L870 1276C875.855 1276 887.77 1278.56 891 1273L497 1273M1155 1273C1158.28 1278.65 1171.02 1276 1177 1276L1241 1276L1480 1276L1537 1276C1542.6 1276 1552.89 1278.36 1556 1273L1155 1273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1697 1273L1698 1274L1697 1273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M240 1274L241 1275L240 1274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M353 1274L354 1275L353 1274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1696 1274L1697 1275L1696 1274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1809 1274L1810 1275L1809 1274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7c4da",
      stroke: "none"
    },
    d: "M497 1275L498 1276L497 1275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1696 1275L1697 1276L1696 1275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M241 1276L242 1277L241 1276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M354 1276L355 1277L354 1276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b7d2",
      stroke: "none"
    },
    d: "M498 1276L499 1277L498 1276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#153e85",
      stroke: "none"
    },
    d: "M499 1276C504.434 1280.12 515.374 1278 522 1278L579 1278L801 1278L866 1278C871.374 1278 884.746 1280.47 888 1276L499 1276M1158 1276C1158 1277.8 1158.01 1277.52 1159 1279C1169.42 1276.52 1181.33 1278 1192 1278L1255 1278L1455 1278L1528 1278C1533.66 1278 1539.34 1277.91 1545 1278.01C1548.34 1278.07 1550.94 1278.83 1553 1276L1158 1276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1695 1276L1696 1277L1695 1276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M241 1277L242 1278L241 1277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7b7d1",
      stroke: "none"
    },
    d: "M499 1277L500 1278L499 1277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1695 1277L1696 1278L1695 1277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1808 1277L1809 1278L1808 1277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M355 1278L356 1279L355 1278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7b6d1",
      stroke: "none"
    },
    d: "M500 1278L501 1279L500 1278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#133b83",
      stroke: "none"
    },
    d: "M501 1278C506.274 1282 516.577 1280 523 1280L580 1280L800 1280L864 1280C869.374 1280 882.746 1282.47 886 1278L501 1278M1160 1278C1160 1279.8 1160.01 1279.52 1161 1281C1171.41 1278.52 1183.33 1280 1194 1280L1256 1280L1454 1280L1527 1280C1532.33 1280 1537.67 1279.92 1543 1280.01C1546.34 1280.07 1548.94 1280.83 1551 1278L1160 1278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1694 1278L1695 1279L1694 1278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M242 1279L243 1280L242 1279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7b6d0",
      stroke: "none"
    },
    d: "M501 1279L502 1280L501 1279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1807 1279L1808 1280L1807 1279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M356 1280L357 1281L356 1280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6b5d0",
      stroke: "none"
    },
    d: "M502 1280L503 1281L502 1280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#113880",
      stroke: "none"
    },
    d: "M503 1280C508.274 1284 518.577 1282 525 1282L581 1282L799 1282L863 1282C868.242 1282 880.81 1284.38 884 1280L503 1280M1162 1280C1162 1281.8 1162.01 1281.52 1163 1283C1173.41 1280.52 1185.33 1282 1196 1282L1257 1282L1453 1282L1525 1282C1530.33 1282 1535.67 1281.92 1541 1282.01C1544.34 1282.07 1546.94 1282.83 1549 1280L1162 1280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1693 1280L1694 1281L1693 1280M1807 1280L1808 1281L1807 1280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6b4cf",
      stroke: "none"
    },
    d: "M503 1281L504 1282L503 1281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M243 1282L244 1283L243 1282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M357 1282L358 1283L357 1282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6b4cf",
      stroke: "none"
    },
    d: "M504 1282L505 1283L504 1282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f357d",
      stroke: "none"
    },
    d: "M505 1282C509.497 1287.12 518.622 1285 525 1285L579 1285L799 1285L861 1285C866.855 1285 878.77 1287.56 882 1282L505 1282M1164 1282C1167.11 1287.36 1177.4 1285 1183 1285L1237 1285L1465 1285L1526 1285C1531.85 1285 1543.77 1287.56 1547 1282L1164 1282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1692 1282L1693 1283L1692 1282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1806 1282L1807 1283L1806 1282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5b3ce",
      stroke: "none"
    },
    d: "M505 1283L506 1284L505 1283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M244 1284L245 1285L244 1284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M358 1284L359 1285L358 1284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1691 1284L1692 1285L1691 1284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M244 1285L245 1286L244 1285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c3179",
      stroke: "none"
    },
    d: "M509 1285C509 1286.8 509.014 1286.52 510 1288C520.117 1285.59 531.637 1287 542 1287L600 1287L787 1287L856 1287C861.506 1287 875.682 1289.56 879 1285L509 1285M1167 1285C1167 1286.8 1167.01 1286.52 1168 1288C1180.79 1284.95 1195.88 1287 1209 1287L1289 1287L1544 1287L1544 1285L1167 1285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1805 1285L1806 1286L1805 1285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M359 1286L360 1287L359 1286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1690 1286L1691 1287L1690 1286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M245 1287L246 1288L245 1287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M360 1287L361 1288L360 1287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2e76",
      stroke: "none"
    },
    d: "M511 1287C514.626 1292.75 523.016 1291 529 1291L581 1291L798 1291L857 1291C863.263 1291 873.542 1293.27 877 1287L511 1287M1169 1287C1172.53 1293.41 1183.59 1291 1190 1291L1251 1291L1469 1291L1522 1291C1528.89 1291 1537.19 1292.77 1542 1287L1169 1287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#677daa",
      stroke: "none"
    },
    d: "M1542 1287L1543 1288L1542 1287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1804 1287L1805 1288L1804 1287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#667ca9",
      stroke: "none"
    },
    d: "M1541 1288L1542 1289L1541 1288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1689 1288L1690 1289L1689 1288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1804 1288L1805 1289L1804 1288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M246 1289L247 1290L246 1289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M361 1289L362 1290L361 1289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M512 1289L513 1290L512 1289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1540 1289L1541 1290L1540 1289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1688 1289L1689 1290L1688 1289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M246 1290L247 1291L246 1290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7589b2",
      stroke: "none"
    },
    d: "M513 1290L514 1291L513 1290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1539 1290L1540 1291L1539 1290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1803 1290L1804 1291L1803 1290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M362 1291L363 1292L362 1291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4b1cc",
      stroke: "none"
    },
    d: "M514 1291L515 1292L514 1291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d327a",
      stroke: "none"
    },
    d: "M515 1291C520.748 1295.35 532.971 1293 540 1293L603 1293L789 1293L845 1293C854.195 1293 865.158 1294.61 874 1292C870.565 1290.56 866.702 1291 863 1291L842 1291L769 1291L515 1291M1172 1291C1177.75 1295.35 1189.97 1293 1197 1293L1262 1293L1451 1293L1509 1293C1518.19 1293 1529.16 1294.61 1538 1292C1534.3 1290.45 1529.98 1291 1526 1291L1505 1291L1431 1291L1172 1291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1687 1291L1688 1292L1687 1291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M247 1292L248 1293L247 1292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1802 1292L1803 1293L1802 1292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M363 1293L364 1294L363 1293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10367e",
      stroke: "none"
    },
    d: "M517 1293C523.164 1297.21 534.74 1295 542 1295L605 1295L788 1295L844 1295C852.901 1295 863.439 1296.53 872 1294C868.566 1292.56 864.702 1293 861 1293L840 1293L768 1293L517 1293M1174 1293C1179.75 1297.35 1191.97 1295 1199 1295L1263 1295L1449 1295L1506 1295C1515.19 1295 1526.16 1296.61 1535 1294C1531.3 1292.45 1526.98 1293 1523 1293L1503 1293L1429 1293L1174 1293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6980ad",
      stroke: "none"
    },
    d: "M1535 1293L1536 1294L1535 1293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1686 1293L1687 1294L1686 1293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M248 1294L249 1295L248 1294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M364 1294L365 1295L364 1294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b75a6",
      stroke: "none"
    },
    d: "M518 1294L519 1295L518 1294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#879abe",
      stroke: "none"
    },
    d: "M1534 1294L1535 1295L1534 1294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M248 1295L249 1296L248 1295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#889cc0",
      stroke: "none"
    },
    d: "M519 1295L520 1296L519 1295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#133b83",
      stroke: "none"
    },
    d: "M520 1295C525.591 1299.24 537.172 1297 544 1297L606 1297L787 1297L842 1297C850.901 1297 861.439 1298.53 870 1296C861.643 1292.49 848.06 1295 839 1295L767 1295L520 1295M1176 1295C1181.75 1299.35 1193.97 1297 1201 1297L1264 1297L1448 1297L1504 1297C1513.19 1297 1524.16 1298.61 1533 1296C1529.3 1294.45 1524.98 1295 1521 1295L1501 1295L1428 1295L1176 1295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5c1d7",
      stroke: "none"
    },
    d: "M1533 1295L1534 1296L1533 1295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1685 1295L1686 1296L1685 1295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1801 1295L1802 1296L1801 1295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M365 1296L366 1297L365 1296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5c1d8",
      stroke: "none"
    },
    d: "M520 1296L521 1297L520 1296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1684 1296L1685 1297L1684 1296M249 1297L250 1298L249 1297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163f87",
      stroke: "none"
    },
    d: "M522 1297C528.164 1301.21 539.74 1299 547 1299L608 1299L786 1299L840 1299C848.901 1299 859.439 1300.53 868 1298C859.643 1294.49 846.06 1297 837 1297L767 1297L522 1297M1178 1297C1183.59 1301.24 1195.17 1299 1202 1299L1265 1299L1447 1299L1502 1299C1510.9 1299 1521.44 1300.53 1530 1298C1526.3 1296.45 1521.98 1297 1518 1297L1498 1297L1427 1297L1178 1297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c85b2",
      stroke: "none"
    },
    d: "M1530 1297L1531 1298L1530 1297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1800 1297L1801 1298L1800 1297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M366 1298L367 1299L366 1298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d87b4",
      stroke: "none"
    },
    d: "M523 1298L524 1299L523 1298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99abca",
      stroke: "none"
    },
    d: "M1529 1298L1530 1299L1529 1298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1683 1298L1684 1299L1683 1298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M250 1299L251 1300L250 1299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M367 1299L368 1300L367 1299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M524 1299L525 1300L524 1299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18428a",
      stroke: "none"
    },
    d: "M525 1299C536.469 1311.52 556.468 1319.81 572 1326C591.07 1333.61 611.494 1338.51 632 1339.91C645.544 1340.84 659.424 1340 673 1340L749 1340L801 1340C808.09 1340 818.305 1341.87 825 1339.4C830.116 1337.51 834.245 1331.75 838 1328C847.282 1318.72 858.436 1309.74 866 1299L525 1299M1180 1299C1187.56 1309.74 1198.72 1318.72 1208 1328C1211.75 1331.75 1215.88 1337.51 1221 1339.4C1228.21 1342.05 1239.36 1340 1247 1340L1306 1340L1384 1340C1406.94 1340 1429.5 1340.46 1452 1335.12C1480.3 1328.4 1503.54 1315.09 1528 1300C1519.64 1296.49 1506.06 1299 1497 1299L1426 1299L1180 1299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1799 1299L1800 1300L1799 1299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607daf",
      stroke: "none"
    },
    d: "M1526 1300L1527 1301L1526 1300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1799 1300L1800 1301L1799 1300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M251 1301L252 1302L251 1301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M368 1301L369 1302L368 1301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d95bd",
      stroke: "none"
    },
    d: "M527 1301L528 1302L527 1301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M1525 1301L1526 1302L1525 1301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1681 1301L1682 1302L1681 1301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M251 1302L252 1303L251 1302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7c4da",
      stroke: "none"
    },
    d: "M528 1302L529 1303L528 1302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1798 1302L1799 1303L1798 1302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M252 1303L253 1304L252 1303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607daf",
      stroke: "none"
    },
    d: "M530 1303L531 1304L530 1303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1522 1303L1523 1304L1522 1303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1680 1303L1681 1304L1680 1303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M252 1304L253 1305L252 1304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M370 1304L371 1305L370 1304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9aaccc",
      stroke: "none"
    },
    d: "M531 1304L532 1305L531 1304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M1521 1304L1522 1305L1521 1304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1679 1304L1680 1305L1679 1304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1797 1304L1798 1305L1797 1304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5271a7",
      stroke: "none"
    },
    d: "M533 1305L534 1306L533 1305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d95bd",
      stroke: "none"
    },
    d: "M1519 1305L1520 1306L1519 1305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M253 1306L254 1307L253 1306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M371 1306L372 1307L371 1306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9aaccc",
      stroke: "none"
    },
    d: "M534 1306L535 1307L534 1306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M1518 1306L1519 1307L1518 1306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1678 1306L1679 1307L1678 1306M1796 1306L1797 1307L1796 1306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M372 1307L373 1308L372 1307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5271a7",
      stroke: "none"
    },
    d: "M536 1307L537 1308L536 1307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d95bd",
      stroke: "none"
    },
    d: "M1516 1307L1517 1308L1516 1307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1677 1307L1678 1308L1677 1307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M254 1308L255 1309L254 1308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M537 1308L538 1309L537 1308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M1515 1308L1516 1309L1515 1308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1795 1308L1796 1309L1795 1308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M373 1309L374 1310L373 1309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607daf",
      stroke: "none"
    },
    d: "M539 1309L540 1310L539 1309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1513 1309L1514 1310L1513 1309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1676 1309L1677 1310L1676 1309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M255 1310L256 1311L255 1310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M374 1310L375 1311L374 1310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M540 1310L541 1311L540 1310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5271a7",
      stroke: "none"
    },
    d: "M1511 1310L1512 1311L1511 1310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1675 1310L1676 1311L1675 1310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1794 1310L1795 1311L1794 1310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M542 1311L543 1312L542 1311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7c4da",
      stroke: "none"
    },
    d: "M1510 1311L1511 1312L1510 1311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1794 1311L1795 1312L1794 1311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M256 1312L257 1313L256 1312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M375 1312L376 1313L375 1312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607daf",
      stroke: "none"
    },
    d: "M544 1312L545 1313L544 1312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1508 1312L1509 1313L1508 1312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1674 1312L1675 1313L1674 1312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1793 1312L1794 1313L1793 1312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M376 1313L377 1314L376 1313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M545 1313L546 1314L545 1313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607daf",
      stroke: "none"
    },
    d: "M1506 1313L1507 1314L1506 1313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1673 1313L1674 1314L1673 1313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1793 1313L1794 1314L1793 1313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M257 1314L258 1315L257 1314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M547 1314L548 1315L547 1314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M1505 1314L1506 1315L1505 1314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M257 1315L258 1316L257 1315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M549 1315L550 1316L549 1315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M1503 1315L1504 1316L1503 1315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1672 1315L1673 1316L1672 1315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1792 1315L1793 1316L1792 1315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M258 1316L259 1317L258 1316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M378 1316L379 1317L378 1316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M551 1316L552 1317L551 1316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1501 1316L1502 1317L1501 1316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1671 1316L1672 1317L1671 1316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M258 1317L259 1318L258 1317M379 1317L380 1318L379 1317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M553 1317L554 1318L553 1317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1499 1317L1500 1318L1499 1317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1791 1317L1792 1318L1791 1317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M259 1318L260 1319L259 1318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M555 1318L556 1319L555 1318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1497 1318L1498 1319L1497 1318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M259 1319L260 1320L259 1319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M380 1319L381 1320L380 1319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M557 1319L558 1320L557 1319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1495 1319L1496 1320L1495 1319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1669 1319L1670 1320L1669 1319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1790 1319L1791 1320L1790 1319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M260 1320L261 1321L260 1320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M381 1320L382 1321L381 1320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M559 1320L560 1321L559 1320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1493 1320L1494 1321L1493 1320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1668 1320L1669 1321L1668 1320M260 1321L261 1322L260 1321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M561 1321L562 1322L561 1321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1491 1321L1492 1322L1491 1321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1789 1321L1790 1322L1789 1321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M261 1322L262 1323L261 1322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M563 1322L564 1323L563 1322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M1489 1322L1490 1323L1489 1322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1667 1322L1668 1323L1667 1322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M261 1323L262 1324L261 1323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M383 1323L384 1324L383 1323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M565 1323L566 1324L565 1323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5271a7",
      stroke: "none"
    },
    d: "M1486 1323L1487 1324L1486 1323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7c4da",
      stroke: "none"
    },
    d: "M1487 1323L1488 1324L1487 1323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1666 1323L1667 1324L1666 1323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1788 1323L1789 1324L1788 1323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M262 1324L263 1325L262 1324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M384 1324L385 1325L384 1324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M567 1324L568 1325L567 1324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607daf",
      stroke: "none"
    },
    d: "M568 1324L569 1325L568 1324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M1484 1324L1485 1325L1484 1324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M262 1325L263 1326L262 1325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M570 1325L571 1326L570 1325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9aaccc",
      stroke: "none"
    },
    d: "M1482 1325L1483 1326L1482 1325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1787 1325L1788 1326L1787 1325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M263 1326L264 1327L263 1326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M572 1326L573 1327L572 1326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607daf",
      stroke: "none"
    },
    d: "M573 1326L574 1327L573 1326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M1479 1326L1480 1327L1479 1326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M1480 1326L1481 1327L1480 1326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1664 1326L1665 1327L1664 1326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M386 1327L387 1328L386 1327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M575 1327L576 1328L575 1327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M1477 1327L1478 1328L1477 1327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1663 1327L1664 1328L1663 1327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1786 1327L1787 1328L1786 1327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M264 1328L265 1329L264 1328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M387 1328L388 1329L387 1328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M577 1328L578 1329L577 1328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M578 1328L579 1329L578 1328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d95bd",
      stroke: "none"
    },
    d: "M1474 1328L1475 1329L1474 1328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1662 1328L1663 1329L1662 1328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1785 1328L1786 1329L1785 1328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7c4da",
      stroke: "none"
    },
    d: "M580 1329L581 1330L580 1329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M581 1329L582 1330L581 1329M1471 1329L1472 1330L1471 1329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1785 1329L1786 1330L1785 1329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M265 1330L266 1331L265 1330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M583 1330L584 1331L583 1330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607daf",
      stroke: "none"
    },
    d: "M584 1330L585 1331L584 1330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M1468 1330L1469 1331L1468 1330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7c4da",
      stroke: "none"
    },
    d: "M1469 1330L1470 1331L1469 1330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1784 1330L1785 1331L1784 1330M389 1331L390 1332L389 1331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7c4da",
      stroke: "none"
    },
    d: "M586 1331L587 1332L586 1331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M587 1331L588 1332L587 1331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d95bd",
      stroke: "none"
    },
    d: "M1465 1331L1466 1332L1465 1331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1660 1331L1661 1332L1660 1331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1784 1331L1785 1332L1784 1331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M266 1332L267 1333L266 1332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M390 1332L391 1333L390 1332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d95bd",
      stroke: "none"
    },
    d: "M590 1332L591 1333L590 1332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5271a7",
      stroke: "none"
    },
    d: "M1461 1332L1462 1333L1461 1332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9aaccc",
      stroke: "none"
    },
    d: "M1462 1332L1463 1333L1462 1332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1659 1332L1660 1333L1659 1332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1783 1332L1784 1333L1783 1332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M391 1333L392 1334L391 1333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M593 1333L594 1334L593 1333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M594 1333L595 1334L594 1333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d95bd",
      stroke: "none"
    },
    d: "M1458 1333L1459 1334L1458 1333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7c4da",
      stroke: "none"
    },
    d: "M1459 1333L1460 1334L1459 1333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M267 1334L268 1335L267 1334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9aaccc",
      stroke: "none"
    },
    d: "M597 1334L598 1335L597 1334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607daf",
      stroke: "none"
    },
    d: "M598 1334L599 1335L598 1334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M1454 1334L1455 1335L1454 1334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M1455 1334L1456 1335L1455 1334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1782 1334L1783 1335L1782 1334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M601.667 1335.33C601.222 1335.78 602.278 1335.72 602.333 1335.67C602.778 1335.22 601.722 1335.28 601.667 1335.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8b8d3",
      stroke: "none"
    },
    d: "M1450.67 1335.33C1450.22 1335.78 1451.28 1335.72 1451.33 1335.67C1451.78 1335.22 1450.72 1335.28 1450.67 1335.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M268 1336L269 1337L268 1336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M605.667 1336.33C605.222 1336.78 606.278 1336.72 606.333 1336.67C606.778 1336.22 605.722 1336.28 605.667 1336.33M1445.67 1336.33C1445.22 1336.78 1446.28 1336.72 1446.33 1336.67C1446.78 1336.22 1445.72 1336.28 1445.67 1336.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M1447 1336L1448 1337L1447 1336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1656 1336L1657 1337L1656 1336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1781 1336L1782 1337L1781 1336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M269 1337L270 1338L269 1337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M394 1337L395 1338L394 1337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M609.667 1337.33C609.222 1337.78 610.278 1337.72 610.333 1337.67C610.778 1337.22 609.722 1337.28 609.667 1337.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607daf",
      stroke: "none"
    },
    d: "M611 1337C612.248 1337.68 612.548 1337.75 614 1338C612.752 1337.32 612.452 1337.25 611 1337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M1439 1337C1440.25 1337.68 1440.55 1337.75 1442 1338C1440.75 1337.32 1440.45 1337.25 1439 1337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1655 1337L1656 1338L1655 1337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M269 1338L270 1339L269 1338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M395 1338L396 1339L395 1338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M615.667 1338.33C615.222 1338.78 616.278 1338.72 616.333 1338.67C616.778 1338.22 615.722 1338.28 615.667 1338.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f89b6",
      stroke: "none"
    },
    d: "M617 1338C618.248 1338.68 618.548 1338.75 620 1339C618.752 1338.32 618.451 1338.25 617 1338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5271a7",
      stroke: "none"
    },
    d: "M1432.67 1338.33C1432.22 1338.78 1433.28 1338.72 1433.33 1338.67C1433.78 1338.22 1432.72 1338.28 1432.67 1338.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1434.67 1338.33C1434.22 1338.78 1435.28 1338.72 1435.33 1338.67C1435.78 1338.22 1434.72 1338.28 1434.67 1338.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e7f0",
      stroke: "none"
    },
    d: "M1436.67 1338.33C1436.22 1338.78 1437.28 1338.72 1437.33 1338.67C1437.78 1338.22 1436.72 1338.28 1436.67 1338.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1654 1338L1655 1339L1654 1338M1780 1338L1781 1339L1780 1338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M270 1339L271 1340L270 1339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M396 1339L397 1340L396 1339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M622.667 1339.33C622.222 1339.78 623.278 1339.72 623.333 1339.67C623.778 1339.22 622.722 1339.28 622.667 1339.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M624 1339C625.248 1339.68 625.548 1339.75 627 1340C625.752 1339.32 625.452 1339.25 624 1339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5271a7",
      stroke: "none"
    },
    d: "M627.667 1339.33C627.222 1339.78 628.278 1339.72 628.333 1339.67C628.778 1339.22 627.722 1339.28 627.667 1339.33M1424.67 1339.33C1424.22 1339.78 1425.28 1339.72 1425.33 1339.67C1425.78 1339.22 1424.72 1339.28 1424.67 1339.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1426 1339C1427.25 1339.68 1427.55 1339.75 1429 1340C1427.75 1339.32 1427.45 1339.25 1426 1339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e7f0",
      stroke: "none"
    },
    d: "M1429.67 1339.33C1429.22 1339.78 1430.28 1339.72 1430.33 1339.67C1430.78 1339.22 1429.72 1339.28 1429.67 1339.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M632 1340C633.248 1340.68 633.548 1340.75 635 1341C633.752 1340.32 633.452 1340.25 632 1340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M635 1340C636.769 1340.78 638.036 1340.91 640 1341C638.231 1340.22 636.964 1340.09 635 1340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5271a7",
      stroke: "none"
    },
    d: "M640 1340C645.216 1342.19 652.381 1341 658 1341L695 1341L825 1341C819.784 1338.81 812.619 1340 807 1340L770 1340L640 1340M1221 1340C1226.22 1342.19 1233.38 1341 1239 1341L1278 1341L1413 1341C1407.78 1338.81 1400.62 1340 1395 1340L1356 1340L1221 1340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ca1c5",
      stroke: "none"
    },
    d: "M1413 1340C1414.77 1340.78 1416.04 1340.91 1418 1341C1416.23 1340.22 1414.96 1340.09 1413 1340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5d0e2",
      stroke: "none"
    },
    d: "M1418 1340C1419.25 1340.69 1419.55 1340.75 1421 1341C1419.75 1340.32 1419.45 1340.25 1418 1340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1779 1340L1780 1341L1779 1340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M271 1341L272 1342L271 1341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1778 1341L1779 1342L1778 1341M1651 1342L1652 1343L1651 1342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M272 1343L273 1344L272 1343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M399 1343L400 1344L399 1343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1650 1343L1651 1344L1650 1343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1777 1343L1778 1344L1777 1343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M400 1344L401 1345L400 1344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1649 1344L1650 1345L1649 1344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M273 1345L274 1346L273 1345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M401 1345L402 1346L401 1345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1648 1345L1649 1346L1648 1345M1776 1345L1777 1346L1776 1345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M274 1346L275 1347L274 1346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M402 1346L403 1347L402 1346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1775 1346L1776 1347L1775 1346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M403 1347L404 1348L403 1347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1775 1347L1776 1348L1775 1347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M275 1348L276 1349L275 1348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1774 1348L1775 1349L1774 1348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M276 1350L277 1351L276 1350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1773 1350L1774 1351L1773 1350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M277 1351L278 1352L277 1351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1642 1352L1643 1353L1642 1352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1772 1352L1773 1353L1772 1352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M278 1353L279 1354L278 1353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1641 1353L1642 1354L1641 1353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1771 1353L1772 1354L1771 1353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M409 1354L410 1355L409 1354M1640 1354L1641 1355L1640 1354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M279 1355L280 1356L279 1355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M410 1355L411 1356L410 1355M1639 1355L1640 1356L1639 1355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1770 1355L1771 1356L1770 1355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M280 1356L281 1357L280 1356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M411 1356L412 1357L411 1356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1638 1356L1639 1357L1638 1356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1769 1356L1770 1357L1769 1356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M412 1357L413 1358L412 1357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1637 1357L1638 1358L1637 1357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M281 1358L282 1359L281 1358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M413 1358L414 1359L413 1358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1636 1358L1637 1359L1636 1358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1768 1358L1769 1359L1768 1358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M282 1359L283 1360L282 1359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M414 1359L415 1360L414 1359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1635 1359L1636 1360L1635 1359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M415 1360L416 1361L415 1360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1634 1360L1635 1361L1634 1360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1767 1360L1768 1361L1767 1360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M283 1361L284 1362L283 1361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M416 1361L417 1362L416 1361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1633 1361L1634 1362L1633 1361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1766 1361L1767 1362L1766 1361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M284 1362L285 1363L284 1362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M417 1362L418 1363L417 1362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1632 1362L1633 1363L1632 1362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M418 1363L419 1364L418 1363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1631 1363L1632 1364L1631 1363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1765 1363L1766 1364L1765 1363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M285 1364L286 1365L285 1364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M419 1364L420 1365L419 1364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1630 1364L1631 1365L1630 1364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1764 1364L1765 1365L1764 1364M420 1365L421 1366L420 1365M1629 1365L1630 1366L1629 1365M421 1366L422 1367L421 1366M1628 1366L1629 1367L1628 1366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1763 1366L1764 1367L1763 1366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M287 1367L288 1368L287 1367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M422 1367L423 1368L422 1367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1627 1367L1628 1368L1627 1367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1762 1367L1763 1368L1762 1367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1626 1368L1627 1369L1626 1368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1761 1369L1762 1370L1761 1369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M289 1370L290 1371L289 1370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1760 1370L1761 1371L1760 1370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M290 1371L291 1372L290 1371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1759 1372L1760 1373L1759 1372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M291 1373L292 1374L291 1373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M429 1373L430 1374L429 1373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1758 1373L1759 1374L1758 1373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M292 1374L293 1375L292 1374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M430 1374L431 1375L430 1374M1619 1374L1620 1375L1619 1374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M431 1375L432 1376L431 1375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1618 1375L1619 1376L1618 1375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M293 1376L294 1377L293 1376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M432 1376L433 1377L432 1376M1617 1376L1618 1377L1617 1376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1756 1376L1757 1377L1756 1376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M294 1377L295 1378L294 1377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1616 1377L1617 1378L1616 1377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1755 1377L1756 1378L1755 1377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M436 1379L437 1380L436 1379M1754 1379L1755 1380L1754 1379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M296 1380L297 1381L296 1380M437 1380L438 1381L437 1380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1612 1380L1613 1381L1612 1380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1753 1380L1754 1381L1753 1380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M297 1381L298 1382L297 1381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M438 1381L439 1382L438 1381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1611 1381L1612 1382L1611 1381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1610 1382L1611 1383L1610 1382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M298 1383L299 1384L298 1383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1751 1383L1752 1384L1751 1383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M299 1384L300 1385L299 1384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M442 1384L443 1385L442 1384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1607 1384L1608 1385L1607 1384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1750 1384L1751 1385L1750 1384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M443 1385L444 1386L443 1385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1606 1385L1607 1386L1606 1385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M444 1386L445 1387L444 1386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1605 1386L1606 1387L1605 1386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M301 1387L302 1388L301 1387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1748 1387L1749 1388L1748 1387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M302 1388L303 1389L302 1388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M447 1388L448 1389L447 1388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1602 1388L1603 1389L1602 1388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1747 1388L1748 1389L1747 1388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M303 1389L304 1390L303 1389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M448 1389L449 1390L448 1389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1016.67 1389.33C1016.22 1389.78 1017.28 1389.72 1017.33 1389.67C1017.78 1389.22 1016.72 1389.28 1016.67 1389.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1018.67 1389.33C1018.22 1389.78 1019.28 1389.72 1019.33 1389.67C1019.78 1389.22 1018.72 1389.28 1018.67 1389.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#092c74",
      stroke: "none"
    },
    d: "M1020 1389.44C1006.08 1391.62 997.58 1400.42 988 1410C979.121 1418.88 970.252 1427.69 961.83 1437C948.303 1451.95 933.257 1465.74 919 1480C900.155 1498.84 881.831 1518.17 863 1537C851.341 1548.66 839.487 1560.16 828.015 1572C823.788 1576.36 819.145 1583.06 824.434 1588.7C829.82 1594.43 842.907 1592 850 1592L919 1592L1126 1592L1189 1592C1198.6 1592 1210.73 1593.97 1220 1591.28C1227.8 1589.01 1228.39 1580.65 1223.77 1575C1213.51 1562.45 1200.47 1551.47 1189 1540C1150.35 1501.35 1112.55 1461.74 1074 1423C1059.56 1408.49 1043.34 1385.77 1020 1389.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1029 1389C1030.25 1389.68 1030.55 1389.75 1032 1390C1030.75 1389.32 1030.45 1389.25 1029 1389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1032 1389L1033 1390L1032 1389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1601 1389L1602 1390L1601 1389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1013 1390L1014 1391L1013 1390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1014 1390L1015 1391L1014 1390M1034 1390L1035 1391L1034 1390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1035 1390L1036 1391L1035 1390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1600 1390L1601 1391L1600 1390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M304 1391L305 1392L304 1391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M451 1391L452 1392L451 1391M1010 1391L1011 1392L1010 1391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1011 1391L1012 1392L1011 1391M1037 1391L1038 1392L1037 1391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1038 1391L1039 1392L1038 1391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1598 1391L1599 1392L1598 1391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1745 1391L1746 1392L1745 1391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M305 1392L306 1393L305 1392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M452 1392L453 1393L452 1392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1008 1392L1009 1393L1008 1392M1040 1392L1041 1393L1040 1392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1597 1392L1598 1393L1597 1392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1744 1392L1745 1393L1744 1392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M306 1393L307 1394L306 1393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1006 1393L1007 1394L1006 1393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1042 1393L1043 1394L1042 1393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1596 1393L1597 1394L1596 1393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M455 1394L456 1395L455 1394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1005 1394L1006 1395L1005 1394M1043 1394L1044 1395L1043 1394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1594 1394L1595 1395L1594 1394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M456 1395L457 1396L456 1395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1003 1395L1004 1396L1003 1395M1045 1395L1046 1396L1045 1395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1593 1395L1594 1396L1593 1395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1742 1395L1743 1396L1742 1395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M308 1396L309 1397L308 1396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M458 1396L459 1397L458 1396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1002 1396L1003 1397L1002 1396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1046 1396L1047 1397L1046 1396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1741 1396L1742 1397L1741 1396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M309 1397L310 1398L309 1397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M459 1397L460 1398L459 1397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1590 1397L1591 1398L1590 1397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1740 1397L1741 1398L1740 1397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M310 1398L311 1399L310 1398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1589 1398L1590 1399L1589 1398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M462 1399L463 1400L462 1399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1587 1399L1588 1400L1587 1399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M463 1400L464 1401L463 1400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1586 1400L1587 1401L1586 1400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M312 1401L313 1402L312 1401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M465 1401L466 1402L465 1401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1584 1401L1585 1402L1584 1401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1737 1401L1738 1402L1737 1401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M313 1402L314 1403L313 1402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M466 1402L467 1403L466 1402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1583 1402L1584 1403L1583 1402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1736 1402L1737 1403L1736 1402M314 1403L315 1404L314 1403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M468 1403L469 1404L468 1403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1581 1403L1582 1404L1581 1403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1735 1403L1736 1404L1735 1403M469 1404L470 1405L469 1404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1580 1404L1581 1405L1580 1404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M471 1405L472 1406L471 1405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1578 1405L1579 1406L1578 1405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1577 1406L1578 1407L1577 1406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1733 1406L1734 1407L1733 1406M317 1407L318 1408L317 1407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M474 1407L475 1408L474 1407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1575 1407L1576 1408L1575 1407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1732 1407L1733 1408L1732 1407M318 1408L319 1409L318 1408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M476 1408L477 1409L476 1408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1573 1408L1574 1409L1573 1408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1731 1408L1732 1409L1731 1408M319 1409L320 1410L319 1409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M477 1409L478 1410L477 1409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1572 1409L1573 1410L1572 1409M1730 1409L1731 1410L1730 1409M320 1410L321 1411L320 1410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M479 1410L480 1411L479 1410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1570 1410L1571 1411L1570 1410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M481 1411L482 1412L481 1411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1568 1411L1569 1412L1568 1411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M482 1412L483 1413L482 1412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1567 1412L1568 1413L1567 1412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M484 1413L485 1414L484 1413M1565 1413L1566 1414L1565 1413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M486 1414L487 1415L486 1414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1563 1414L1564 1415L1563 1414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1726 1414L1727 1415L1726 1414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M324 1415L325 1416L324 1415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M488 1415L489 1416L488 1415M1561 1415L1562 1416L1561 1415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1562 1415L1563 1416L1562 1415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1725 1415L1726 1416L1725 1415M325 1416L326 1417L325 1416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M489 1416L490 1417L489 1416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1560 1416L1561 1417L1560 1416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1724 1416L1725 1417L1724 1416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M326 1417L327 1418L326 1417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M491 1417L492 1418L491 1417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1558 1417L1559 1418L1558 1417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1723 1417L1724 1418L1723 1417M327 1418L328 1419L327 1418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M493 1418L494 1419L493 1418M1556 1418L1557 1419L1556 1418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1722 1418L1723 1419L1722 1418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M328 1419L329 1420L328 1419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M495 1419L496 1420L495 1419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1554 1419L1555 1420L1554 1419M497 1420L498 1421L497 1420M1552 1420L1553 1421L1552 1420M499 1421L500 1422L499 1421M1550 1421L1551 1422L1550 1421M501 1422L502 1423L501 1422M1548 1422L1549 1423L1548 1422M503 1423L504 1424L503 1423M1546 1423L1547 1424L1546 1423M505 1424L506 1425L505 1424M1544 1424L1545 1425L1544 1424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M507 1425L508 1426L507 1425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1542 1425L1543 1426L1542 1425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M509 1426L510 1427L509 1426M1540 1426L1541 1427L1540 1426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1715 1426L1716 1427L1715 1426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M511 1427L512 1428L511 1427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1538 1427L1539 1428L1538 1427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1714 1427L1715 1428L1714 1427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M336 1428L337 1429L336 1428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M513 1428L514 1429L513 1428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M514 1428L515 1429L514 1428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1536 1428L1537 1429L1536 1428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1713 1428L1714 1429L1713 1428M337 1429L338 1430L337 1429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M515 1429L516 1430L515 1429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M516 1429L517 1430L516 1429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1533 1429L1534 1430L1533 1429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1534 1429L1535 1430L1534 1429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1712 1429L1713 1430L1712 1429M338 1430L339 1431L338 1430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M518 1430L519 1431L518 1430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1531 1430L1532 1431L1531 1430M1711 1430L1712 1431L1711 1430M339 1431L340 1432L339 1431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M520 1431L521 1432L520 1431M1081 1431L1082 1432L1081 1431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1529 1431L1530 1432L1529 1431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1710 1431L1711 1432L1710 1431M340 1432L341 1433L340 1432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M522 1432L523 1433L522 1432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M523 1432L524 1433L523 1432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1082 1432L1083 1433L1082 1432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1526 1432L1527 1433L1526 1432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1527 1432L1528 1433L1527 1432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1709 1432L1710 1433L1709 1432M341 1433L342 1434L341 1433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M525 1433L526 1434L525 1433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1083 1433L1084 1434L1083 1433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1524 1433L1525 1434L1524 1433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1708 1433L1709 1434L1708 1433M342 1434L343 1435L342 1434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M527 1434L528 1435L527 1434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M528 1434L529 1435L528 1434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1084 1434L1085 1435L1084 1434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1521 1434L1522 1435L1521 1434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1522 1434L1523 1435L1522 1434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1707 1434L1708 1435L1707 1434M343 1435L344 1436L343 1435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M530 1435L531 1436L530 1435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M963 1435L964 1436L963 1435M1085 1435L1086 1436L1085 1435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1519 1435L1520 1436L1519 1435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1706 1435L1707 1436L1706 1435M344 1436L345 1437L344 1436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M533 1436L534 1437L533 1436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M962 1436L963 1437L962 1436M1086 1436L1087 1437L1086 1436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1516 1436L1517 1437L1516 1436M1705 1436L1706 1437L1705 1436M345 1437L346 1438L345 1437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M535 1437L536 1438L535 1437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M536 1437L537 1438L536 1437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M961 1437L962 1438L961 1437M1087 1437L1088 1438L1087 1437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1513 1437L1514 1438L1513 1437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1514 1437L1515 1438L1514 1437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1704 1437L1705 1438L1704 1437M346 1438L347 1439L346 1438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M538 1438L539 1439L538 1438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M539 1438L540 1439L539 1438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M960 1438L961 1439L960 1438M1088 1438L1089 1439L1088 1438M1511 1438L1512 1439L1511 1438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1703 1438L1704 1439L1703 1438M347 1439L348 1440L347 1439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M541 1439L542 1440L541 1439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M959 1439L960 1440L959 1439M1089 1439L1090 1440L1089 1439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1508 1439L1509 1440L1508 1439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1702 1439L1703 1440L1702 1439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M544 1440L545 1441L544 1440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M958 1440L959 1441L958 1440M1090 1440L1091 1441L1090 1440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1505 1440L1506 1441L1505 1440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1701 1440L1702 1441L1701 1440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M547 1441L548 1442L547 1441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M548 1441L549 1442L548 1441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M957 1441L958 1442L957 1441M1091 1441L1092 1442L1091 1441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1502 1441L1503 1442L1502 1441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1700 1441L1701 1442L1700 1441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M550 1442L551 1443L550 1442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M551 1442L552 1443L551 1442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M956 1442L957 1443L956 1442M1092 1442L1093 1443L1092 1442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1498 1442L1499 1443L1498 1442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1499 1442L1500 1443L1499 1442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M553 1443L554 1444L553 1443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M554 1443L555 1444L554 1443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M955 1443L956 1444L955 1443M1093 1443L1094 1444L1093 1443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1495 1443L1496 1444L1495 1443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1496 1443L1497 1444L1496 1443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M557 1444L558 1445L557 1444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M558 1444L559 1445L558 1444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M954 1444L955 1445L954 1444M1094 1444L1095 1445L1094 1444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1491 1444L1492 1445L1491 1444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1492 1444L1493 1445L1492 1444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M560 1445L561 1446L560 1445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M561 1445L562 1446L561 1445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M953 1445L954 1446L953 1445M1095 1445L1096 1446L1095 1445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1488 1445L1489 1446L1488 1445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1489 1445L1490 1446L1489 1445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M564 1446L565 1447L564 1446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M565 1446L566 1447L565 1446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M952 1446L953 1447L952 1446M1096 1446L1097 1447L1096 1446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1484 1446L1485 1447L1484 1446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1485 1446L1486 1447L1485 1446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M356 1447L357 1448L356 1447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M568 1447L569 1448L568 1447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M569 1447L570 1448L569 1447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M951 1447L952 1448L951 1447M1097 1447L1098 1448L1097 1447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1480 1447L1481 1448L1480 1447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1481 1447L1482 1448L1481 1447M357 1448L358 1449L357 1448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M572 1448L573 1449L572 1448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M573 1448L574 1449L573 1448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M950 1448L951 1449L950 1448M1098 1448L1099 1449L1098 1448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1475.67 1448.33C1475.22 1448.78 1476.28 1448.72 1476.33 1448.67C1476.78 1448.22 1475.72 1448.28 1475.67 1448.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1477 1448L1478 1449L1477 1448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1692 1448L1693 1449L1692 1448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M358 1449L359 1450L358 1449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M576 1449L577 1450L576 1449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M577.667 1449.33C577.222 1449.78 578.278 1449.72 578.333 1449.67C578.778 1449.22 577.722 1449.28 577.667 1449.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M949 1449L950 1450L949 1449M1099 1449L1100 1450L1099 1449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1471 1449L1472 1450L1471 1449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1472 1449L1473 1450L1472 1449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1691 1449L1692 1450L1691 1449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M359 1450L360 1451L359 1450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M581.667 1450.33C581.222 1450.78 582.278 1450.72 582.333 1450.67C582.778 1450.22 581.722 1450.28 581.667 1450.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M948 1450L949 1451L948 1450M1100 1450L1101 1451L1100 1450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1466 1450L1467 1451L1466 1450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1467.67 1450.33C1467.22 1450.78 1468.28 1450.72 1468.33 1450.67C1468.78 1450.22 1467.72 1450.28 1467.67 1450.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1690 1450L1691 1451L1690 1450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M360 1451L361 1452L360 1451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M586 1451L587 1452L586 1451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M587 1451C588.248 1451.68 588.548 1451.75 590 1452C588.752 1451.32 588.452 1451.25 587 1451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M947 1451L948 1452L947 1451M1101 1451L1102 1452L1101 1451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1461.67 1451.33C1461.22 1451.78 1462.28 1451.72 1462.33 1451.67C1462.78 1451.22 1461.72 1451.28 1461.67 1451.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284685",
      stroke: "none"
    },
    d: "M1463.67 1451.33C1463.22 1451.78 1464.28 1451.72 1464.33 1451.67C1464.78 1451.22 1463.72 1451.28 1463.67 1451.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1689 1451L1690 1452L1689 1451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M591 1452C592.248 1452.68 592.548 1452.75 594 1453C592.752 1452.32 592.452 1452.25 591 1452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d7e5",
      stroke: "none"
    },
    d: "M594.667 1452.33C594.222 1452.78 595.278 1452.72 595.333 1452.67C595.778 1452.22 594.722 1452.28 594.667 1452.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M946 1452L947 1453L946 1452M1102 1452L1103 1453L1102 1452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1455 1452L1456 1453L1455 1452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1456 1452C1457.25 1452.68 1457.55 1452.75 1459 1453C1457.75 1452.32 1457.45 1452.25 1456 1452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1688 1452L1689 1453L1688 1452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M597.667 1453.33C597.222 1453.78 598.278 1453.72 598.333 1453.67C598.778 1453.22 597.722 1453.28 597.667 1453.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M599 1453C600.248 1453.68 600.548 1453.75 602 1454C600.752 1453.32 600.451 1453.25 599 1453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M945 1453L946 1454L945 1453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1103 1453L1104 1454L1103 1453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1448 1453C1449.25 1453.68 1449.55 1453.75 1451 1454C1449.75 1453.32 1449.45 1453.25 1448 1453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1451.67 1453.33C1451.22 1453.78 1452.28 1453.72 1452.33 1453.67C1452.78 1453.22 1451.72 1453.28 1451.67 1453.33M604.667 1454.33C604.222 1454.78 605.278 1454.72 605.333 1454.67C605.778 1454.22 604.722 1454.28 604.667 1454.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M606.667 1454.33C606.222 1454.78 607.278 1454.72 607.333 1454.67C607.778 1454.22 606.722 1454.28 606.667 1454.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M608.667 1454.33C608.222 1454.78 609.278 1454.72 609.333 1454.67C609.778 1454.22 608.722 1454.28 608.667 1454.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M944 1454L945 1455L944 1454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1104 1454L1105 1455L1104 1454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1440.67 1454.33C1440.22 1454.78 1441.28 1454.72 1441.33 1454.67C1441.78 1454.22 1440.72 1454.28 1440.67 1454.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1442.67 1454.33C1442.22 1454.78 1443.28 1454.72 1443.33 1454.67C1443.78 1454.22 1442.72 1454.28 1442.67 1454.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1444.67 1454.33C1444.22 1454.78 1445.28 1454.72 1445.33 1454.67C1445.78 1454.22 1444.72 1454.28 1444.67 1454.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M365 1455L366 1456L365 1455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M613.667 1455.33C613.222 1455.78 614.278 1455.72 614.333 1455.67C614.778 1455.22 613.722 1455.28 613.667 1455.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M615 1455C616.248 1455.68 616.548 1455.75 618 1456C616.752 1455.32 616.452 1455.25 615 1455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M618 1455C619.248 1455.68 619.548 1455.75 621 1456C619.752 1455.32 619.452 1455.25 618 1455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M943 1455L944 1456L943 1455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1105 1455L1106 1456L1105 1455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1430 1455C1431.25 1455.68 1431.55 1455.75 1433 1456C1431.75 1455.32 1431.45 1455.25 1430 1455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1433.67 1455.33C1433.22 1455.78 1434.28 1455.72 1434.33 1455.67C1434.78 1455.22 1433.72 1455.28 1433.67 1455.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1435.67 1455.33C1435.22 1455.78 1436.28 1455.72 1436.33 1455.67C1436.78 1455.22 1435.72 1455.28 1435.67 1455.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M366 1456L367 1457L366 1456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M624 1456C625.506 1456.68 626.315 1456.83 628 1457C626.494 1456.32 625.685 1456.17 624 1456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M628 1456C629.506 1456.68 630.315 1456.83 632 1457C630.494 1456.32 629.685 1456.17 628 1456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M632 1456C634.332 1456.98 636.457 1456.98 639 1457C636.668 1456.02 634.543 1456.02 632 1456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M942 1456L943 1457L942 1456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1106 1456L1107 1457L1106 1456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1411 1456C1413.33 1456.98 1415.46 1456.98 1418 1457C1415.67 1456.02 1413.54 1456.02 1411 1456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1418 1456C1419.51 1456.68 1420.31 1456.83 1422 1457C1420.49 1456.32 1419.69 1456.17 1418 1456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1422 1456C1423.51 1456.68 1424.31 1456.83 1426 1457C1424.49 1456.32 1423.69 1456.17 1422 1456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1683 1456L1684 1457L1683 1456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M367 1457L368 1458L367 1457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M729 1457L730 1458L729 1457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M941 1457L942 1458L941 1457M1107 1457L1108 1458L1107 1457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1682 1457L1683 1458L1682 1457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M368 1458L369 1459L368 1458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M728 1458L729 1459L728 1458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M940 1458L941 1459L940 1458M1108 1458L1109 1459L1108 1458M1681 1458L1682 1459L1681 1458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M727 1459L728 1460L727 1459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M939 1459L940 1460L939 1459M1109 1459L1110 1460L1109 1459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M726 1460L727 1461L726 1460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M938 1460L939 1461L938 1460M1110 1460L1111 1461L1110 1460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M372 1461L373 1462L372 1461M725 1461L726 1462L725 1461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M937 1461L938 1462L937 1461M1111 1461L1112 1462L1111 1461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1677 1461L1678 1462L1677 1461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M373 1462L374 1463L373 1462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M724 1462L725 1463L724 1462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M936 1462L937 1463L936 1462M1112 1462L1113 1463L1112 1462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1676 1462L1677 1463L1676 1462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M374 1463L375 1464L374 1463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M723 1463L724 1464L723 1463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M935 1463L936 1464L935 1463M1113 1463L1114 1464L1113 1463M1675 1463L1676 1464L1675 1463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M722 1464L723 1465L722 1464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M934 1464L935 1465L934 1464M1114 1464L1115 1465L1114 1464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M377 1465L378 1466L377 1465M721 1465L722 1466L721 1465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M933 1465L934 1466L933 1465M1115 1465L1116 1466L1115 1465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M378 1466L379 1467L378 1466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M720 1466L721 1467L720 1466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M932 1466L933 1467L932 1466M1116 1466L1117 1467L1116 1466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1671 1466L1672 1467L1671 1466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M379 1467L380 1468L379 1467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M719 1467L720 1468L719 1467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M931 1467L932 1468L931 1467M1117 1467L1118 1468L1117 1467M1670 1467L1671 1468L1670 1467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M718 1468L719 1469L718 1468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M930 1468L931 1469L930 1468M1118 1468L1119 1469L1118 1468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M382 1469L383 1470L382 1469M717 1469L718 1470L717 1469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M929 1469L930 1470L929 1469M1119 1469L1120 1470L1119 1469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1667 1469L1668 1470L1667 1469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M383 1470L384 1471L383 1470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M716 1470L717 1471L716 1470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M928 1470L929 1471L928 1470M1120 1470L1121 1471L1120 1470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1666 1470L1667 1471L1666 1470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M715 1471L716 1472L715 1471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M927 1471L928 1472L927 1471M1121 1471L1122 1472L1121 1471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1665 1471L1666 1472L1665 1471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M386 1472L387 1473L386 1472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M714 1472L715 1473L714 1472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M926 1472L927 1473L926 1472M1122 1472L1123 1473L1122 1472M1329 1472L1330 1473L1329 1472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M387 1473L388 1474L387 1473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M713 1473L714 1474L713 1473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M925 1473L926 1474L925 1473M1123 1473L1124 1474L1123 1473M1330 1473L1331 1474L1330 1473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1662 1473L1663 1474L1662 1473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M712 1474L713 1475L712 1474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M924 1474L925 1475L924 1474M1124 1474L1125 1475L1124 1474M1331 1474L1332 1475L1331 1474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1661 1474L1662 1475L1661 1474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M390 1475L391 1476L390 1475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M711 1475L712 1476L711 1475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M923 1475L924 1476L923 1475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1125 1475L1126 1476L1125 1475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1332 1475L1333 1476L1332 1475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M391 1476L392 1477L391 1476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M710 1476L711 1477L710 1476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M922 1476L923 1477L922 1476M1333 1476L1334 1477L1333 1476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1658 1476L1659 1477L1658 1476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M709 1477L710 1478L709 1477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M921 1477L922 1478L921 1477M1334 1477L1335 1478L1334 1477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1657 1477L1658 1478L1657 1477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M394 1478L395 1479L394 1478M708 1478L709 1479L708 1478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1335 1478L1336 1479L1335 1478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1655 1478L1656 1479L1655 1478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M395 1479L396 1480L395 1479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M707 1479L708 1480L707 1479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1336 1479L1337 1480L1336 1479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1654 1479L1655 1480L1654 1479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1337 1480L1338 1481L1337 1480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M398 1481L399 1482L398 1481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1338 1481L1339 1482L1338 1481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1651 1481L1652 1482L1651 1481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1339 1482L1340 1483L1339 1482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1650 1482L1651 1483L1650 1482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M401 1483L402 1484L401 1483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1340 1483L1341 1484L1340 1483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1648 1483L1649 1484L1648 1483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M402 1484L403 1485L402 1484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1341 1484L1342 1485L1341 1484M1647 1484L1648 1485L1647 1484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M404 1485L405 1486L404 1485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1342 1485L1343 1486L1342 1485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1645 1485L1646 1486L1645 1485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M405 1486L406 1487L405 1486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1343 1486L1344 1487L1343 1486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1644 1486L1645 1487L1644 1486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M407 1487L408 1488L407 1487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1344 1487L1345 1488L1344 1487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1642 1487L1643 1488L1642 1487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M408 1488L409 1489L408 1488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1345 1488L1346 1489L1345 1488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1641 1488L1642 1489L1641 1488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M410 1489L411 1490L410 1489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1346 1489L1347 1490L1346 1489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1639 1489L1640 1490L1639 1489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M411 1490L412 1491L411 1490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1347 1490L1348 1491L1347 1490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1638 1490L1639 1491L1638 1490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M413 1491L414 1492L413 1491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1348 1491L1349 1492L1348 1491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1636 1491L1637 1492L1636 1491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M414 1492L415 1493L414 1492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1349 1492L1350 1493L1349 1492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1635 1492L1636 1493L1635 1492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M416 1493L417 1494L416 1493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1350 1493L1351 1494L1350 1493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1633 1493L1634 1494L1633 1493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M417 1494L418 1495L417 1494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1351 1494L1352 1495L1351 1494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1632 1494L1633 1495L1632 1494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M419 1495L420 1496L419 1495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1352 1495L1353 1496L1352 1495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1630 1495L1631 1496L1630 1495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M421 1496L422 1497L421 1496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1353 1496L1354 1497L1353 1496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1628 1496L1629 1497L1628 1496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M422 1497L423 1498L422 1497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1354 1497L1355 1498L1354 1497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1627 1497L1628 1498L1627 1497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M424 1498L425 1499L424 1498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1355 1498L1356 1499L1355 1498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1625 1498L1626 1499L1625 1498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M426 1499L427 1500L426 1499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1356 1499L1357 1500L1356 1499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1623 1499L1624 1500L1623 1499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M427 1500L428 1501L427 1500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1357 1500L1358 1501L1357 1500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1622 1500L1623 1501L1622 1500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M429 1501L430 1502L429 1501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1358 1501L1359 1502L1358 1501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1620 1501L1621 1502L1620 1501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M431 1502L432 1503L431 1502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1359 1502L1360 1503L1359 1502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1618 1502L1619 1503L1618 1502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M432 1503L433 1504L432 1503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1360 1503L1361 1504L1360 1503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1617 1503L1618 1504L1617 1503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M434 1504L435 1505L434 1504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1361 1504L1362 1505L1361 1504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1615 1504L1616 1505L1615 1504M436 1505L437 1506L436 1505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1362 1505L1363 1506L1362 1505M1613 1505L1614 1506L1613 1505M438 1506L439 1507L438 1506M1363 1506L1364 1507L1363 1506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1611 1506L1612 1507L1611 1506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M439 1507L440 1508L439 1507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M440 1507L441 1508L440 1507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1364 1507L1365 1508L1364 1507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1610 1507L1611 1508L1610 1507M441 1508L442 1509L441 1508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1365 1508L1366 1509L1365 1508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1608 1508L1609 1509L1608 1508M443 1509L444 1510L443 1509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1366 1509L1367 1510L1366 1509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1606 1509L1607 1510L1606 1509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M445 1510L446 1511L445 1510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1367 1510L1368 1511L1367 1510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1604 1510L1605 1511L1604 1510M447 1511L448 1512L447 1511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1368 1511L1369 1512L1368 1511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1602 1511L1603 1512L1602 1511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M449 1512L450 1513L449 1512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1369 1512L1370 1513L1369 1512M1600 1512L1601 1513L1600 1512M451 1513L452 1514L451 1513M1370 1513L1371 1514L1370 1513M1598 1513L1599 1514L1598 1513M453 1514L454 1515L453 1514M1371 1514L1372 1515L1371 1514M1596 1514L1597 1515L1596 1514M455 1515L456 1516L455 1515M1372 1515L1373 1516L1372 1515M1594 1515L1595 1516L1594 1515M457 1516L458 1517L457 1516M1373 1516L1374 1517L1373 1516M1592 1516L1593 1517L1592 1516M459 1517L460 1518L459 1517M1374 1517L1375 1518L1374 1517M1590 1517L1591 1518L1590 1517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M461 1518L462 1519L461 1518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1375 1518L1376 1519L1375 1518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1588 1518L1589 1519L1588 1518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M463 1519L464 1520L463 1519M1586 1519L1587 1520L1586 1519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M465 1520L466 1521L465 1520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1169 1520L1170 1521L1169 1520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1584 1520L1585 1521L1584 1520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M467 1521L468 1522L467 1521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M878 1521L879 1522L878 1521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1170 1521L1171 1522L1170 1521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1582 1521L1583 1522L1582 1521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M469 1522L470 1523L469 1522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M470 1522L471 1523L470 1522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M877 1522L878 1523L877 1522M1171 1522L1172 1523L1171 1522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1579 1522L1580 1523L1579 1522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1580 1522L1581 1523L1580 1522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M472 1523L473 1524L472 1523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M664 1523L665 1524L664 1523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M876 1523L877 1524L876 1523M1172 1523L1173 1524L1172 1523M1577 1523L1578 1524L1577 1523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1578 1523L1579 1524L1578 1523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M474 1524L475 1525L474 1524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M663 1524L664 1525L663 1524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M875 1524L876 1525L875 1524M1173 1524L1174 1525L1173 1524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1575 1524L1576 1525L1575 1524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M476 1525L477 1526L476 1525M662 1525L663 1526L662 1525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M874 1525L875 1526L874 1525M1174 1525L1175 1526L1174 1525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1573 1525L1574 1526L1573 1525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M478 1526L479 1527L478 1526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M479 1526L480 1527L479 1526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M661 1526L662 1527L661 1526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M873 1526L874 1527L873 1526M1175 1526L1176 1527L1175 1526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1570 1526L1571 1527L1570 1526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1571 1526L1572 1527L1571 1526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M481 1527L482 1528L481 1527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M660 1527L661 1528L660 1527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M872 1527L873 1528L872 1527M1176 1527L1177 1528L1176 1527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1568 1527L1569 1528L1568 1527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M483 1528L484 1529L483 1528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M484 1528L485 1529L484 1528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M659 1528L660 1529L659 1528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M871 1528L872 1529L871 1528M1177 1528L1178 1529L1177 1528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1566 1528L1567 1529L1566 1528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M486 1529L487 1530L486 1529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M658 1529L659 1530L658 1529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M870 1529L871 1530L870 1529M1178 1529L1179 1530L1178 1529M1563 1529L1564 1530L1563 1529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M488 1530L489 1531L488 1530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M489 1530L490 1531L489 1530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M657 1530L658 1531L657 1530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M869 1530L870 1531L869 1530M1179 1530L1180 1531L1179 1530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1561 1530L1562 1531L1561 1530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M491 1531L492 1532L491 1531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M656 1531L657 1532L656 1531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M868 1531L869 1532L868 1531M1180 1531L1181 1532L1180 1531M1558 1531L1559 1532L1558 1531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M493 1532L494 1533L493 1532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M494 1532L495 1533L494 1532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M655 1532L656 1533L655 1532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M867 1532L868 1533L867 1532M1181 1532L1182 1533L1181 1532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1555 1532L1556 1533L1555 1532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1556 1532L1557 1533L1556 1532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M496 1533L497 1534L496 1533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M654 1533L655 1534L654 1533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M866 1533L867 1534L866 1533M1182 1533L1183 1534L1182 1533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1553 1533L1554 1534L1553 1533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M499 1534L500 1535L499 1534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M653 1534L654 1535L653 1534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M865 1534L866 1535L865 1534M1183 1534L1184 1535L1183 1534M1550 1534L1551 1535L1550 1534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M501 1535L502 1536L501 1535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M502 1535L503 1536L502 1535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M652 1535L653 1536L652 1535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M864 1535L865 1536L864 1535M1184 1535L1185 1536L1184 1535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1547 1535L1548 1536L1547 1535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1548 1535L1549 1536L1548 1535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M504 1536L505 1537L504 1536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M505 1536L506 1537L505 1536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M651 1536L652 1537L651 1536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M863 1536L864 1537L863 1536M1185 1536L1186 1537L1185 1536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1544 1536L1545 1537L1544 1536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1545 1536L1546 1537L1545 1536M507 1537L508 1538L507 1537M650 1537L651 1538L650 1537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M862 1537L863 1538L862 1537M1186 1537L1187 1538L1186 1537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1542 1537L1543 1538L1542 1537M510 1538L511 1539L510 1538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M649 1538L650 1539L649 1538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M861 1538L862 1539L861 1538M1187 1538L1188 1539L1187 1538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1539 1538L1540 1539L1539 1538M513 1539L514 1540L513 1539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M514 1539L515 1540L514 1539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M648 1539L649 1540L648 1539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M860 1539L861 1540L860 1539M1188 1539L1189 1540L1188 1539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1536 1539L1537 1540L1536 1539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M516 1540L517 1541L516 1540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M517 1540L518 1541L517 1540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M647 1540L648 1541L647 1540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M859 1540L860 1541L859 1540M1189 1540L1190 1541L1189 1540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1532 1540L1533 1541L1532 1540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1533 1540L1534 1541L1533 1540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M519 1541L520 1542L519 1541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M520 1541L521 1542L520 1541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M646 1541L647 1542L646 1541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M858 1541L859 1542L858 1541M1190 1541L1191 1542L1190 1541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1529 1541L1530 1542L1529 1541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1530 1541L1531 1542L1530 1541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M522 1542L523 1543L522 1542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M523 1542L524 1543L523 1542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M645 1542L646 1543L645 1542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M857 1542L858 1543L857 1542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1191 1542L1192 1543L1191 1542M1526 1542L1527 1543L1526 1542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1527 1542L1528 1543L1527 1542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M526 1543L527 1544L526 1543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M527 1543L528 1544L527 1543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M644 1543L645 1544L644 1543M856 1543L857 1544L856 1543M1192 1543L1193 1544L1192 1543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1523 1543L1524 1544L1523 1543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M529 1544L530 1545L529 1544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M530 1544L531 1545L530 1544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M643 1544L644 1545L643 1544M855 1544L856 1545L855 1544M1193 1544L1194 1545L1193 1544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1519 1544L1520 1545L1519 1544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1520 1544L1521 1545L1520 1544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M533 1545L534 1546L533 1545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M534 1545L535 1546L534 1545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M642 1545L643 1546L642 1545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M854 1545L855 1546L854 1545M1194 1545L1195 1546L1194 1545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1515 1545L1516 1546L1515 1545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1516 1545L1517 1546L1516 1545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M536 1546L537 1547L536 1546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M537 1546L538 1547L537 1546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M641 1546L642 1547L641 1546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M853 1546L854 1547L853 1546M1195 1546L1196 1547L1195 1546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1512 1546L1513 1547L1512 1546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1513 1546L1514 1547L1513 1546M540 1547L541 1548L540 1547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M541 1547L542 1548L541 1547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M640 1547L641 1548L640 1547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M852 1547L853 1548L852 1547M1196 1547L1197 1548L1196 1547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1508 1547L1509 1548L1508 1547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1509 1547L1510 1548L1509 1547M544 1548L545 1549L544 1548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M545 1548L546 1549L545 1548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M639 1548L640 1549L639 1548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M851 1548L852 1549L851 1548M1197 1548L1198 1549L1197 1548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1504 1548L1505 1549L1504 1548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1505 1548L1506 1549L1505 1548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M548 1549L549 1550L548 1549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M549 1549L550 1550L549 1549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M550 1549L551 1550L550 1549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M638 1549L639 1550L638 1549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M850 1549L851 1550L850 1549M1198 1549L1199 1550L1198 1549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1499 1549L1500 1550L1499 1549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1500.67 1549.33C1500.22 1549.78 1501.28 1549.72 1501.33 1549.67C1501.78 1549.22 1500.72 1549.28 1500.67 1549.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M553.667 1550.33C553.222 1550.78 554.278 1550.72 554.333 1550.67C554.778 1550.22 553.722 1550.28 553.667 1550.33M637 1550L638 1551L637 1550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M849 1550L850 1551L849 1550M1199 1550L1200 1551L1199 1550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#566e9f",
      stroke: "none"
    },
    d: "M1495 1550L1496 1551L1495 1550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1496.67 1550.33C1496.22 1550.78 1497.28 1550.72 1497.33 1550.67C1497.78 1550.22 1496.72 1550.28 1496.67 1550.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M557.667 1551.33C557.222 1551.78 558.278 1551.72 558.333 1551.67C558.778 1551.22 557.722 1551.28 557.667 1551.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M636 1551L637 1552L636 1551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M848 1551L849 1552L848 1551M1200 1551L1201 1552L1200 1551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1490 1551L1491 1552L1490 1551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1491.67 1551.33C1491.22 1551.78 1492.28 1551.72 1492.33 1551.67C1492.78 1551.22 1491.72 1551.28 1491.67 1551.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M562.667 1552.33C562.222 1552.78 563.278 1552.72 563.333 1552.67C563.778 1552.22 562.722 1552.28 562.667 1552.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M635 1552L636 1553L635 1552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M847 1552L848 1553L847 1552M1201 1552L1202 1553L1201 1552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1485 1552L1486 1553L1485 1552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1486.67 1552.33C1486.22 1552.78 1487.28 1552.72 1487.33 1552.67C1487.78 1552.22 1486.72 1552.28 1486.67 1552.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M567.667 1553.33C567.222 1553.78 568.278 1553.72 568.333 1553.67C568.778 1553.22 567.722 1553.28 567.667 1553.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284685",
      stroke: "none"
    },
    d: "M569.667 1553.33C569.222 1553.78 570.278 1553.72 570.333 1553.67C570.778 1553.22 569.722 1553.28 569.667 1553.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M634 1553L635 1554L634 1553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M846 1553L847 1554L846 1553M1202 1553L1203 1554L1202 1553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1480 1553C1481.25 1553.68 1481.55 1553.75 1483 1554C1481.75 1553.32 1481.45 1553.25 1480 1553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M572.667 1554.33C572.222 1554.78 573.278 1554.72 573.333 1554.67C573.778 1554.22 572.722 1554.28 572.667 1554.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M574.667 1554.33C574.222 1554.78 575.278 1554.72 575.333 1554.67C575.778 1554.22 574.722 1554.28 574.667 1554.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M633 1554L634 1555L633 1554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M845 1554L846 1555L845 1554M1203 1554L1204 1555L1203 1554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1474 1554C1475.25 1554.68 1475.55 1554.75 1477 1555C1475.75 1554.32 1475.45 1554.25 1474 1554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1477 1554L1478 1555L1477 1554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M578 1555C579.248 1555.68 579.549 1555.75 581 1556C579.752 1555.32 579.452 1555.25 578 1555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284685",
      stroke: "none"
    },
    d: "M581.667 1555.33C581.222 1555.78 582.278 1555.72 582.333 1555.67C582.778 1555.22 581.722 1555.28 581.667 1555.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M632 1555L633 1556L632 1555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M844 1555L845 1556L844 1555M1204 1555L1205 1556L1204 1555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1468 1555L1469 1556L1468 1555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M1469.67 1555.33C1469.22 1555.78 1470.28 1555.72 1470.33 1555.67C1470.78 1555.22 1469.72 1555.28 1469.67 1555.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M584.667 1556.33C584.222 1556.78 585.278 1556.72 585.333 1556.67C585.778 1556.22 584.722 1556.28 584.667 1556.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M586.667 1556.33C586.222 1556.78 587.278 1556.72 587.333 1556.67C587.778 1556.22 586.722 1556.28 586.667 1556.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#284685",
      stroke: "none"
    },
    d: "M588.667 1556.33C588.222 1556.78 589.278 1556.72 589.333 1556.67C589.778 1556.22 588.722 1556.28 588.667 1556.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M631 1556L632 1557L631 1556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M843 1556L844 1557L843 1556M1205 1556L1206 1557L1205 1556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7588b1",
      stroke: "none"
    },
    d: "M1461 1556C1462.25 1556.68 1462.55 1556.75 1464 1557C1462.75 1556.32 1462.45 1556.25 1461 1556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d7e5",
      stroke: "none"
    },
    d: "M1464.67 1556.33C1464.22 1556.78 1465.28 1556.72 1465.33 1556.67C1465.78 1556.22 1464.72 1556.28 1464.67 1556.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M592 1557C593.248 1557.68 593.549 1557.75 595 1558C593.752 1557.32 593.452 1557.25 592 1557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M595.667 1557.33C595.222 1557.78 596.278 1557.72 596.333 1557.67C596.778 1557.22 595.722 1557.28 595.667 1557.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M630 1557L631 1558L630 1557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M842 1557L843 1558L842 1557M1206 1557L1207 1558L1206 1557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1453.67 1557.33C1453.22 1557.78 1454.28 1557.72 1454.33 1557.67C1454.78 1557.22 1453.72 1557.28 1453.67 1557.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M1455 1557C1456.25 1557.68 1456.55 1557.75 1458 1558C1456.75 1557.32 1456.45 1557.25 1455 1557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M600.667 1558.33C600.222 1558.78 601.278 1558.72 601.333 1558.67C601.778 1558.22 600.722 1558.28 600.667 1558.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M602.667 1558.33C602.222 1558.78 603.278 1558.72 603.333 1558.67C603.778 1558.22 602.722 1558.28 602.667 1558.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M604 1558C605.248 1558.68 605.549 1558.75 607 1559C605.752 1558.32 605.452 1558.25 604 1558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M629 1558L630 1559L629 1558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M841 1558L842 1559L841 1558M1207 1558L1208 1559L1207 1558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1443 1558C1444.25 1558.68 1444.55 1558.75 1446 1559C1444.75 1558.32 1444.45 1558.25 1443 1558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1446.67 1558.33C1446.22 1558.78 1447.28 1558.72 1447.33 1558.67C1447.78 1558.22 1446.72 1558.28 1446.67 1558.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1448.67 1558.33C1448.22 1558.78 1449.28 1558.72 1449.33 1558.67C1449.78 1558.22 1448.72 1558.28 1448.67 1558.33M610 1559C611.248 1559.68 611.548 1559.75 613 1560C611.752 1559.32 611.452 1559.25 610 1559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M613 1559C614.248 1559.68 614.548 1559.75 616 1560C614.752 1559.32 614.452 1559.25 613 1559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M616 1559C617.248 1559.68 617.548 1559.75 619 1560C617.752 1559.32 617.452 1559.25 616 1559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M628 1559L629 1560L628 1559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M840 1559L841 1560L840 1559M1208 1559L1209 1560L1208 1559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#476197",
      stroke: "none"
    },
    d: "M1430 1559C1431.51 1559.68 1432.31 1559.83 1434 1560C1432.49 1559.32 1431.69 1559.17 1430 1559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1434 1559C1435.25 1559.68 1435.55 1559.75 1437 1560C1435.75 1559.32 1435.45 1559.25 1434 1559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1437 1559C1438.25 1559.68 1438.55 1559.75 1440 1560C1438.75 1559.32 1438.45 1559.25 1437 1559M624 1560C625.506 1560.68 626.315 1560.83 628 1561C626.494 1560.32 625.685 1560.17 624 1560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M839 1560L840 1561L839 1560M1209 1560L1210 1561L1209 1560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8496ba",
      stroke: "none"
    },
    d: "M1417 1560C1418.51 1560.68 1419.31 1560.83 1421 1561C1419.49 1560.32 1418.69 1560.17 1417 1560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1421 1560C1422.77 1560.78 1424.04 1560.91 1426 1561C1424.23 1560.22 1422.96 1560.09 1421 1560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M838 1561L839 1562L838 1561M1210 1561L1211 1562L1210 1561M837 1562L838 1563L837 1562M1211 1562L1212 1563L1211 1562M836 1563L837 1564L836 1563M1212 1563L1213 1564L1212 1563M1213 1564L1214 1565L1213 1564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M1214 1565L1215 1566L1214 1565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M822 1578L823 1579L822 1578M1226 1578L1227 1579L1226 1578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M821 1581L821 1584C821.696 1582.45 821.696 1582.55 821 1581M1227 1581L1227 1584C1227.7 1582.45 1227.7 1582.55 1227 1581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93a3c2",
      stroke: "none"
    },
    d: "M822 1586L823 1587L822 1586M1226 1586L1227 1587L1226 1586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2cadc",
      stroke: "none"
    },
    d: "M823 1588L824 1589L823 1588M1225 1588L1226 1589L1225 1588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3b0cb",
      stroke: "none"
    },
    d: "M824 1589L825 1590L824 1589M1224 1589L1225 1590L1224 1589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M827 1591L828 1592L827 1591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37548e",
      stroke: "none"
    },
    d: "M828.667 1591.33C828.223 1591.78 829.278 1591.72 829.333 1591.67C829.778 1591.22 828.722 1591.28 828.667 1591.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657ba8",
      stroke: "none"
    },
    d: "M1219.67 1591.33C1219.22 1591.78 1220.28 1591.72 1220.33 1591.67C1220.78 1591.22 1219.72 1591.28 1219.67 1591.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bdd4",
      stroke: "none"
    },
    d: "M1221 1591L1222 1592L1221 1591z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInmersial);
export default __webpack_public_path__ + "static/media/inmersial.9c10b97b70cd6d1d0d28b6ceb204020b.svg";
export { ForwardRef as ReactComponent };